export default {
  locale: 'ko',
  messages: {
	accountMy: '내 계정',
	actions: '작업',
	add: '추가',
	addressAddNew: '새 주소 추가',
	addressCity: '도시',
	addressCountries: '국가',
	addressCountry: '국가',
	addressDeleteConfirmTitle: '주소 삭제',
	addressDeleteConfirmMessage: '이 주소를 삭제하시겠습니까?',
	addressDeleteSuccess: '주소가 삭제되었습니다!',
	addressEdit: '주소 수정',
	addressFlags: '플래그',
	addressInvoice: '청구지 주소',
	addressInvoiceDifferentAsShippingLabel: '청구 정보가 배송 주소와 동일한가요?',
	addressInvoiceSelectionTitle: '청구지 주소를 선택해 주세요',
	addressInvoiceUsedFor: '청구서에 사용 중',
	addressInvoiceUse: '청구서에 사용',
	addressLabel: '주소 별칭(예: 집)',
	addressLegalInformation: '법적 정보',
	addressMy: '내 주소록',
	addressName: '받는 분 성함',
	addressNoItems: '아직 저장된 주소가 없습니다!',
	addressPhone: '전화번호(배송 시 연락용)',
	addressPostalCode: '우편번호',
	addressRegion: '주 / 지역',
	addressShipping: '배송 주소',
	addressShippingSelectionTitle: '배송 주소를 선택해 주세요',
	addressStreet1: '주소',
	addressStreetNumberHint: '건물 번호를 잊지 마세요. 번호가 없으면 배송업체가 주소를 찾지 못하는 경우가 많습니다.',
	addressPostalCodeInvalid: '이 우편번호는 선택한 국가와 일치하지 않습니다.',
	addressPhoneInvalid: '전화번호가 올바르지 않은 것 같습니다. 배송업체가 연락에 사용합니다.',
	addressPhoneMobileHint: '휴대전화 번호를 권장합니다. 배송업체가 SMS로 배송 안내를 보냅니다.',
	addressIssueTitle: '배송 전에 이 주소를 완성해야 합니다',
	addressIssueIncomplete: '필수 항목이 누락되었습니다.',
	addressIssuePostalCode: '선택한 국가의 우편번호를 확인해 주세요.',
	addressIssuePhone: '연락 가능한 전화번호가 필요합니다. 배송업체가 전화하거나 배송 안내를 보냅니다.',
	addressIssueRegion: '배송업체가 요구하는 주 또는 도를 선택해 주세요.',
	addressIssueTaxId: '이 배송지는 세관에서 납세자 번호를 요구합니다.',
	addressCustomsHint: '소포 통관에 필요합니다.',
	addressTaxIdRfc: '멕시코 납세자 번호(RFC)',
	addressTaxIdCpf: '브라질 납세자 번호(CPF)',
	addressTaxIdRut: '칠레 납세자 번호(RUT)',
	addressTaxIdPccc: '개인 통관 코드(PCCC)',
	addressTaxIdCuil: '아르헨티나 납세자 번호(CUIL)',
	addressTaxIdNationalId: '국가 신분증 번호',
	addressTaxIdNorwayNid: '노르웨이 신분증 번호(11자리)',
	addressIssueComplete: '이 주소 완성하기',
	addressStreet2: '상세 주소(동/호수, 공동현관 비밀번호 등)',
	administrationTitle: '관리자',
	affiliationComment: '메모',
	affiliationCommission: '수수료',
	affiliationCommissionMultiplePendingAlert: '이 목록은 예상치입니다. 주문 및 수수료는 아직 확정되지 않았습니다!',
	affiliationCommissionPendingAlert: '이 주문은 승인 대기 중입니다',
	affiliationDeleteConfirmMessage: '이 제휴를 삭제하시겠습니까?',
	affiliationInvoiceTotalTitle: '수령할 총액(부가세 포함)',
	affiliationKey: '제휴 키',
	affiliationLegalApplyVAT: '부가세 적용',
	affiliationLegalInformations: '법적 정보(청구 정보, 사업자등록번호 등)',
	affiliationMy: '내 제휴',
	affiliationOptionValidityDays: '제휴 링크 유효 기간(일)',
	affiliationSince: '가입일',
	affiliationViewResultsMy: '제휴 수익 보기',
	affiliations: '제휴',
	alertContactError: '메시지를 보낼 수 없습니다! 다시 시도해 주세요...',
	alertContactSuccess: '잘 받았습니다!',
	alertConversationNoExists: '이 대화는 존재하지 않습니다!',
	alertFetchApiError: '현재 서버를 이용할 수 없습니다...',
	alertFormRequiredFieldsError: '필수 항목을 모두 입력해 주세요!',
	alertGenericError: '오류가 발생했습니다! 잠시 후 다시 시도해 주세요...',
	alertInstitutionAlreadyExists: '이 기관은 이미 등록되어 있습니다!',
	alertJsonParseError: '서버가 잘못된 응답을 반환했습니다...',
	alertOrderValid: '주문이 제작 준비 상태가 되었습니다!',
	alertUnauthorized: '세션이 만료되었습니다! 다시 로그인해 주세요',
	alertUserAlreadyExists: '이 이메일 주소로 이미 가입된 계정이 있습니다!',
	alertUserRegisterSuccess: '환영합니다!',
	app404ErrorText: '요청하신 페이지를 찾을 수 없습니다! 홈으로 돌아가거나 내 계정으로 이동해 주세요',
	app404ErrorTitle: '길을 잘못 드셨네요...',
	appAccessButton: '{app} 바로가기',
	appAgreementAcceptButton: '이용약관 읽기',
	appAgreementAcceptHelp: '이 링크를 클릭하시면 이용약관을 읽어보실 수 있어요',
	appAgreementAcceptClickHint: '여기를 클릭해 동의에 체크해 주세요',
	appAgreementAcceptLabel: '이용약관을 읽었으며 이에 동의합니다',
	appApplication: '애플리케이션',
	appBackHomeButton: '홈으로 돌아가기',
	appBackHomeTitle: '잘못된 경로입니다...',
	appBugErrorText: '문제가 발생했습니다... 죄송합니다! 아래 링크를 클릭해 이 페이지를 새로고침해 주세요...',
	appConditionsAcceptTitle: '이용약관',
	appConditionsCheckError: '이용약관 동의 항목에 체크해 주세요!',
	appConditionsCheckLabel: '이용약관을 읽었으며 이에 동의합니다',
	appConditionsCheckSuccess: '잘 받았습니다!',
	appConditionsUpdateDate: '최종 업데이트: {date}',
	appConfig: '설정',
	appConfiguration: '환경 설정',
	appCookieConsentPrivacyLink: '개인정보 처리방침 보기',
	appCookieConsentText: '이 사이트를 계속 이용하시면 서비스의 원활한 운영과 통계 목적의 쿠키 사용에 동의하시는 것으로 간주됩니다. 사전 동의 없이 개인정보가 제공되는 일은 없습니다.',
	appCreateIndexButton: '데이터베이스 인덱스 생성',
	appDataPrivacyCheckButton: '개인정보 처리방침 읽어보기',
	appDatabase: '데이터베이스',
	appErrorAlertText: '예기치 않은 문제가 발생했습니다... 걱정하지 마세요! 문의해 주시면 최대한 빠르게 해결해 드리겠습니다!',
	appErrorAlertTitle: '오류가 발생했습니다!',
	appForceUpdateApp: '애플리케이션 강제 업데이트',
	appForceUpdateAppWeb: '웹 애플리케이션 강제 업데이트',
	appHome: '홈',
	appMaintenanceModeText: '잠시만 기다려 주신 후 다시 방문해 주세요...',
	appMaintenanceModeTitle: '현재 점검 중입니다',
	appProcessLaunch: '프로세스 실행',
	appQuestionLink: '궁금한 점이 있으신가요?',
	appRewiewsHeaderText: '프랑스에서 🇫🇷 사랑을 담아 ❤️ 제작 - 4.6 ⭐️ ⭐️ ⭐️ ⭐️ ⭐️ Trustpilot 리뷰 500개 이상',
	appShopOrderHistory: '주문 조회',
	appStart: '나만의 책 만들기',
	appVersion: '버전',
	appVersionCurrent: '현재 애플리케이션 버전: {version}',
	appWebsiteAboutUs: '우리 이야기',
	appWebsiteBlog: '블로그',
	appWebsiteBook: '책 소개',
	appWebsiteConversationAndroid: 'Android 문자메시지 인쇄하기',
	appWebsiteConversationInstagram: 'Instagram 메시지 인쇄하기',
	appWebsiteConversationIos: 'iPhone iMessage/문자메시지 인쇄하기',
	appWebsiteConversationMessenger: 'Messenger 메시지 인쇄하기',
	appWebsiteConversationWhatsapp: 'WhatsApp 메시지 인쇄하기',
	appWebsiteConversations: '메신저 선택',
	appWebsiteFaq: '자주 묻는 질문',
	appFooterQuestion: '질문이 있으신가요?',
	appFooterTerms: '이용약관',
	appWebsitePrices: '가격',
	appWelcomeTitle: '{name}에 오신 것을 환영합니다',
	autocompleteSearch: '검색어를 입력하세요…',
	apply: '적용',
	back: '뒤로',
	by: '작성자',
	cancel: '취소',
	cartAddTo: '장바구니에 담기',
	cartAuthInfo: '계속하시려면 이메일 주소를 입력해 주세요...',
	cartContinuePurchase: '쇼핑 계속하기',
	cartEmptyError: '장바구니가 비어 있습니다...',
	cartItemsRemoveAll: '전체 삭제',
	cartMy: '내 장바구니',
	cartMyEdit: '장바구니 수정',
	cartNextStepButton: '다음 단계로',
	cartNoItems: '장바구니에 담긴 상품이 없습니다.',
	cartNote: '요청사항',
	cartProgression: '장바구니 진행 상황',
	cartSalesConditionsAccept: '주문을 확정하시면 판매 약관에 동의하시는 것으로 간주됩니다.',
	cartSee: '장바구니 보기',
	cartShipping: '배송',
	cartShippingFeeError: '이 주소로는 배송할 수 없습니다! 다른 주소를 입력해 주세요!',
	cartStepConfirmationTitle: '주문 확인',
	cartStepInvoiceTitle: '청구 정보',
	cartStepPaymentTitle: '결제',
	cartStepPreviewTitle: '장바구니',
	cartStepShippingTitle: '배송',
	cartTotalShipping: '배송비',
	cartTotalSubTotal: '소계',
	cartTotalTax: '부가세',
	cartTotalTotal: '합계',
	cartValidButton: '주문 확정하기',
	checkoutEyebrow: '고객님의 주문',
	checkoutStepUpsellTitle: '한 권만, 아니면 두 권?',
	checkoutStepUpsellTitleGroup: '한 권, 두 권, 아니면 더 많이?',
	checkoutStepUpsellHint: '직접 소장하셔도, 소중한 분께 선물하셔도, 둘 다 하셔도 좋아요.',
	checkoutStepUpsellHintGroup: '각자 한 권씩: 두 번째 책부터 할인해 드려요.',
	checkoutStepShippingTitle: '책을 어디로 보내 드릴까요?',
	checkoutStepShippingHint: '정성껏 인쇄해서 전 세계 어디로든 보내 드려요.',
	checkoutStepInvoiceTitle: '고객님의 정보',
	checkoutStepInvoiceHint: '청구서 발행과 주문 조회에 사용돼요.',
	checkoutStepPaymentTitle: '안전하게 결제하기',
	checkoutStepPaymentHint: '신용카드, Apple Pay, Google Pay: 암호화 결제.',
	checkoutPdfReadyTitle: '전자책이 준비되었어요',
	checkoutPdfReadyHint: '배송이 필요 없어요. 주문만 완료해 주세요.',
	checkoutSummaryEyebrow: '주문 요약',
	cartReassuranceSecure: '안전한 결제',
	cartReassuranceReturn: '환불 보장',
	cartReassuranceSupport: '고객 지원',
	checkoutPromoEyebrow: '할인 코드',
	checkoutGiftEyebrow: '기프트 카드',
	checkoutGiftCodeLabel: '기프트 코드',
	checkoutGiftCodePlaceholder: '기프트 코드를 입력하세요',
	checkoutGiftCodeHint: '기프트 카드를 받으셨나요? 여기에 코드를 입력해 주세요.',
	checkoutGiftToggle: '기프트 카드가 있으신가요?',
	checkoutAddCopy: '한 권 더 담기',
	checkoutSecondCopyKicker: '소장용으로, 선물용으로',
	checkoutSecondCopyKickerGroup: '한 사람당 한 권',
	checkoutSecondCopyTitle: '추가 책은 반값',
	checkoutSecondCopyTitlePercent: '추가 책',
	checkoutSecondCopyFor: '이 책',
	checkoutSecondCopyForGroup: '2권째',
	checkoutSecondCopyChip: '두 번째는 반값',
	checkoutSecondCopyChipPercent: '두 번째는 {percent}% 할인',
	checkoutSecondCopySet: '{count}권 전체, 한 세트로',
	checkoutSecondCopyPerBook: '한 권',
	checkoutSecondCopySetPrice: '{count}권 {price}',
	checkoutExtraBooksChip: '추가 책은 반값',
	checkoutExtraBooksChipPercent: '추가 책은 −{percent}%',
	checkoutGroupQtyHint: '세 번째도, 추가 책은 모두 −{percent}%예요.',
	productExtraCopyRate: '추가 책, 한 권 가격의 %',
	productExtraCopyRateHelp: '첫 권을 넘는 각 책은 한 권 가격의 이 비율입니다. 비움: 50%. 0: 수량 할인.',
	checkoutGroupPicksLabel: '권수',
	checkoutGroupAddSecond: '2권',
	checkoutGroupAddThird: '3',
	checkoutGroupAddSecondAria: '두 번째 책을 반값에 담기',
	checkoutGroupAddThirdAria: '3권으로 바꾸기',
	checkoutQtyGroupHint: '한 사람당 한 권, 두 번째부터 할인이 적용돼요.',
	checkoutQtyPdfSingle: '전자책 1권',
	checkoutQtyMoreAriaLabel: '다른 수량',
	checkoutQtyVolumeBreakdown: '{copies}부 × {volumes}권 = 책 {total}권',
	checkoutOfferBookCount: '{count}권',
	checkoutUpsellTwoHint: '선물용으로 좋아요: 두 번째 책을 추가하시면 할인이 자동으로 적용돼요.',
	checkoutEmptyTitle: '진행 중인 주문이 없습니다',
	checkoutEmptyHint: '책 화면으로 돌아가 원하시는 구성을 선택해 주세요.',
	checkoutEmptyCta: '내 대화 보기',
	checkoutBookAsideEyebrow: '고객님의 책',
	checkoutBookAsideEyebrowPlural: '주문하신 책',
	checkoutBookAsideVolume: '권',
	checkoutBookAsideVolumes: '권',
	checkoutBookAsideShelfLabel: '주문하신 {count}권',
	checkoutBookAsideEbook: '전자책',
	checkoutBookAsidePaper: '종이책',
	checkToggler: '전체 선택/해제',
	choose: '선택',
	close: '닫기',
	code: '코드',
	cmsDeleteConfirmTitle: '콘텐츠 삭제',
	cmsDeleteConfirmMessage: '이 콘텐츠를 삭제하시겠습니까?',
	cms: 'CMS',
	cmsAdminListHint: '페이지, 패널, 번역을 수정합니다. 국기 아이콘은 언어별 번역 상태를 나타냅니다.',
	cmsPageAdd: '페이지 추가',
	cmsContentDuplicateSuccess: 'CMS 콘텐츠를 복제했습니다!',
	companyShippingEdit: '배송 수단 수정',
	conditions: '약관',
	configMissingKeyAlert: '설정 키 속성이 없습니다!',
	configAdminHint: '애플리케이션 설정, 제휴, 백그라운드 프로세스, 원본 설정 키를 관리합니다.',
	configuration: '환경 설정',
	confirm: '확인',
	confirmMessage: '작업을 확인해 주십시오.',
	confirmTitle: '정말 진행하시겠습니까?',
	contactButton: '문의하기',
	contactMessage: '메시지',
	contactPageButton: '보내기',
	contactPageText1: '도움이 필요하신가요? 궁금한 점이 있으신가요? 언제든지 도와드릴게요!',
	contactPageTitle: '문의하기',
	contactSend: '보내기',
	continue: '계속하기',
	console: '콘솔',
	country: '국가',
	conversationActionContinue: '계속하기',
	conversationActionRestart: '다시 시작하기',
	conversationAddTitle: '대화 추가',
	conversationAdminDeleteConfirmTitle: '대화 삭제',
	conversationAdminDeleteConfirmMessage: '이 대화와 모든 미디어가 영구적으로 삭제됩니다. 이 작업은 되돌릴 수 없습니다.',
	conversationAdminListHint: '모든 고객 대화를 조회하고 필터링하고 관리합니다. 상태 탭으로 원하는 진행 단계를 선택하십시오.',
	conversationArchiveError: '아카이브 파일을 읽을 수 없습니다! 문제 해결을 위해 문의해 주십시오...',
	conversationBookOrderTypeBook: '종이책 + 전자책 무료 제공',
	conversationBookOrderTypePdf: '전자책만',
	conversationBookPreview: '미리보기',
	conversationBookPreviewSelected: '{number}권 미리보기',
	conversationBookSelector: '수정할 책을 선택하세요',
	conversationBookTypeLabelBook: '종이책 + 전자책',
	conversationBookTypeLabelPdf: '전자책만',
	conversationBooks: '책',
	conversationCollectorArchiveSelectButton: '아카이브 업로드',
	conversationCollectorInitWaiting: '데이터를 준비하는 중입니다... 잠시만 기다려 주세요',
	conversationCollectorUseArchive: '데이터 백업(아카이브) 업로드',
	conversationCoverBookEdit: '표지 꾸미기',
	conversationCoverBookReset: '이 책의 표지 초기화',
	conversationCoverApplyToAllBooks: '이 표지를 모든 권에 적용',
	conversationCoverAutoAppliedToAllBooks: '다른 권에도 표지를 적용했습니다.',
	conversationCoverApplyToAllBooksTitle: '이 표지를 모든 권에 적용할까요?',
	conversationCoverApplyToAllBooksMessage: '다른 모든 권에 적용할 항목을 선택하세요.',
	conversationCoverApplyOptionColor: '색상',
	conversationCoverApplyOptionPhoto: '사진',
	conversationCoverApplyOptionTitle: '제목',
	conversationCoverApplyOptionSubtitle: '부제',
	conversationCoverBookSwitchAlertMessage: '이 책의 표지 정보만 저장됩니다.',
	conversationCoverBookSwitchAlertTitle: '이 책의 표지를 저장할까요?',
	conversationCoverColorEditTitle: '표지 선택',
	conversationCoverLuxEyebrow: '고객님의 표지',
	conversationCoverLuxHint: '디자인과 색을 고른 뒤 표지를 다듬어 보세요.',
	conversationCoverResumeLuxEyebrow: '머리말',
	conversationCoverResumeLuxHint: '선택 사항: 이 글은 표지 안쪽에 인쇄됩니다.',
	conversationCoverBookNumber: '{number}권',
	conversationCreationDate: '생성일',
	conversationCustomImportUpload: '생성된 파일 가져오기',
	conversationCoverFooterPrefaceGuide: '머리말 없이 진행하시려면 미리보기로 돌아가시고, 작성하시려면 계속 진행해 주세요(선택 사항이며 표지 안쪽에 인쇄됩니다).',
	conversationCoverFooterNextPreface: '머리말(선택 사항)',
	conversationCoverFooterSkipPreface: '머리말 건너뛰기 · 미리보기로',
	conversationCoverFooterBackToCover: '표지로 돌아가기',
	conversationCoverFooterFinishPreview: '완료 · 미리보기로',
	conversationCoverFooterGoPreview: '미리보기로 돌아가기',
	conversationCoverEditionTypeTitle: '책 구성 유형',
	conversationCoverEditionTypeBookHelp: '전집으로 만들면 각 권의 표지를 따로 꾸밀 수 있어요.',
	conversationCoverColorSelectorHelp: '표지 색상을 선택하세요',
	conversationCoverStyleSelectorHelp: '표지 디자인을 선택해 주세요',
	conversationCoverStylePhoto: '폴라로이드',
	conversationCoverStyleIncipit: '첫 메시지',
	conversationCoverPickMessageTitle: '메시지 고르기',
	conversationCoverEditQuote: '문장 고치기',
	conversationCoverPickMessageHint: '고른 문장이 표지에 크게 실립니다.',
	conversationCoverPickMessageSearch: '메시지 찾기',
	conversationCoverPickMessageEmpty: '해당하는 메시지가 없습니다.',
	conversationCoverAddQuote: '문장 추가',
	conversationCoverHourLabel: '시간',
	conversationCoverDateLabel: '날짜',
	conversationCoverGroupNameLabel: '그룹 이름',
	conversationCoverSpanLabel: '첫 메시지와 마지막 메시지의 날짜',
	conversationCoverApplyOptionStyle: '디자인',
	conversationCoverApplyOptionQuote: '문장',
	conversationCoverDragNDropFiles: '이미지를 여기로 끌어다 놓으세요',
	conversationCoverTapToSelectPhoto: '눌러서 사진을 선택하세요',
	conversationCoverOpenFinder: '이미지 선택',
	conversationCoverPhotoSelectorTitle: '사진 선택',
	conversationCoverPhotoEditHint: '클릭하면 사진을 변경할 수 있어요',
	conversationCoverPhotoChoose: '클릭해서 사진을 고르세요',
	conversationPreviewSwipeHint: '밀어서 페이지를 넘겨 보세요',
	conversationPreviewOpenBookHint: '표지를 밀어서 책을 열어 보세요',
	conversationPreviewDiscoverBook: '내 책 살펴보기',
	conversationPreviewVolumesLabel: '나의 컬렉션: 총 {count}권',
	conversationPreviewVolumesHint: '표지를 누르면 해당 권이 열려요.',
	conversationCoverResumeEditTitle: '머리말 작성(선택 사항)',
	conversationCoverResumeError: '머리말이 한 페이지에 담기지 않습니다. 내용을 줄이거나 줄바꿈을 줄여 주세요.',
	conversationCoverResumeNearLimit: '한 페이지 한도에 가까워지고 있어요({lines}/{max}줄).',
	conversationCoverResumeHelp: '이 머리말은 표지 안쪽에 인쇄됩니다.',
	conversationCoverResumePlaceholder: '책에 담을 머리말을 작성해 주세요',
	conversationCoverResumeReset: '이 책의 머리말 초기화',
	conversationCoverTitleError: '제목이 너무 깁니다(최대 {max}자)',
	conversationCoverTitleHelp: '클릭하면 책 제목을 수정할 수 있어요',
	conversationCoverTitlePlaceholder: '제목을 입력하세요...',
	conversationCoverDefaultTitleTwoNames: '{name1} & {name2}',
	conversationCoverDefaultTitleGroup: '우리 그룹',
	conversationCoverDefaultTitleSingle: '나의 메시지',
	conversationCoverWaitingForCustomization: '다음 단계에서 표지를 꾸미실 수 있어요...',
	conversationCreateInfoText: '여기 아이콘을 눌러 메시지로 새 책을 만들어 보세요',
	conversationCreateMyBookTitle: '내 책 만들기',
	conversationCreateTitle: '책 만들기',
	conversationDateCreation: '생성일',
	conversationDateDownloadedInfo: '{downloaded}에 책을 다운로드했습니다',
	conversationDateEnd: '대화 종료일',
	conversationDateEndInfo: '책은 {end}에 끝납니다',
	conversationDateEndLabel: '종료일 선택',
	conversationDateEndMessageSelection: '여기서 책 끝내기',
	conversationDateGeneratedInfo: '{generated}에 책이 생성되었습니다',
	conversationDateRange: '{start} ~ {end}',
	conversationDeleteConfirmation: '대화를 삭제했습니다!',
	conversationDateSelectionAlert: '전송 중에 대화가 손상된 것 같습니다. 전송하는 동안 페이지를 벗어나지 마시고, 인터넷 연결이 안정적인 상태에서 다시 시도해 주십시오.',
	conversationDateSimulatedInfo: '{simulated}에 책을 확인했습니다',
	conversationDateStart: '대화 시작일',
	conversationDateStartInfo: '책은 {start}에 시작합니다',
	conversationDateStartLabel: '시작일 선택',
	conversationDateStartMessageSelection: '여기서 책 시작하기',
	conversationDatesLuxEyebrow: '고객님의 이야기',
	conversationDatesLuxHint: '책의 시작일과 종료일을 선택하세요. 메시지를 클릭하면 더 세밀하게 조정할 수 있어요.',
	conversationDatesLuxNextEnd: '종료일',
	conversationDatesLuxBackStart: '시작일',
	conversationDatesLuxSavePreview: '저장 · 미리보기로',
	conversationDatesPresetsLabel: '기간 빠른 선택',
	conversationDatesPreset_all: '전체 대화',
	conversationDatesPreset_year: '최근 1년',
	conversationDatesPreset_sixMonths: '최근 6개월',
	conversationDatesSelectionCount: '메시지 {count, number}{count, plural, one {건} other {건}}',
	conversationDatesSelectionPeriod: '{start} ~ {end}',
	conversationDatesStoryDuration: '선택한 기간: {duration}',
	conversationDatesStartCaption: '고객님의 맨 처음 메시지',
	conversationDatesEndCaption: '고객님의 맨 마지막 메시지',
	conversationDatesBookMessages: '선택한 범위에 메시지 {messages, number}건, 사진 {photos, number}장, 미디어 {medias, number}개',
	conversationDateSelectionEmpty: '이 기간에는 메시지가 없습니다. 선택 범위를 넓혀 보세요.',
	conversationDatesEditTitle: '날짜 선택',
	conversationDemoAlert: '책의 첫 페이지들을 미리 보실 수 있어요.<br></br>주문하시면 인쇄 전에 확인하실 수 있도록 전체 버전을 보내 드려요.',
	conversationDemoEndAlert: '구매를 확정하시면 나머지 메시지도 모두 보실 수 있어요.',
	conversationPreviewEndTitle: '다음 이야기가 기다리고 있어요',
	conversationPreviewEndBody: '나머지 메시지는 고객님을 위해 남겨 두었어요. 지금 주문하시면 책의 전체 버전을 보실 수 있어요.',
	conversationPreviewEndCta: '지금 주문하기',
	conversationPreviewEndBodyPaused: '수정 내용을 확정해 주세요. 디지털판을 바로 이메일로 보내 드리니, 내용을 확인해 주세요.',
	conversationPreviewEndCtaPaused: '수정 내용 확정하기',
	conversationPreviewPrefaceOptionalBadge: '선택 사항',
	conversationPreviewPrefaceEmptyTitle: '원하시면 머리말도 넣어 보세요',
	conversationPreviewPrefaceEmptyText: '책을 여는 짧은 글이에요. 넣지 않으셔도 괜찮아요.',
	conversationPreviewPrefaceEmptyButton: '머리말 추가',
	conversationPreviewPrefaceEditButton: '머리말 수정',
	conversationPreviewCoverEditButton: '표지 수정',
	conversationPreviewCoverOpenLabel: '책 열기',
	conversationDisclaimerSubtitle: '형식을 선택하시면 나만의 편집 공간으로 이동해요.',
	conversationDisclaimerTitle: '메시지 {count}{count, plural,\n		=0 {건}\n		=1 {건}\n		other {건}\n	}: 읽어 볼 가치가 있는 이야기',
	conversationDisclaimerSavings: '{value} 절약',
	conversationDisclaimerEBookIncluded: '전자책 포함',
	conversationDisclaimerGenerating: '책을 만들고 있어요...',
	conversationDisclaimerPlanSingleTitle: '1권',
	conversationDisclaimerPlanSingleDescription: '기본 구성',
	conversationDisclaimerPlanSingleButtonText: '내 책 만들기',
	conversationDisclaimerPlanSingleFeaturePages: '원하시는 책 1권(400페이지) 배송',
	conversationDisclaimerPlanSingleFeatureQuality: '',
	conversationDisclaimerPlanSingleFeatureEvolutive: '확장 가능: 다음 권은 나중에 추가',
	conversationDisclaimerPlanSingleFeaturePremiumPaper: '프리미엄 용지',
	conversationDisclaimerPlanSingleFeaturePremiumPrint: '프리미엄 용지 인쇄',
	conversationDisclaimerPlanSingleFeaturePdfIncluded: 'PDF 버전 포함({price} 상당)',
	conversationDisclaimerPlanSingleFeatureWorkshop: '전체 맞춤 편집 무료 제공',
	conversationDisclaimerPlanSingleFeatureMedia: '사진, 동영상, 음성 포함',
	conversationDisclaimerPlanCollectionTitle: '전권 컬렉션',
	conversationDisclaimerPlanCollectionDescription: '전집',
	conversationDisclaimerPlanCollectionButtonText: '우리 이야기 전부 간직하기',
	conversationDisclaimerPlanCollectionBadge: '패키지 할인 -{percentage}%',
	conversationDisclaimerPlanCollectionFeatureBox: '책 {count}권 인쇄 및 배송',
	conversationDisclaimerPlanCollectionFeatureDiscount: '컬렉션 가격 -{percentage}% (-{amount} 할인 포함)',
	conversationDisclaimerPlanCollectionFeatureDigital: '전자책 무료 제공',
	conversationDisclaimerPlanCollectionFeatureWorkshop: '전체 맞춤 편집 무료 제공',
	conversationDisclaimerPlanCollectionFeatureMedia: '사진, 동영상, 음성 포함',
	conversationDisclaimerPlanEbookTitle: '전자책',
	conversationDisclaimerPlanEbookDescription: '디지털',
	conversationDisclaimerPlanEbookButtonText: 'PDF로 저장',
	conversationDisclaimerPlanEbookFeaturePdf: '고화질 PDF 즉시 제공',
	conversationDisclaimerPlanEbookFeatureShare: '간편한 공유',
	conversationDisclaimerPlanEbookFeatureMessages: '메시지 {count}건 전체 수록',
	conversationDisclaimerPlanEbookFeatureMedia: '사진, 동영상, 음성 포함',
	conversationDisclaimerReassuranceGuaranteeTitle: '만족 보장 환불제',
	conversationDisclaimerReassuranceGuaranteeDescription: '최종 확정 전까지 요청만 하시면 환불해 드립니다.',
	conversationDisclaimerReassuranceCustomTitle: '자유로운 맞춤 편집',
	conversationDisclaimerReassuranceCustomDescription: '결제 후에도 표지와 메시지를 수정할 수 있습니다',
	conversationDisclaimerReassuranceSecureTitle: '100% 안전한 결제',
	conversationDisclaimerReassuranceSecureDescription: '신용카드, Apple Pay, Google Pay, Link',
	conversationDisclaimerReassuranceDeliveryTitle: '빠른 배송',
	conversationDisclaimerReassuranceDeliveryDescription: '영업일 기준 5일 이내 배송',
	conversationDisclaimerReviewSuffix: '인쇄된 책 +{count}권 기준',
	conversationDowloadUnableAlert: '대화로 만든 책은 더 이상 다운로드하실 수 없습니다... 문제 해결을 위해 저희에게 문의해 주세요.',
	conversationDownloadBackPreview: '책 미리보기로 돌아가기',
	conversationDownloadDeadlineInfo: '{date}까지 파일을 다운로드할 수 있어요',
	conversationDownloadEyebrow: '책이 준비되었어요',
	conversationDownloadHint: 'PDF를 다운로드해서 대화의 디지털 사본을 보관하세요.',
	conversationDownloadLoading: '파일을 준비하고 있어요…',
	conversationDownloadLink: '내 책 제{index}권 다운로드',
	conversationDownloadFileCoverLink: '표지 {name} 다운로드',
	conversationDownloadFileSourceLink: '원본 파일 {name} 다운로드',
	conversationDownloadPdfButton: '전자책 다운로드',
	conversationDownloadPdfWaitingMessage: '5분 후에 다시 다운로드해 주세요',
	conversationEditStart: '책 편집',
	conversationEditSuccess: '대화가 수정되었습니다!',
	conversationFlags: '플래그',
	conversationImages: '이미지',
	conversationMedias: '미디어',
	'conversationFormatLabelA4-1': '추억의 기록',
	'conversationFormatLabelA4-2': '(A4 앨범)',
	'conversationFormatLabelA5-1': '작은 보물',
	'conversationFormatLabelA5-2': '(A5 노트)',
	conversationGeneratedSuccess: '축하합니다! <br></br> 대화가 생성되었습니다!',
	conversationGenerationAlert: '책을 만들고 있어요…',
	conversationGenerationAlert2: '잠시만 기다려 주세요. 금방 끝나요.',
	conversationGenerationFailed: '책을 만드는 중에 멈췄어요.',
	conversationGenerationFailedHint: '메시지는 안전하게 저장되어 있어요. 다시 시도해 주세요. 같은 일이 또 생기면 문의해 주세요. 함께 확인해 드릴게요.',
	conversationGenerationRetry: '다시 시도하기',
	conversationHelpBooksText: '책을 전환하면 각 책의 정보를 따로 수정할 수 있어요',
	conversationHelpBooksTitle: '책 선택',
	conversationHelpCoverColorText: '원을 클릭하면 표지 배경색을 바꿀 수 있어요.',
	conversationHelpCoverColorTitle: '표지 색상',
	conversationHelpCoverImageText: '이 영역에 이미지 파일을 끌어다 놓으면 표지에 추가할 수 있어요.',
	conversationHelpCoverImageTitle: '표지 이미지',
	conversationHelpCoverTitleText: '제목을 클릭해서 수정해 보세요! 제목과 부제목, 두 줄을 수정할 수 있어요',
	conversationHelpCoverTitleTitle: '표지 제목',
	conversationHelpDatePreviewText: '책의 시작 날짜를 선택하세요.',
	conversationHelpDatePreviewTitle: '날짜',
	conversationHelpDateSelectorText: '날짜를 바꾸면 첫 메시지와 마지막 메시지가 여기에 표시돼요!',
	conversationHelpDateSelectorTitle: '메시지 미리보기',
	conversationHelpParticipantColorText: '참여자마다 말풍선 색상을 바꿀 수 있어요',
	conversationHelpParticipantColorTitle: '참여자 색상',
	conversationHelpParticipantNameText: '참여자 이름을 원하는 대로 수정해 보세요!',
	conversationHelpParticipantNameTitle: '참여자 이름',
	conversationHelpParticipantPositionText: '참여자의 말풍선을 왼쪽에 표시할지 오른쪽에 표시할지 선택하세요',
	conversationHelpParticipantPositionTitle: '참여자 위치',
	conversationHelpMessagesToolsTitle: '도구',
	conversationHelpMessagesToolsText: '타일을 눌러 검색하거나, 미디어·날짜로 필터링하거나, 메시지를 숨길 수 있어요.',
	conversationHelpMessagesSearchTitle: '검색',
	conversationHelpMessagesSearchText: '단어나 이름을 입력해 메시지를 빠르게 찾아보세요.',
	conversationHelpMessagesMediasTitle: '미디어',
	conversationHelpMessagesMediasText: '사진, 동영상, 오디오, 링크가 있는 메시지만 필터링할 수 있어요.',
	conversationHelpMessagesDatesTitle: '날짜',
	conversationHelpMessagesDatesText: '두 날짜 사이의 메시지만 남겨 대화의 일부에 집중할 수 있어요.',
	conversationHelpMessagesHidePeriodTitle: '기간 숨기기',
	conversationHelpMessagesHidePeriodText: '두 날짜를 선택하면 해당 기간의 메시지를 한 번에 숨기거나 다시 표시할 수 있어요.',
	conversationHelpMessagesHiddenTitle: '표시',
	conversationHelpMessagesHiddenText: '전체, 표시된 것만, 숨긴 것만 볼 수 있어요.',
	conversationHelpMessagesListTitle: '메시지 수정',
	conversationHelpMessagesListText: '각 말풍선에서 선택, 숨기기, 텍스트 수정, 새 메시지 추가가 가능해요.',
	conversationHelpMessagesFooterTitle: '미리보기로 돌아가기',
	conversationHelpMessagesFooterText: '완료되면 미리보기로 돌아가 업데이트된 책을 확인하세요.',
	conversationHelpPreviewBookCoverText: '나만의 특별한 표지를 만들어 보세요. 클릭하면 편집할 수 있어요.',
	conversationHelpPreviewBookCoverTitle: '표지',
	conversationHelpPreviewBookPreviewText: '클릭하면 이 책을 미리 넘겨볼 수 있어요.',
	conversationHelpPreviewBookPreviewTitle: '책 미리보기',
	conversationHelpPreviewBookSelectorText: '주문에 포함할 책을 선택해 주세요.',
	conversationHelpPreviewBookSelectorTitle: '내 책 목록',
	conversationHelpPreviewBookSplitText: '이 옵션을 켜면 모든 책의 페이지 수가 같아져요.',
	conversationHelpPreviewBookSplitTitle: '페이지 균등 분배',
	conversationHelpPreviewCopyText: '소장용, 선물용으로 여러 권 주문하세요. 2권부터 할인돼요.',
	conversationHelpPreviewCopyTitle: '한 권 선물하기',
	conversationHelpPreviewFormatText: '종이책 또는 전자책, 마음에 드는 쪽을 선택하세요.',
	conversationHelpPreviewFormatTitle: '형식',
	conversationHelpPreviewRenderText: '고객님의 책이에요. 표지는 바로 꾸밀 수 있어요. 그다음 페이지를 넘겨 보세요.',
	conversationHelpPreviewRenderTitle: '내 책',
	conversationHelpPreviewMessagesText: '이 카드를 눌러 메시지 내용을 수정하세요.',
	conversationHelpPreviewMessagesTitle: '메시지',
	conversationHelpPreviewDatesText: '이 카드를 눌러 책의 시작일과 종료일을 선택하세요.',
	conversationHelpPreviewDatesTitle: '날짜',
	conversationHelpPreviewParticipantsText: '이 카드를 눌러 참여자 이름과 표시 방식을 바꾸세요.',
	conversationHelpPreviewParticipantsTitle: '참여자',
	conversationHelpPreviewCoverTitleText: '제목이나 부제목을 클릭해 수정하세요.',
	conversationHelpPreviewCoverTitleTitle: '제목과 부제목',
	conversationHelpPreviewVolumesTitle: '여러 권',
	conversationHelpPreviewVolumesText: '대화가 여러 권으로 나뉩니다. 번호를 눌러 권을 바꾸고 각 표지를 꾸밀 수 있어요.',
	conversationHelpPreviewCoverImageText: '사진 영역을 눌러 표지 이미지를 추가하거나 바꾸세요.',
	conversationHelpPreviewCoverImageTitle: '사진',
	conversationHelpPreviewCoverColorText: '색상 칩을 눌러 표지 배경색을 바꾸세요.',
	conversationHelpPreviewCoverColorTitle: '색상',
	conversationHelpPreviewValidText: '준비가 끝나면 확인을 눌러 주세요. 전자책은 이메일로, 책은 집으로 도착해요.',
	conversationHelpPreviewValidTitle: '시작해요!',
	conversationHighlightStartDateTitle: '첫 메시지',
	conversationHighlightStartDateDescription: '이날 첫 메시지가 보내졌어요. 그 뒤의 이야기는 여기서 시작됐어요.',
	conversationHighlightDurationTitle: '함께한 날',
	conversationHighlightDurationDescription: '그 첫 메시지 이후, 함께한 이 모든 날이에요.',
	conversationHighlightMessagesCountTitle: '메시지',
	conversationHighlightMessagesCountDescription: '{date}부터 주고받은 이 모든 메시지예요.',
	conversationHighlightImagesCountTitle: '사진',
	conversationHighlightImagesCountDescription: '우리 대화 속에 남겨 둔 사진이에요.',
	conversationHighlightMediasCountTitle: '영상과 음성',
	conversationHighlightMediasCountDescription: '목소리를 다시 듣고, 그 순간을 다시 보려고요.',
	conversationHighlightSpecialDayMessagesCountTitle: '하루 동안',
	conversationHighlightSpecialDayMessagesCountDescription: '하루에 주고받은 메시지, 우리의 최고 기록이에요.',
	conversationHighlightSpecialDayTitle: '그날',
	conversationHighlightSpecialDayDescription: '우리가 메시지를 가장 많이 주고받은 날이에요.',
	conversationHighlightCharsCountReferenceDiffTitle: '로미오와 줄리엣',
	conversationHighlightCharsCountReferenceDiffDescription: '로미오와 줄리엣 본문, 이 배수만큼의 길이예요.',
	conversationHighlightCharsCountReferenceDiffRomeoJuliette: '{diff}배',
	conversationHighlightTypingDurationTitle: '글을 쓴 시간',
	conversationHighlightTypingDurationDescription: '우리가 메시지를 쓰는 데 들인 시간이에요.',
	conversationHighlightUnitDays: '일',
	conversationHighlightUnitMessages: '개',
	conversationHighlightUnitHours: '시간',
	conversationHighlightUnitTimes: '배',
	conversationHighlightBadge: '몇 가지 숫자로',
	conversationHighlightStoryKicker: '당신의 이야기',
	conversationHighlightsMomentsCount: '다운로드할 이미지 {count}장',
	conversationHighlightShareFormat: '스토리 비율',
	conversationHighlightsCardFooter: '어떤 이야기는 책이 될 자격이 있어요',
	conversationHighlightShareButton: '다운로드',
	conversationHighlightShareButtonAlt: '대화 통계 보기',
	conversationHighlightShareImageButton: '이미지 보내기',
	conversationHighlightSubtitle: '주고받은 말을, 숫자로.',
	conversationHighlightTitle1: '주고받은 말을',
	conversationHighlightTitle2: '몇 개의 숫자로',
	conversationHighlightOpenStoryButton: '이 스토리 열기',
	conversationHighlightsAtGlanceEyebrow: '한눈에 보기',
	conversationHighlightsAtGlanceTitle: '두 사람의 이야기 규모',
	conversationHighlightsNoAiNote: '이 통계는 AI 없이 자동으로 계산됩니다.',
	conversationHighlightsKpiMessages: '메시지',
	conversationHighlightsKpiWords: '주고받은 단어',
	conversationHighlightsKpiActiveDays: '대화한 날',
	conversationHighlightsKpiStreak: '연속으로 대화한 날',
	conversationHighlightsRhythmEyebrow: '두 사람의 리듬',
	conversationHighlightsRhythmTitle: '메시지가 오가는 순간',
	conversationHighlightsTopHour: '가장 많이 대화한 시간',
	conversationHighlightsTopWeekday: '가장 많이 대화한 요일',
	conversationHighlightsNightMessages: '밤에 보낸 메시지',
	conversationHighlightsChartMonths: '첫 메시지부터 마지막까지, 월별',
	conversationHighlightsChartYears: '첫 메시지부터 마지막까지, 연도별',
	conversationHighlightsLessThanOneMinute: '1분 미만',
	conversationHighlightsSpanLessThanMonth: '한 달 미만',
	conversationHighlightsSpanYears: '{count}년',
	conversationHighlightsSpanMonths: '{count}개월',
	conversationHighlightsSpanYearsMonths: '{years}년 {months}개월',
	conversationHighlightsSpanLabel: '첫 메시지부터 마지막까지',
	conversationHighlightsBusiestDayLabel: '가장 이야기가 많았던 날',
	conversationHighlightsPhotosLabel: '사진',
	conversationHighlightsMediasLabel: '영상과 음성 메시지',
	conversationHighlightsBookPagesLabel: '책으로 보면',
	conversationHighlightsBookPagesPrefix: '약',
	conversationHighlightsBookPagesUnit: '쪽',
	conversationHighlightsBookPagesNote: '메시지와 사진을 바탕으로 한 추정입니다.',
	conversationHighlightsWritingHours: '서로 쓴 시간 약 {count}시간.',
	conversationHighlightsRomeo: '로미오와 줄리엣 약 {count}편 분량.',
	conversationHighlightsDayClockPeak: '{start}시부터 {end}시가 가장 많아요',
	conversationHighlightsLessThanOnePercent: '1% 미만',
	conversationHighlightsWritesLonger: '{name}님의 메시지가 가장 길어요.',
	conversationHighlightsStartsMore: '{name}님이 대화를 가장 자주 시작해요.',
	conversationHighlightsWordsPerMessage: '메시지당 {count}단어',
	conversationHighlightsStartsShare: '시작의 {percent}%',
	conversationHighlightsMedianReply: '답장 시간 중앙값',
	conversationHighlightsBalanceEyebrow: '두 사람의 균형',
	conversationHighlightsBalanceTitle: '서로 곁에 있는 각자의 방식',
	conversationHighlightsWordsShort: '단어',
	conversationHighlightsStartsShort: '대화 시작',
	conversationHighlightsBalanceNote: '비율은 대화의 리듬을 보여 줄 뿐, 누군가의 중요도를 나타내지 않아요.',
	conversationHighlightsRecordsEyebrow: '두 사람의 기록',
	conversationHighlightsRecordsTitle: '눈에 띄는 순간들',
	conversationHighlightsLongestSession: '가장 긴 대화',
	conversationHighlightsIntenseQuarter: '가장 뜨거웠던 15분',
	conversationHighlightsQuestions: '다정한 메시지',
	conversationHighlightsSignsOfInterest: '하트, 뽀뽀, 「사랑해」',
	conversationHighlightsLaughs: '웃음이 담긴 메시지',
	conversationHighlightsSharedSmiles: '함께 나눈 미소',
	conversationHighlightsFavoriteEmojis: '즐겨 쓴 이모지',
	conversationHighlightsStoriesEyebrow: '간직하고 싶은 순간',
	conversationHighlightsStoriesTitle: '추억 카드',
	conversationHighlightsStoriesText: '카드를 열고 스토리 형식으로 다운로드해 보세요.',
	conversationHighlightsDeepEyebrow: '숫자 너머에는?',
	conversationHighlightsDeepTitle: '두 사람의 이야기를 더 깊이 들여다보고 싶으신가요?',
	conversationHighlightsDeepText: '언젠가 더 깊이 알아보고 싶으시다면 알려 주세요. 지금은 추가 분석을 진행하지 않아요.',
	conversationHighlightsDeepThanks: '감사합니다. 관심을 남겨 주셨어요',
	conversationHighlightsDeepButton: '네, 관심 있어요',
	conversationHighlightsDeepNotice: '준비되는 대로 알려 드릴게요.',
	conversationHighlightsDeepNoticeClose: '확인',
	conversationHighlightsPrintBook: '내 책을 인쇄하고 싶어요',
	conversationHighlightsPrintNow: '지금 인쇄하기',
	conversationHighlightsLoading: '숫자를 모으고 있어요.',
	conversationHighlightsEmpty: '숫자를 뽑으려면 대화가 조금 더 필요해요.',
	conversationImagesCount: '사진 {count}{count, plural,\n		=0 {장}\n		=1 {장}\n		other {장}\n  	}',
	conversationImportFileNotSupportedError: '파일이 올바른 압축 파일이 아닙니다! 올바른 압축 파일(.zip)을 선택해 주세요',
	conversationImportFileSummary: '고객님의 이름은 {name}, 이 압축 파일에는 대화 {count}개가 들어 있습니다.',
	conversationImportFileTooBigError: '파일이 너무 큽니다! (4GB 초과). 문제 해결을 위해 저희에게 문의해 주세요',
	conversationImportProviderNext: '대화 전송하기',
	conversationImportTutorialGoNext: '더 보기',
	conversationImportTutorialStep: '{step}단계',
	conversationImportDetailToggle: '화면 캡처가 포함된 상세 가이드 보기',
	conversationImportDetailCardTitle: '처음이신가요?',
	conversationImportDetailCardSubtitle: '화면 캡처가 포함된 {count}단계 그림 가이드',
	conversationImportDetailCardAction: '가이드 열기',
	conversationImportDetailTitle: '단계별 상세 가이드',
	conversationImportDetailStepOf: '{total}단계 중 {current}단계',
	conversationImportDetailPrev: '이전',
	conversationImportDetailNext: '다음',
	conversationImportDetailClose: '닫기',
	conversationImportSelectionSummary: '선택한 대화: {name} (메시지 {count}{count, plural,\n			=0 {건}\n			=1 {건}\n			other {건}\n		} 포함)',
	conversationImportSelectionSummary2: '선택한 대화: {name}',
	conversationImportSelectionText: '친구 이름을 입력하세요...',
	conversationImportSelectionTitle: '대화를 선택하세요',
	conversationImportStepCreation: '책 생성',
	conversationImportStepExtraction: '파일 분석',
	conversationImportStepFinal: '마무리 작업',
	conversationImportStepImages: '사진 전송',
	conversationImportStepMedias: '동영상 및 음성 전송',
	conversationImportStepMessages: '메시지 저장',
	conversationImportTransferStatMessages: '메시지',
	conversationImportTransferStatPhotos: '사진',
	conversationImportTransferStatMedias: '동영상 및 음성',
	conversationImportTransferEyebrow: '거의 다 됐어요',
	conversationImportTransferTitle: '책을 준비하고 있어요',
	conversationImportTransferSubtitle: '잠시만 기다려 주세요. 고객님의 이야기가 만들어지고 있어요.',
	conversationImportTransferStay: '전송이 끝날 때까지 이 페이지에 머물러 주세요.',
	conversationImportResumeTitle: '이전 전송이 중단되었습니다.',
	conversationImportResumeTextFile: '같은 파일({name})을 다시 선택하면 중단된 지점부터 이어서 진행됩니다.',
	conversationImportResumeText: '같은 파일을 다시 선택하면 중단된 지점부터 이어서 진행됩니다.',
	conversationImportResumeButton: '이어서 전송하기',
	conversationImportResumeDiscard: '다시 시작',
	conversationImportDuplicateTitle: '이 대화는 이미 고객님 계정에 있습니다',
	conversationImportDuplicateEyebrow: '동일한 대화',
	conversationImportDuplicateLead: '동일한 대화를 찾았습니다. 중복 전송을 피하려면 이미 있는 대화를 열어 보세요.',
	conversationImportDuplicateQuestion: '어떻게 하시겠어요?',
	conversationImportDuplicateUseExisting: '이미 있는 대화 사용',
	conversationImportDuplicateImportAnyway: '다시 가져오기',
	conversationImportSuccess: '축하합니다! <br></br>대화를 가져왔습니다!',
	conversationImportValidationWaiting: '확인 중...',
	conversationMediaAudioOpusWarning: '이 파일이 재생되지 않으면 호환되는 다른 브라우저(Google Chrome 등)를 사용해 주세요',
	conversationMediasCount: '미디어 {count}{count, plural,\n		=0 {개}\n		=1 {개}\n		other {개}\n	}',
	conversationMerge: '대화 병합',
	conversationMergeSelect: '이 대화 선택',
	conversationMergeUnselect: '이 대화 선택 해제',
	conversationMergeInfo: '병합할 대화를 선택한 뒤, 목록 아래에 있는 버튼을 클릭하세요:',
	conversationMergeRequestSuccess: '대화가 곧 병합됩니다. 병합이 완료되면 이메일로 알려드립니다.',
	conversationMergeHintEyebrow: '참고',
	conversationMergeHintTitle: '하나의 대화로 합치기',
	conversationMergeHintSingle: '여러 대화 스레드가 있나요? + 버튼으로 각 대화를 가져온 뒤 하나의 대화로 병합하세요.',
	conversationMergeHintReady: '대화를 시간순 하나의 대화로 병합할 수 있습니다.',
	conversationMessages: '메시지',
	conversationMessagesCount: '메시지 {count}{count, plural,\n		=0 {건}\n		=1 {건}\n		other {건}\n	}',
	conversationMessagesCount2: '{count, plural,\n		=0 {메시지}\n		=1 {메시지}\n		other {메시지}\n	}',
	conversationMessagesImagesCount: '이미지 {count}{count, plural,\n		=0 {장}\n		=1 {장}\n		other {장}\n	}',
	conversationMessagesImagesCount2: '{count, plural,\n		=0 {이미지}\n		=1 {이미지}\n		other {이미지}\n	}',
	conversationMessagesLoadingAlert: '메시지를 불러오는 중...',
	conversationMessagesMediasCount: '미디어 {count}{count, plural,\n		=0 {개}\n		=1 {개}\n		other {개}\n	}',
	conversationMessagesMediasCount2: '{count, plural,\n		=0 {미디어}\n		=1 {미디어}\n		other {미디어}\n	}',
	conversationNoData: '아직 만드신 대화가 없어요.',
	conversationOptionWithImagesHelp1: '현재 고객님의 책에는 이미지와 사진이 포함됩니다.',
	conversationOptionWithImagesHelp2: '현재 고객님의 책에는 이미지와 사진이 포함되지 않습니다.',
	conversationOptionWithImagesHelp3: '사진 수에 따라 대화 전송이 느려질 수 있습니다. 불러오는 동안 이 페이지에 머물러 주세요. 최대 10분까지 걸릴 수 있습니다. 그래도 문제가 계속되면 www.fromsmash.com을 이용해 hello@monlivresms.com으로 상대방 또는 그룹 이름과 함께 압축 파일을 보내 주세요. 저희가 해결 방법을 찾아드리겠습니다.',
	conversationOptionWithImagesLabel: '대화의 이미지를 포함할까요?',
	conversationOptionWithMediaHelp: '책에 인쇄된 QR코드로 동영상, 음성, GIF를 다시 볼 수 있어요. 데이터 보관은 10년 동안 무료로 제공돼요.',
	conversationOptionWithMediasLabel: '대화의 동영상, 음성, GIF를 포함할까요?',
	conversationOrder: '주문',
	conversationOrderButton: '지금 주문하기',
	conversationOrderButtonWithPrice: '주문하기 · {price}',
	conversationOrderButtonWithPriceVolumes: '{count}권 주문하기 · {price}',
	conversationOrderDiscountLabel: '이 대화를 {threshold}권 이상 주문하시면 -{discount}% 할인',
	conversationOrderQuantity: '주문 수량',
	conversationOrderSummaryBook: '책 {bookCount}{bookCount, plural,\n			=1 {권}\n			other {권}\n		} · {bookTotal} {discount, plural,\n			=0 {}\n			other {({discount}% 할인 포함)}\n		}',
	conversationOrderSummary2: '고객님의 주문에는 책 {bookCount}{bookCount, plural,\n				=0 {권}\n				=1 {권}\n				other {권}\n			}과 전자책 {pdfCount}{pdfCount, plural,\n				=0 {권}\n				=1 {권}\n				other {권}\n			}{freeCount, plural,\n				=0 {}\n				=1 { + 무료 전자책 1권}\n				other { + 무료 전자책 {freeCount}권}\n			}이 포함되며, 금액은 {pdfTotal}입니다.',
	conversationOrderSummaryBestof: 'Best Of 책 1권 · {bestofTotal}',
	conversationOrderSummaryPdf: '전체 수록 전자책 1권 · {pdfTotal}',
	conversationParticipantColorHelp: '여기를 클릭하면 말풍선 색상을 바꿀 수 있어요',
	conversationParticipantColorBlushClair: '연한 블러시',
	conversationParticipantColorCielClair: '연한 하늘색',
	conversationParticipantColorLavandeClaire: '연한 라벤더',
	conversationParticipantColorPruneClaire: '연한 자두색',
	conversationParticipantColorPecheClaire: '연한 피치',
	conversationParticipantColorSaugeClair: '연한 세이지',
	conversationParticipantColorMiel: '허니',
	conversationParticipantColorPerle: '진주색',
	conversationParticipantNameHelp: '여기를 클릭하면 참여자 이름을 수정할 수 있어요',
	conversationParticipantNameError: '이름이 너무 깁니다 (최대 {max}자)',
	conversationParticipantPositionHelp: '클릭하면 참여자 위치를 바꿀 수 있어요 (오른쪽 또는 왼쪽)',
	conversationParticipantPositionLeft: '왼쪽',
	conversationParticipantPositionRight: '오른쪽',
	conversationParticipants: '참여자',
	conversationOrders: '주문 내역',
	conversationPrinterMode: '인쇄소 모드',
	conversationParticipantsLuxEyebrow: '고객님의 대화',
	conversationParticipantsLuxHint: '참여자별로 이름, 말풍선 색상, 좌우 위치를 수정할 수 있어요.',
	conversationParticipantsLuxSavePreview: '저장 · 미리보기로 돌아가기',
	conversationParticipantsLuxSaved: '저장됨',
	conversationParticipantsSameSideHint: '여러 참여자가 같은 쪽에 있습니다. 좌우 위치를 확인해 주세요.',
	conversationParticipantsEditTitle: '참여자 수정',
	conversationPauseButton: '주문 일시중지',
	conversationPauseConfirmText: '책 생성이 일시중지됩니다. 언제든지 다시 시작할 수 있습니다.',
	conversationPreviewBookNumber: '{index}{index, plural,\n			  =0 {}\n			  =1 {번째}\n			  =2 {번째}\n			  other {번째}\n		  } 책',
	conversationPreviewBestofHelpButton: '선별은 어떻게 이루어지나요?',
	conversationPreviewBestofHelpText: '저희 알고리즘은 대화의 모든 순간을 분석합니다. 메시지가 오간 밀도, 대화의 질(실제로 주고받은 대화인지 혼잣말인지), 내용의 풍부함(사진, 텍스트, 이모지)을 살펴봅니다. 처음과 마지막 메시지는 언제나 그대로 남습니다. 정말로 의미 있었던 순간만 책에 담깁니다. 메시지는 계속 비공개로 보호됩니다. 저희 알고리즘은 내용을 절대 읽지 않고, 주고받은 구조만 확인합니다.',
	conversationPreviewBookSelection: '책 선택',
	conversationPreviewBooksSelectAllBooks: '종이책 전체 선택',
	conversationPreviewBooksSelectAllEBooks: '전자책 전체 선택',
	conversationPreviewBooksUnselectAll: '전체 선택 해제',
	conversationPreviewBrowserWarning: '사용 중인 브라우저 때문에 화면이 느려질 수 있습니다. 최적의 환경을 위해 Google Chrome을 권장합니다.',
	conversationPreviewFormatSelection: '판형 선택',
	conversationPreviewPagesDivideEquallyLabel: '책마다 페이지를 균등하게 나눌까요?',
	conversationPreviewPagesSetMaxBookPagesLabel: '가급적 {max}페이지 분량의 책으로 만들까요?',
	conversationPreviewTitle: '이야기를 한 권의 책으로.',
	conversationPreviewSubtitle: '표지, 이름, 날짜, 메시지를 꾸민 뒤 구성을 선택하세요.',
	conversationPreviewHeroTitle: '주고받은 말, 오래 남는 한 권으로.',
	conversationPreviewBookCaption: '페이지를 넘겨 책을 살펴보세요.',
	conversationPreviewCustomizeEyebrow: '나만의 스타일로',
	conversationPreviewEditionEyebrow: '구성',
	conversationPreviewPricePerVolume: '{price}/권',
	conversationPreviewCollectionPriceNote: '{count}권 · {price}/권',
	conversationPreviewCollectionUntilLabel: '어느 권',
	conversationPreviewCollectionUntilAll: '첫 권부터 마지막 권까지',
	conversationPreviewCollectionUntilOpen: '선택',
	conversationPreviewCollectionUntilClose: '닫기',
	conversationPreviewCollectionUntilPartial: '처음 {count}권',
	conversationPreviewCollectionUntilSuffix: '마지막 {count}권',
	conversationPreviewCollectionUntilSingle: '{number}권',
	conversationPreviewCollectionUntilWindow: '{from}권부터 {to}권까지',
	conversationPreviewCollectionUntilPeriod: '{start}부터 {end}까지',
	conversationPreviewCollectionUntilHint: '나머지 권은 대화에 남습니다. 다음 주문에서 만들 수 있습니다.',
	conversationPreviewCollectionUntilAriaStart: '인쇄할 첫 권',
	conversationPreviewCollectionUntilAriaEnd: '인쇄할 마지막 권',
	conversationPreviewTypeBookTaglinePartial: '대화의 처음 {count}권입니다.',
	conversationPreviewTypeBookTaglineSuffix: '대화의 마지막 {count}권입니다.',
	conversationPreviewTypeBookTaglineWindowSingle: '대화의 {number}권입니다.',
	conversationPreviewTypeBookTaglineWindow: '대화의 {from}권부터 {to}권입니다.',
	conversationPreviewStickyCollectionVolumes: '컬렉션 · {count}권',
	conversationPreviewSocialProofCount: '리뷰 {count}개 이상',
	conversationPreviewSocialProofAria: 'Trustpilot 리뷰 {count}개 이상 기준, 5점 만점에 {rating}점',
	conversationPreviewCustomizeTitle: '내 책 꾸미기',
	conversationPreviewCustomizeDone: '꾸미기 완료',
	conversationPreviewCustomizeClose: '꾸미기 닫기',
	conversationPreviewEditionScrollLabel: '구성 섹션으로 이동',
	conversationPreviewEditionBelowHint: '아래에서 구성을 선택하세요',
	conversationPreviewCustomizeHint: '카드를 눌러 수정하세요.',
	conversationPreviewCardsHintTitle: '이름, 기간, 메시지',
	conversationPreviewCardsHintText: '여기서 이름, 기간, 메시지를 바꿀 수 있어요.',
	conversationPreviewCustomizeTopics: '표지 · 이름 · 날짜 · 메시지',
	conversationPreviewEditionTitle: '구성 선택',
	conversationPreviewEditionHint: '옵션을 비교하고 마음에 드는 것을 선택하세요.',
	conversationPreviewPausedEyebrow: '주문 일시중지됨',
	conversationPreviewPausedTitle: '수정이 끝나셨나요?',
	conversationPreviewPausedHint: '주문이 일시중지되어 있습니다. 책을 수정한 뒤 확인하시면 제작이 다시 시작됩니다.',
	conversationPreviewPausedScrollHint: '수정 내용 확정',
	conversationPreviewMissingMediasBanner: '대화의 일부 미디어(사진, 파일)가 없거나 불러오지 못했습니다. 확정하기 전에 메시지를 확인해 주세요.',
	conversationPreviewMissingMediasCta: '누락된 미디어 보완',
	bookMissingPhotoLabel: '사진 없음',
	conversationMissingMediasBadge: '누락된 미디어',
	conversationMissingMediasCta: '누락된 미디어 보완',
	conversationResumeWithoutMediasButton: '이 사진 없이 계속',
	conversationResumeMissingMediasConfirmText: '아직 누락된 사진이 있습니다. 책은 해당 사진 없이 인쇄로 진행됩니다. 가능하면 미디어를 보완하세요.',
	orderMissingMediasAlert: '이 주문의 대화에 누락된 사진이 있습니다. 제작을 재개하려면 보완해 주세요.',
	missingMediasRecoveryAddPhoto: '사진 추가',
	missingMediasRecoveryArchiveCta: '내보내기 파일 놓기',
	missingMediasRecoveryArchiveError: '이 파일을 읽을 수 없습니다. 메신저 내보내기 파일인지 확인하세요.',
	missingMediasRecoveryArchiveHelp: '{provider} 내보내기(zip)를 다시 업로드하세요. 누락된 사진만 추가되며: 메시지와 수정 내용은 그대로입니다.',
	missingMediasRecoveryArchiveTitle: '새 내보내기로 보완',
	missingMediasRecoveryArchiveWorking: '파일에서 누락된 사진을 찾는 중…',
	missingMediasRecoveryContact: '문의하기',
	missingMediasRecoveryEmpty: '지금은 누락된 미디어가 감지되지 않았습니다.',
	missingMediasRecoveryError: '오류가 발생했습니다. 다시 시도하거나 문의해 주세요.',
	missingMediasRecoveryFirstDate: '첫 누락 미디어: {date}.',
	missingMediasRecoveryIgnore: '무시',
	missingMediasRecoveryIntro: '책에 사진 {count}장이 누락되었습니다. 내보내기 파일을 다시 올리거나 아래에서 항목별로 처리할 수 있습니다.',
	missingMediasRecoveryListTitle: '미디어 하나씩 처리',
	missingMediasRecoveryNoMatch: '누락된 미디어와 일치하는 파일을 찾지 못했습니다.',
	missingMediasRecoveryRecommended: '권장',
	missingMediasRecoveryRescan: '다시 확인',
	missingMediasRecoveryResolved: '누락된 미디어 처리가 완료되었습니다. 책이 다시 제작으로 들어갑니다.',
	missingMediasRecoverySuccessEyebrow: '완료',
	missingMediasRecoverySuccessTitle: '사진 보완이 완료되었습니다',
	missingMediasRecoverySuccessText: '누락된 미디어 처리가 완료되었습니다. 책이 다시 제작으로 들어갑니다.',
	missingMediasRecoverySuccessCta: '미리보기로 돌아가기',
	conversationMissingMediasFixedSuccess: '누락된 미디어 보완이 완료되었습니다. 책이 다시 제작으로 들어갑니다.',
	conversationMissingMediasFixedHint: '고객님께서 하실 일은 없습니다. 제작이 자동으로 재개됩니다.',
	missingMediasRecoverySmsStepAndroid: 'Android: MonLivreSMS 앱을 다시 열고 대화를 다시 보내세요.',
	missingMediasRecoverySmsStepBackup: '암호화되지 않은 새 로컬 백업(Mac/PC)을 만든 다음 소프트웨어를 다시 실행해 이 대화의 미디어를 다시 보내세요.',
	missingMediasRecoverySmsStepIcloud: 'iPhone: 메시지에서 대화를 열고 연락처를 탭한 뒤 스크롤하여 iCloud 사진을 다운로드하세요.',
	missingMediasRecoverySmsTitle: 'SMS / iPhone 전송',
	missingMediasRecoveryTitle: '누락된 미디어 ({count})',
	conversationPreviewEditionMetaLabel: '구성 상세',
	conversationPreviewBestofLearnMore: 'Best-Of 선별 방식 알아보기',
	conversationPreviewBestofHint: '예시용 Best Of 미리보기입니다. 실제 베스트 메시지 선별은 주문 후 PDF 생성 시점에 이루어집니다.',
	conversationPreviewBestofHintDismiss: '닫기',
	conversationPreviewBestofHintLearnMore: '자세히 보기',
	conversationPreviewBestofPriceNote: '주문 후 선정',
	conversationPreviewTypeBestofTaglineCompare: '더 가벼운 선택: 최고의 순간을 1권으로.',
	conversationPreviewMetaEbook: '전자책 무료 제공',
	conversationPreviewMetaVolume: '{count}권',
	conversationPreviewMetaVolumes: '{count}권',
	conversationPreviewMetaPages: '{pages}페이지',
	conversationPreviewMetaMessages: '메시지 {count}건',
	conversationPreviewMetaBestofPages: '약 400페이지',
	conversationPreviewMetaBestofSelection: '스마트 선별',
	conversationPreviewMetaPdfInstant: '바로 PDF',
	conversationPreviewMetaPdfCredit: '책 크레딧',
	conversationPreviewPdfPriceNote: '책으로 가면 차감',
	conversationPreviewPdfLearnMore: '어떻게 되나요?',
	conversationPreviewPdfHelpText: '{ebookPrice}를 결제하면 PDF를 받습니다. 나중에 종이책({bookPrice})을 주문하면 이 {ebookPrice}가 차감되고 {remainingPrice}가 남습니다. 크레딧은 계정에 남습니다.',
	conversationPreviewReassurancePdfCredit: '책으로 가면 이 {price}가 차감됩니다',
	conversationPreviewStickyPdfCredit: '책으로 갈 때 {price} 크레딧',
	conversationPreviewEbookCreditBanner: '이 대화에 {amount} 크레딧이 있습니다. 종이책을 주문하면 자동으로 차감됩니다.',
	conversationPreviewEbookCreditOrderHint: '{credit} 크레딧 차감 · 정가 {fullPrice}',
	conversationPreviewStickyEbookCredit: '{credit} 크레딧 적용',
	paymentMethodEbookCreditHint: '종이책용 ebook 크레딧',
	cartTotalsEbookCredit: 'ebook 크레딧',
	cartTotalsCredit: '크레딧',
	conversationOrderButtonEbook: 'PDF 받기',
	conversationOrderButtonEbookWithPrice: 'PDF 받기 · {price}',
	conversationPreviewTypeBookTaglineSingle: '고객님의 이야기 전부, 한 장 한 장.',
	conversationPreviewTypeBookTaglineMulti: '대화 전체를 인쇄본 {count}권으로.',
	conversationPreviewHeroHeading: '책 미리보기',
	conversationPreviewHelpTourButton: '페이지 도움말 보기',
	conversationPreviewCardLabelCover: '표지',
	conversationPreviewCardLabelParticipants: '참여자',
	conversationPreviewCardLabelDates: '날짜',
	conversationPreviewCardLabelMessages: '메시지',
	conversationPreviewZoneDone: '확인함',
	conversationPreviewZoneHintCover: '색상, 사진, 제목, 서문',
	conversationPreviewZoneHintParticipants: '이름과 말풍선 색상',
	conversationPreviewZoneHintDates: '책에 담기는 기간',
	conversationPreviewZoneHintMessages: '메시지 숨기기 또는 수정',
	conversationHelpPreviewCustomizeTitle: '이름, 날짜, 메시지',
	conversationHelpPreviewCustomizeText: '카드를 눌러 이름, 날짜, 메시지를 수정하세요.',
	conversationBookNavPrev: '이전 페이지',
	conversationBookNavNext: '다음 페이지',
	conversationBookBackToCover: '표지로 돌아가기',
	conversationPreviewTypeBookPagesHint: ' · {pages}페이지',
	conversationPreviewTypeBookMessagesHint: ' · 메시지 {count}건',
	conversationOrderTotal: '합계',
	conversationPreviewTypeBestofDescription: '400페이지에 담은 최고의 순간들. 전자책 무료 제공.',
	conversationPreviewTypeBestofTitle: 'Best Of',
	conversationPreviewTypeBookDescription: '{count}권 · 전체 이야기 수록. 전자책 무료 제공.',
	conversationPreviewTypeBookDescriptionWithPrice: '{count}권 · {unitBreakdown} · 전권 수록. 전자책 무료 제공.',
	conversationPreviewReassuranceShipping: '전 세계 무료 배송',
	conversationPreviewExpressDeliveryLead: '{where} 특급 배송',
	conversationPreviewExpressDeliveryDate: '{date}부터',
	conversationPreviewTypeBookTitle: '전권 컬렉션',
	conversationPreviewTypeHighlight: '추천',
	conversationPreviewTypePdfDescription: '대화를 PDF로 남겨 두세요. 이 금액은 나중에 책을 원하시면 적용됩니다.',
	conversationPreviewTypePdfTitle: '디지털',
	conversationPreviewTypeSelectionTitle: '원하는 형식을 선택하세요',
	conversationProgress: '진행 상황',
	conversationProviderButton: '설정으로 이동',
	conversationProviderType: '종류',
	conversationRemoveButton: '대화 삭제',
	conversationRemoveConfirmText: '대화를 삭제하면 미디어도 함께 삭제되며 복구할 수 없습니다.',
	conversationRemoveConfirmTitle: '대화 삭제',
	conversationRemoveFlagConfirmMessage: '이 대화에서 플래그를 제거하시겠습니까?',
	conversationRemoveSuccess: '대화가 삭제되었습니다.',
	conversationRestartProcess: '다시 시작',
	conversationResumeButton: '확인 후 인쇄',
	conversationResumeConfirmText: '대화가 \'확인됨\' 상태로 표시되며, 곧 생성되어 인쇄가 시작됩니다.',
	conversationValidateModificationsButton: '수정 내용 확정',
	conversationValidateModificationsConfirmTitle: '수정 내용을 확정할까요?',
	conversationValidateModificationsConfirmBook: '수정 내용이 반영되어 책 제작이 다시 시작됩니다.',
	conversationValidateModificationsConfirmEbook: '수정 내용이 반영된 전자책이 다시 생성되어 이메일로 발송됩니다.',
	conversationValidateModificationsConfirmMissingMedias: '대화의 일부 미디어가 없습니다. 확정하기 전에 확인해 주세요. 현재 수정 내용 그대로 책 제작이 시작됩니다.',
	conversationValidateModificationsSuccessBook: '수정 내용이 저장되었습니다. 책 제작이 다시 시작됩니다.',
	conversationValidateModificationsSuccessEbook: '수정 내용이 저장되었습니다. 다시 생성된 전자책을 이메일로 보내드립니다.',
	conversationValidateModificationsBackToList: '내 대화 목록으로',
	conversationSelectThread: '스레드 선택',
	conversationShareCancelButton: '나중에',
	conversationShareConfirmButton: '내 기록 확인하기',
	conversationShareConfirmTitle: '저희가 이런 걸 찾았어요...',
	conversationShareConfirmText: '고객님의 대화 속에는 놀라운 기록들이 숨어 있어요. 바로 공유하실 수 있도록 이미지로 만들어 두었어요.',
	conversationStatusConfigured: '생성 대기 중',
	conversationStatusDone: '완료',
	conversationStatusOngeneration: '생성 중',
	conversationStatusOnproduction: '제작 중',
	conversationStatusOnvalidation: '인쇄 대기 중',
	conversationStatusPending: '대기 중',
	conversationTypeAndroidDownloadAlt: '또는 링크를 복사해 원하는 브라우저에 붙여넣으세요',
	conversationTypeAndroidDownloadButton: '앱 다운로드',
	conversationTypeAndroidIntroText1: 'Android 휴대폰으로 SMS 책을 만들려면 스마트폰(예: 삼성, HTC, 화웨이)에서 진행해야 합니다.',
	conversationTypeAndroidIntroText2: '아래 링크를 눌러 Android 휴대폰에 MonLivreSMS 앱을 설치하세요. (Google Play에서는 제공되지 않는 앱입니다)',
	conversationTypeAndroidIntroText3: '추억의 SMS 책을 함께 쓸 상대를 고르고, 이야기의 시작일과 종료일을 정하세요.',
	conversationTypeAndroidIntroText4: '이야기 주인공들의 이름을 정하고, 소개글을 쓰고, 표지를 꾸며보세요',
	conversationTypeAndroidIntroText5: 'SMS 책을 완성하려면 계정을 만들고 안전한 결제 서버에서 구매를 마무리하세요.',
	conversationTypeInstagramFileText1: 'Instagram에서 압축 파일을 다운로드할 수 있는 이메일을 보내 줍니다',
	conversationTypeInstagramFileText2: '기기에 다운로드하세요',
	conversationTypeInstagramFileText3: '아래 버튼을 누른 뒤, 파일에서 압축을 풀지 말고 .zip 그대로 선택하세요. 파일 이름 예시: *이름*_*오늘날짜*.zip (선택한 대화만 인쇄 서비스로 전송됩니다)',
	conversationTypeInstagramProviderText1: '계정 설정에서 Instagram 데이터 사본을 요청하세요',
	conversationTypeInstagramProviderText2: 'Instagram 계정에 연결된 이메일 주소를 입력하고 JSON 형식을 선택하세요',
	conversationTypeInstagramProviderText3: '그다음 비밀번호를 입력하고 <strong>다운로드 요청</strong>을 눌러 Instagram에서 백업 생성을 시작하세요.',
	conversationTypeIosIntroText1: 'iPhone을 컴퓨터에 연결하고 암호화되지 않은 iTunes 백업을 만드세요. (\'이 컴퓨터\'를 선택하고, \'iPhone 백업 암호화\'는 체크를 해제한 뒤 \'지금 백업\'을 누르세요)',
	conversationTypeIosIntroText2: '컴퓨터 운영체제에 맞는 링크를 눌러 MonLivreSMS 소프트웨어를 다운로드하세요:',
	conversationTypeIosIntroText3: '<strong>주의, 소프트웨어가 백업을 찾지 못하는 경우:</strong><br></br> - Mac:<br></br>시스템 환경설정 > 보안 및 개인 정보 보호 > 전체 디스크 접근 권한으로 이동한 뒤, 왼쪽 아래 자물쇠를 풀고 MonLivreSMS 앱을 추가하세요.<br></br> - PC: <br></br>Apple 보안 정책상 고객님의 허가 없이는 백업을 읽을 수 없습니다.',
	conversationTypeMessengerFileText1: 'Facebook에서 압축 파일을 다운로드할 수 있는 이메일이 발송됩니다',
	conversationTypeMessengerFileText2: '기기에 다운로드하세요',
	conversationTypeMessengerFileText3: '아래 버튼을 누른 뒤, 파일에서 압축 파일을 .zip 상태 그대로 선택하세요. 예시: facebook-*이름*.zip (선택한 대화만 인쇄 서비스로 전송됩니다)',
	conversationTypeMessengerProviderText1: '계정 설정에서 Facebook 데이터 사본을 요청하세요',
	conversationTypeMessengerProviderText2: '\'내 정보 다운로드\'를 누르세요',
	conversationTypeMessengerProviderText3: '그다음 아래 옵션을 설정하세요:<br></br>\n			  <strong>날짜 범위</strong>: (원하는 기간)<br></br>\n			  <strong>형식</strong>: JSON<br></br>\n			  <strong>미디어 품질</strong>: 낮음(이 정도로 충분하고 전송 시간도 짧아집니다)<br></br>\n			  <strong>내 정보</strong>: 메시지(나머지는 선택 해제)',
	conversationTypeMessengerProviderText4: '주의: 데이터 형식은 반드시 JSON(HTML 아님)으로 선택해 주세요!',
	'conversationTypeSnapchatProviderText1.1': '기기에서 Snapchat 앱을 여세요.',
	'conversationTypeSnapchatProviderText1.2': '화면 왼쪽 위의 아바타(또는 Bitmoji)를 눌러 프로필로 이동하세요.',
	'conversationTypeSnapchatProviderText1.3': '오른쪽 위의 톱니바퀴 아이콘을 눌러 설정을 여세요.',
	'conversationTypeSnapchatProviderText2.1': '아래로 스크롤해 \'개인정보 보호\' 항목까지 이동하세요.',
	'conversationTypeSnapchatProviderText2.2': '\'내 데이터\'를 선택하세요.',
	'conversationTypeSnapchatProviderText3.1': '본인 확인을 위해 로그인을 요청받을 수 있습니다.',
	'conversationTypeSnapchatProviderText4.1': '\'내 데이터\' 페이지에는 메시지를 포함해 다운로드할 수 있는 데이터 목록이 표시됩니다.',
	'conversationTypeSnapchatProviderText4.2': '페이지 맨 아래의 \'내 데이터 제출\'을 누르세요.',
	'conversationTypeSnapchatProviderText5.1': '요청을 보내면 Snapchat에서 데이터 다운로드 준비를 시작합니다.',
	'conversationTypeSnapchatProviderText5.2': '보통 몇 시간에서 하루 정도 걸릴 수 있습니다.',
	'conversationTypeSnapchatProviderText5.3': '압축 파일이 준비되면 Snapchat에서 데이터 다운로드 링크가 담긴 이메일이 발송됩니다.',
	'conversationTypeSnapchatProviderText6.1': '이메일에 있는 링크를 눌러 다운로드 페이지로 이동하세요.',
	'conversationTypeSnapchatProviderText6.2': '데이터가 담긴 ZIP 파일을 다운로드하세요.',
	'conversationTypeSnapchatProviderText7.1': 'ZIP 파일을 다운로드한 뒤에는 열지 마세요.',
	'conversationTypeSnapchatProviderText7.2': 'ZIP 파일 전체를 그대로 지정된 영역에 올려 주세요.',
	'conversationTypeSnapchatProviderText7.3': '그다음 원하는 대화를 골라 책을 만들 수 있습니다.',
	conversationTypeSnapchatProviderTitle1: '1. Snapchat 설정 열기:',
	conversationTypeSnapchatProviderTitle2: '2. 데이터 요청:',
	conversationTypeSnapchatProviderTitle3: '3. 본인 인증:',
	conversationTypeSnapchatProviderTitle4: '4. 데이터 다운로드:',
	conversationTypeSnapchatProviderTitle5: '5. 이메일 기다리기:',
	conversationTypeSnapchatProviderTitle6: '6. 압축 파일 다운로드:',
	conversationTypeSnapchatProviderTitle7: '7. MonLivreSMS에서 데이터 추출 및 사용:',
	'conversationTypeTelegramProviderText1.1': 'https://desktop.telegram.org/에서 PC 또는 Mac용 Telegram 데스크톱 앱을 설치하세요.',
	'conversationTypeTelegramProviderText1.2': '컴퓨터에서 Telegram 앱을 여세요.',
	'conversationTypeTelegramProviderText2.1': '앱에서 책으로 만들고 싶은 대화 상대의 이름을 눌러 대화를 여세요.',
	'conversationTypeTelegramProviderText3.1': '대화 오른쪽 위의 점 세 개를 누르세요.',
	'conversationTypeTelegramProviderText3.2': '\'채팅 기록 내보내기\'를 선택하세요.',
	'conversationTypeTelegramProviderText4.1': '설정 창에서 원하는 파일 형식(사진, 동영상, 음성 메시지 등)을 모두 선택하세요.',
	'conversationTypeTelegramProviderText4.2': '필요하면 내보낼 파일의 최대 크기를 조정하세요.',
	'conversationTypeTelegramProviderText4.3': '창 아래의 \'내보내기\'를 누르세요.',
	'conversationTypeTelegramProviderText5.1': '내보낸 데이터를 찾아 ZIP 파일로 압축하세요(마우스 오른쪽 버튼 클릭 > 보내기 > 압축(ZIP) 폴더).',
	'conversationTypeTelegramProviderText6.1': 'ZIP 파일 전체를 업로드하세요',
	conversationTypeTelegramProviderTitle1: '1. Telegram 데스크톱 앱 설치:',
	conversationTypeTelegramProviderTitle2: '2. 대화 선택:',
	conversationTypeTelegramProviderTitle3: '3. 대화 기록 내보내기:',
	conversationTypeTelegramProviderTitle4: '4. 대화 내보내기 설정:',
	conversationTypeTelegramProviderTitle5: '5. ZIP 파일로 압축:',
	conversationTypeTelegramProviderTitle6: '6. MonLivreSMS에 업로드:',
	conversationTypeTitle: '{name} 대화로 책 만들기',
	conversationTypeWhatsappFileText1: 'WhatsApp 대화 가져오기',
	conversationTypeWhatsappFileText2: '\'미디어 첨부\' 선택',
	conversationTypeWhatsappFileText3: '대화 다운로드',
	conversationTypeWhatsappFileText4: '\'zip\' 형식이 아니면 압축해 주세요',
	conversationTypeWhatsappFileText5: '대화의 텍스트 내용만 필요하면 .txt 파일만 올려 주세요',
	conversationTypeWhatsappProviderText1: 'WhatsApp 대화 사본 내보내기',
	conversationTypeWhatsappProviderText2: '<strong>Android:</strong><br></br>WhatsApp 앱 열기<br></br>대화방으로 이동<br></br>\'기타\' 누르기',
	conversationTypeWhatsappProviderText3: '<strong>iOS:</strong><br></br>WhatsApp 앱 열기<br></br>대화방으로 이동<br></br>상단 메뉴 바에서 연락처 이름 또는 그룹 이름 누르기<br></br>맨 아래로 스크롤해 \'채팅 내보내기\' 선택',
	conversations: '대화',
	conversationsMy: '내 대화',
	conversationBackToList: '내 대화 목록으로 돌아가기',
	conversationsLuxEyebrow: '고객님의 이야기',
	conversationsLuxHint: '대화를 다시 찾아 아름다운 책으로 만들어 보세요.',
	ordersLuxEyebrow: '작업실',
	ordersLuxHint: '책을 찾고, 작업실에서 집까지의 여정을 따라가 보세요.',
	ordersLuxDetailTitle: '나의 책',
	ordersLuxDetailHint: '작업실에서 문 앞까지, 책의 여정을 따라가세요.',
	ordersLuxViewFollow: '내 책 따라가기',
	ordersLuxEmptyTitle: '첫 이야기가 기다리고 있어요.',
	ordersLuxEmptyHint: '대화를, 자꾸만 다시 펼치고 싶은 책으로 바꿔 보세요.',
	ordersLuxStepReceived: '접수',
	ordersLuxStepAtelier: '작업실',
	ordersLuxStepPrint: '인쇄',
	ordersLuxStepShipped: '배송 중',
	ordersLuxStepHome: '집으로',
	ordersLuxStoryPendingpayment: '결제가 완료되면 작업실에서 제작이 시작됩니다.',
	ordersLuxStoryPending: '주문을 받았습니다. 작업실에서 이미 준비하고 있습니다.',
	ordersLuxStoryOnpreparation: '책이 형태를 갖추고 있습니다. 한 장 한 장 정성껏 준비합니다.',
	ordersLuxStoryOnfabrication: '책을 인쇄하고 있습니다. 곧 작업실을 떠납니다.',
	ordersLuxStoryShipped: '책이 배송 중입니다. 고객님께로 향하고 있습니다.',
	ordersLuxStoryComplete: '책이 도착했습니다. 이제 손만 뻗으면 됩니다.',
	ordersLuxStoryCanceled: '이 주문은 취소되었습니다. 추억은 소중히 보관됩니다.',
	userProfileLuxEyebrow: '내 공간',
	userProfileLuxHint: '정보, 로그인 방법, 설정을 관리하세요.',
	userProfileValueEmpty: '입력되지 않음',
	userProfileNotLinked: '연결되지 않음',
	userProfileNewsletterOn: '이미 소식과 혜택을 받고 있습니다.',
	userProfilePasswordOn: '설정됨',
	addressesLuxEyebrow: '내 공간',
	addressesLuxHint: '배송지와 청구지 주소를 확인하세요.',
	addressesLuxEditHint: '이 주소는 배송 또는 청구에 사용할 수 있습니다.',
	conversationsNewApp: '앱의 새 대화',
	conversationsOldApp: '앱의 기존 대화',
	dashboardTitle: '대시보드',
	date: '날짜',
	dateActivated: '활성화 날짜',
	dateCreated: '생성 날짜',
	dateLastCguAccept: '최근 이용약관 동의 날짜',
	dateLastEdit: '최근 수정 날짜',
	dateLastLogin: '최근 로그인 날짜',
	dateSelect: '날짜 선택',
	dateSelectPlaceholder: '여기를 눌러 날짜를 선택하세요...',
	dateStatus: '상태 변경 날짜',
	dateValidation: '확정 날짜',
	dates: '날짜',
	days: '일',
	daysCount: '{count}{count, plural,\n		=0 {일}\n		=1 {일}\n		other {일}\n	}',
	delete: '삭제',
	deleteRequestError: '삭제 중 오류가 발생했습니다!',
	deleteRequestSuccess: '삭제되었습니다!',
	description: '설명',
	detailsInformation: '상세 정보',
	domain: '도메인',
	download: '다운로드',
	edit: '수정',
	editViewAdvanced: '고급 편집',
	editViewSimplified: '간편 편집',
	elementNoItems: '항목이 없습니다',
	elementsCount: '{count}{count, plural,\n			  =0 {개}\n			  =1 {개}\n			  other {개}\n		  }',
	example: '예시',
	examples: '예시',
	file: '파일',
	fileDeleteError: '이 파일을 삭제할 수 없습니다',
	fileDeleteSuccess: '파일이 삭제되었습니다!',
	fileSelected: '선택한 파일: {file}',
	fileSwitch: '파일 변경',
	fileUploadError: '이 파일을 업로드할 수 없습니다!',
	fileUploadProcessStartOnSave: '파일 업로드는 저장할 때 시작됩니다.',
	fileUploadRestrictionTypeError: '허용되지 않는 파일 형식입니다! 허용 형식: {types}',
	fileUploadSuccess: '파일이 업로드되었습니다!',
	files: '파일',
	filtersTitle: '필터',
	finish: '완료',
	flags: '플래그',
	free: '무료',
	generalInformation: '일반 정보',
	help: '도움말',
	hours: '시간',
	hoursCount: '{count}{count, plural,\n		=0 {시간}\n		=1 {시간}\n		other {시간}\n	}',
	imageDeleteError: '이 이미지를 삭제할 수 없습니다!',
	imageDeleteSuccess: '이미지가 삭제되었습니다!',
	imageUploadError: '이 이미지를 업로드할 수 없습니다',
	imageUploadRestrictionSize: '이미지는 최대 {format} 크기여야 합니다',
	imageUploadRestrictionType: '이미지는 {types} 형식이어야 합니다',
	imageUploadRestrictionTypeError: '허용되지 않는 이미지 형식입니다! 허용 형식: {types}',
	import: '가져오기',
	importModelDownloadButton: '템플릿 다운로드',
	importRequestError: '가져오는 중 오류가 발생했습니다!',
	importRequestSomeFailAlert: '하나 이상의 항목을 가져오지 못했습니다!',
	importRequestSuccess: '데이터를 가져왔습니다!',
	identifier: '식별자',
	importerFileButton: '데이터 가져오기',
	importerFileHelp: '스프레드시트 편집 소프트웨어(Excel, OpenOffice 등)로 CSV 파일을 만들 수 있습니다',
	importerFileInfo: 'CSV 파일(쉼표로 구분된 값)을 선택하세요',
	importerNoItemsAlert: '가져올 항목이 없습니다',
	importerTitle: '데이터 가져오기',
	information: '정보',
	informationsDetails: '상세 정보',
	informationsGeneral: '일반 정보',
	invoicePrint: '청구서 인쇄',
	invoicesPrint: '청구서 일괄 인쇄',
	isActive: '활성 여부',
	isPublic: '공개 여부',
	isUnlimited: '무제한 여부',
	label: '명칭',
	language: '언어',
	languageAR: '아랍어',
	languageBN: '벵골어',
	languageDE: '독일어',
	languageEN: '영어',
	languageES: '스페인어',
	languageFR: '프랑스어',
	languageHI: '힌디어',
	languageIT: '이탈리아어',
	languageJA: '일본어',
	languagePT: '포르투갈어',
	languageRU: '러시아어',
	languageZH: '중국어',
	learnMoreButton: '자세히 보기',
	limitLabel: '제한 유형',
	limitTextForm1: '제한 조건',
	listTitle: '목록',
	loading: '로딩 중...',
	loadMore: '더 보기…',
	copiedToClipboard: '복사되었습니다!',
	logo: '로고',
	minutes: '분',
	name: '이름',
	next: '다음',
	no: '아니요',
	of: '값',
	options: '옵션',
	order: '주문',
	orderAdd: '주문 추가',
	orderAddTitle: '주문 추가',
	orderAddressPrivacyInfo: '고객님의 주소는 공개되지 않습니다! 이 주문의 다른 참여자만 주소를 확인할 수 있습니다.',
	orderAddressShippingValid: '배송 주소 확인',
	orderBilling: '청구 정보',
	orderConfirmationPaymentError: '오류가 발생했습니다... 저희에게 문의해 주세요!',
	orderConfirmationPaymentWaiting: '잠시만 기다려 주세요... 주문 확정을 위해 결제를 처리하고 있습니다',
	orderConfirmationPaymentWaitingHint: '보통 몇 초면 완료됩니다.',
	orderConfirmationPendingText: '주문을 완료하려면 결제가 필요합니다! 아래 링크를 눌러 결제를 확정하고 주문을 마무리해 주세요.',
	orderConfirmationPendingText2: '주의: 신용카드로 결제하시는 경우 결제 승인에 시간이 걸릴 수 있습니다. 확인이 끝날 때까지 잠시 기다려 주세요.',
	orderConfirmationPendingTitle: '결제 대기 중인 주문입니다!',
	orderConfirmationOrderNumber: '주문 번호 {code}',
	orderConfirmationNextStepsTitle: '다음 단계는?',
	orderConfirmationStepEmail: '주문 확인 이메일',
	orderConfirmationStepEmailDesc: '{email}(으)로 주문 내역을 보내 드렸습니다',
	orderConfirmationStepEmailDescNoEmail: '주문 내역을 이메일로 보내 드립니다',
	orderConfirmationStepPreparation: '책 제작 준비',
	orderConfirmationStepPreparationDesc: '정성껏 인쇄하고 제본해 드립니다',
	orderConfirmationStepShipping: '배송',
	orderConfirmationStepShippingDesc: '택배가 발송되면 바로 이메일로 알려 드립니다',
	orderConfirmationSummaryTitle: '주문 내역',
	orderConfirmationViewOrderCta: '내 주문 조회',
	orderConfirmationHomeCta: '홈으로 돌아가기',
	orderConfirmationGuestTitle: '소식 받기',
	orderConfirmationSocialText: '자주 쓰시는 SNS에서 저희를 팔로우하고 최신 소식과 신제품, 때로는 할인 정보까지 받아 보세요...',
	orderConfirmationSocialTitle: '계속 소통해요!',
	orderConfirmationText: '주문이 접수되어 곧 준비를 시작합니다. 발송되면 이메일로 알려 드립니다.',
	orderConfirmationTitle: '주문이 접수되었습니다!',
	orderContent: '주문 내용',
	orderDetails: '상세 정보',
	orderId: '식별자',
	orderInfoCommentAlertTitle: '중요 안내',
	orderInvoice: '청구서',
	orderInvoicePrintButton: '청구서 인쇄',
	orderItemsEmpty: '주문에 상품이 없습니다',
	orderItemViewBook: '내 책 보기',
	orderItemsTotal: '상품 합계:',
	orderMassStatusConfirmMessage: '주문 {count}건의 상태를 변경하시겠습니까?',
	orderMassExportInvoiceDetails: '청구서 상세 내보내기',
	orderMassUpdateStatus: '상태 변경',
	orderMassSendEmail: '이메일 보내기',
	orderAdminListHint: '상태별로 주문을 확인하고 처리하세요. 필터를 사용하면 국가, 상품, 확정 날짜로 좁혀 볼 수 있습니다.',
	orderNoItems: '아직 주문 내역이 없습니다!',
	orderFlags: '플래그',
	orderNote: '메모',
	orderNoteCustomer: '고객 메모',
	orderNoteAdmin: '내부 메모(관리자)',
	orderNoteAdminAdd: '메모 추가',
	orderNoteAdminEmpty: '이 주문에는 내부 메모가 없습니다.',
	orderNoteAdminPlaceholder: '팀에게만 보이는 내부 메모입니다(배송, 고객지원…)',
	orderPaymentChooseMethodLabel: '결제 수단 선택',
	orderPaymentFinishTitle: '결제 완료하기',
	orderPaymentValidButton: '결제 확인',
	orderPaymentMethod: '결제 수단',
	orderPayments: '결제 내역',
	orderProcessInvitationText: '친구를 초대해 빈칸을 채워 보세요',
	orderProcessInvitationTextBefore1: 'Directos.eu는 개인 간 공동 구매 서비스로, 제조사에서 상품을 직접 구매할 수 있어요. 상품 가격은 물론 배송비까지 함께 아끼실 수 있어요!',
	orderProcessInvitationTextBefore2: '걱정하지 마세요! 해결 방법이 있어요:',
	orderPublicAccess: '공개 접근',
	orderProductAdd: '상품 추가',
	orderRefunds: '환불 내역',
	orderShipping: '배송',
	orderShippingAdd: '배송 추가',
	orderSendStatusNotificationEmail: '알림 이메일 보내기',
	orderShippingFee: '배송비',
	orderShippingRemoveConfirmMessage: '이 배송을 주문에서 삭제하시겠습니까?',
	orderShippingTrackingTitle: '주문 배송 조회',
	orderShippingTrackingButton: '배송 조회',
	orderShippingTrackingHint: '운송사에 추적 정보가 표시되기까지 몇 시간이 걸릴 수 있습니다.',
	orderShippings: '배송 내역',
	orderStatus: '상태',
	orderStatusCanceled: '취소됨',
	orderStatusComplete: '완료됨',
	orderStatusOnpreparation: '준비 중',
	orderStatusOnprogress: '진행 중',
	orderStatusPending: '대기 중',
	orderStatusPendingpayment: '결제 대기 중',
	orderStatusShipped: '발송됨',
	orderSubtotalDiscount: '할인',
	orderSubtotalExclTax: '소계(부가세 별도)',
	orderSubtotalInclTax: '소계(부가세 포함)',
	orderTax: '부가세',
	orderThanks: '주문해 주셔서 감사합니다',
	attributionPaidLine: '결제가 완료되었습니다',
	attributionSkip: '주문 보기',
	attributionSourceTitle: '이 책을 갖고 싶게 만든 건 무엇인가요?',
	attributionSourceLead: '주문은 이미 접수되었습니다. 마음에 남으신 점을 하나만 알려 주세요.',
	attributionSearchTitle: '검색하기 전에 MonLivreSMS를 이미 알고 계셨나요?',
	attributionSearchLead: '어디선가 들어 본 이름인지, 이번에 처음 아시게 된 이름인지.',
	attributionOccasionTitle: '이 책은 어떤 때를 위한 건가요?',
	attributionOccasionLead: '마음에 두고 계신 그 때.',
	attributionOtherPlaceholder: '원하시면 짧게 적어 주세요',
	attributionOtherContinue: '계속',
	attributionSaveError: '답변을 저장하지 못했습니다. 다시 시도해 주세요.',
	attributionOpt_bouche_a_oreille: '가까운 사람이 말해 주었습니다',
	attributionOpt_vu_objet: '누군가의 집에서 책을 보았습니다',
	attributionOpt_receveur_devenu_client: '선물 받아서, 이제 제 차례입니다',
	attributionOpt_recherche: 'Google에서 찾았습니다',
	attributionOpt_instagram: 'Instagram',
	attributionOpt_tiktok: 'TikTok',
	attributionOpt_facebook: 'Facebook',
	attributionOpt_pinterest: 'Pinterest',
	attributionOpt_qvema: 'Qui veut être mon associé',
	attributionOpt_medias: '기사, 방송, 팟캐스트',
	attributionOpt_client_existant: '여기서 주문한 적이 있습니다',
	attributionOpt_autre: '다른 이유',
	attributionOpt_decouverte_pure: '아무래도 우연',
	attributionOpt_pre_bao: '가까운 사람이 말해 준 적이 있습니다',
	attributionOpt_pre_tv: '텔레비전에서 본 적이 있습니다',
	attributionOpt_pre_social: 'SNS에서 본 적이 있습니다',
	attributionOpt_pre_inconnu: '잘 모르겠습니다',
	attributionOpt_anniv_couple: '만난 날의 기념',
	attributionOpt_noel: '크리스마스',
	attributionOpt_saint_valentin: '발렌타인데이',
	attributionOpt_anniversaire: '생일',
	attributionOpt_deuil: '떠나보낸 사람의 메시지',
	attributionOpt_naissance: '출산',
	attributionOpt_distance: '떠나는 사람, 또는 멀리 사는 사람',
	attributionOpt_pour_soi: '나를 위해, 선물이 아니라',
	attributionOpt_autre_occasion: '다른 순간',
	bookIntentTitle: '이 책은 어떤 날을 위한 건가요?',
	bookIntentLead: '하나만 고르면, 시작할 수 있어요.',
	bookIntentSkip: '지금은 아니에요',
	bookIntentOpt_anniv_couple: '우리가 만난 날의 기념',
	bookIntentOpt_anniversaire: '누군가의 생일',
	bookIntentOpt_noel: '크리스마스',
	bookIntentOpt_saint_valentin: '발렌타인데이',
	bookIntentOpt_souvenir: '이제 곁에 없는 사람',
	bookIntentOpt_plus_tard: '조금 더 나중',
	bookIntentOpt_autre: '다른 때',
	bookIntentDate_anniv_couple: '그 날이 언제인가요',
	bookIntentDateLead_anniv_couple: '만난 날, 또는 둘이 기념하는 날.',
	bookIntentDate_anniversaire: '생일이 언제인가요',
	bookIntentDateLead_anniversaire: '선물할 사람의 생일입니다.',
	bookIntentDate_plus_tard: '대략 언제인가요',
	bookIntentDateLead_plus_tard: '마음에 두고 있는 날.',
	bookIntentDateDefer: '날짜는 나중에 적을게요',
	bookIntentDateBack: '뒤로',
	bookIntentDateContinue: '계속',
	bookIntentSaveError: '답을 저장하지 못했습니다. 다시 시도해 주세요.',
	inboxPromptTitle: '책을 위해',
	inboxPromptSignup: '메일을 방금 보냈습니다. 「{subject}」입니다. 책의 시작이고, 광고는 아닙니다. {provider}에서 가끔 다른 칸으로 옮겨 둡니다. 「{mark}」로 바꿔 주세요. 그 한 번으로 다음 소식이 제대로 도착하고, 책을 잘 만드는 데 필요한 것이 손에 들어옵니다.',
	inboxPromptTransfer: '메일을 방금 보냈습니다. 「{subject}」입니다. 대화로 가는 링크이고, 광고는 아닙니다. {provider}에서 가끔 다른 칸으로 옮겨 둡니다. 「{mark}」로 바꿔 주세요. 그 한 번으로, 원하는 책을 만드는 데 필요한 것이 손에 들어옵니다.',
	inboxPromptMarkGmail: '스팸 해제',
	inboxPromptMarkYahoo: '스팸 해제',
	inboxPromptButton: '{provider}에서 확인',
	inboxPromptClose: '닫기',
	inboxPromptConfirm: '메일을 방금 보냈습니다. 「{subject}」입니다. 계정을 여는 메일입니다. {provider}에서 가끔 다른 칸으로 옮겨 둡니다. 「{mark}」로 바꿔 주세요. 그 한 번으로 다음 소식이 도착합니다.',
	emailConfirmPageTitle: '이메일 주소 확인',
	emailConfirmTitle: '메일을 확인해 주세요',
	emailConfirmLead: '계정을 여는 메일을 방금 보냈습니다. 안의 버튼으로 주소를 확인합니다.',
	emailConfirmResend: '메일 다시 보내기',
	emailConfirmResent: '메일을 다시 보냈습니다.',
	emailConfirmExpired: '이 링크는 만료되었습니다. 계정에서 새 링크를 요청해 주세요.',
	emailConfirmInvalid: '이 링크와 맞는 계정이 없습니다.',
	emailConfirmWorking: '계정을 여는 중입니다…',
	orderTotal: '총 합계',
	orderTotalTTC: '합계(부가세 포함)',
	orderTotalTax: '부가세 {rate}%',
	orderTotalToPay: '결제 총액: {total}€',
	orderTotals: '합계',
	orderUserRegisterAlert: '주문에 문제가 생겼을 때 연락드릴 수 있도록 이메일 주소를 입력해 주세요.',
	orderView: '주문 보기',
	orderViewShort: '주문',
	orderWeight: '무게',
	orderWeightHint: '합계 = 단위 무게 × 수량({quantity}개 → {weight} kg)',
	orderWeightHintPages: '페이지 기준 추정({grams} g/페이지): {pages}페이지 → {weight} kg',
	orderShippingManualFlag: '계약 중인 배송사로는 이 도착지(국가, 무게 또는 픽업 장소)에 맞출 수 없습니다. 아래에서 Sendcloud 방법을 선택한 뒤 운송장을 생성하세요.',
	shippingLegacyChronopostPaused: '이 주문은 이전 Chronopost 방식으로 남아 있습니다. 수정에서 배송 방법을 Sendcloud 상품으로 바꾼 뒤 운송장을 생성하세요.',
	orderShippingFedexPickupFlag: 'FedEx 발송: 집하는 파리 시간 18시~21시 사이, 다음 영업일로 자동 예약됩니다.',
	orderShippingFedexPickupBookedFlag: 'FedEx 집하가 {date}로 예약되었습니다(Sendcloud n°{id}).',
	orderitemAddProductTitle: '상품 정보 수정',
	orders: '주문',
	ordersEditSuccess: '주문이 수정되었습니다!',
	ordersContactTitle: '주문별 연락',
	ordersMy: '내 주문',
	ordersMyViewButton: '내 주문 보기',
	packingInformation: '포장 정보',
	parcelGroupInfo: '소포 개수 기준으로 묶기',
	parcelGroupLabel: '소포 그룹',
	parcelGroupWeightInfo: '소포 그룹당 kg',
	parcelGroupWeightLabel: '무게 기준으로 소포 묶기',
	paymentCardInputLabel: '주문을 완료하려면 신용카드 정보를 입력해 주세요.',
	paymentMethodCreditbalanceDescription1: '총액에서 자동 차감됩니다',
	paymentMethodCreditbalanceDescription2: '남은 결제 금액',
	paymentMethodCreditbalancePay: '크레딧으로 확인',
	paymentMethodCreditbalanceTitle: '크레딧 적용됨',
	paymentFailError: '결제가 완료되지 않았습니다! 다시 시도해 주세요',
	paymentMethod: '결제 수단',
	paymentMethodBancontactLabel: 'Bancontact',
	paymentMethodBankcheckLabel: '수표',
	paymentMethodBanktransferLabel: '계좌 이체',
	paymentMethodCardLabel: '신용카드',
	paymentMethodCreditcardLabel: '신용카드',
	paymentMethodCreditDescription1: '이 금액은 장바구니 총액 중 남은 결제 금액에서 자동으로 차감됩니다.',
	paymentMethodGiropayLabel: 'Giropay',
	paymentMethodIdealLabel: 'iDEAL',
	paymentMethodPhoneLabel: '전화',
	paymentMethodCreditPay: '적립금으로 결제',
	paymentMethodCreditTitle: '주문 금액의 일부를 이미 결제하셨습니다:',
	paymentValidButton: '결제 확인',
	previous: '이전',
	priceInformation: '가격 정보',
	priceRoundAlertTooltip: '환율 변환으로 인해 이 가격은 반올림될 수 있습니다',
	printButton: '인쇄',
	process: '프로세스',
	productAnnexes: '부록',
	productAnnexesNewProductError: '부록을 추가하기 전에 새 상품을 먼저 저장해 주세요!',
	productAttributes: '속성',
	product: '상품',
	productAdd: '상품 추가',
	productAdminListHint: '카탈로그와 가격, 스토어 판매 여부를 관리하세요.',
	productConversationTypeMissingAlert: '선택한 유형에 연결된 상품이 없습니다. 문제 해결을 위해 저희에게 문의해 주세요!',
	productCostHT: '원가(부가세 별도)',
	productDescription: '설명',
	productEdit: '상품 수정',
	productImages: '이미지',
	productImagesNewProductError: '이미지를 추가하기 전에 새 상품을 먼저 저장해 주세요!',
	productIsActive: '활성 여부',
	productName: '상품명',
	productPictureDelete: '이미지 삭제',
	productPriceHT: '가격(부가세 별도)',
	productPriceTTC: '가격(부가세 포함)',
	productReference: '상품 코드',
	productSlug: '슬러그',
	productSpecialPriceQuantityDiscountInfo: '{quantity}권을 추가하면 장바구니에서 {percent}% 절약할 수 있어요!',
	productTaxCalculate: '계산',
	productTaxRate: '세율',
	productTaxRateFormHelp: '세율이 20%인 경우 0.2를 입력하세요',
	productUseForConversationBook: '종이책 사용 여부',
	productUseForConversationEBook: '전자책 사용 여부',
	productUseForCredit: '사용자 적립금 사용 여부',
	products: '상품',
	productsView: '상품 보기',
	quantity: '수량',
	refresh: '새로 고침',
	refundCreateTitle: '환불 생성',
	refundCreateConfirmMessage: '이 환불을 생성하시겠습니까?',
	remove: '삭제',
	retry: '다시 시작',
	save: '저장',
	saveBeforeAlert: '먼저 저장해 주세요...',
	saveRequestError: '저장 오류!',
	saveRequestSuccess: '저장되었습니다!',
	saving: '저장 중...',
	searchFor: '검색',
	seconds: '초',
	select: '선택',
	selectAll: '전체 선택',
	selectFile: '파일 선택',
	selectImage: '이미지 선택',
	selectOptions: '옵션 선택',
	selectUnAll: '전체 선택 해제',
	seoOrderViewTitle: '주문번호 {code}',
	seoTitle: 'SMS와 대화를 책으로 인쇄',
	shippingAddressEdit: '배송 주소 수정',
	shippingAddressMissingError: '배송 주소가 입력되지 않았습니다.',
	shippingCalculation: '계산',
	shippingCalculationInfo: '계산이 반복될 경우 최대값 포함 조건을 사용하는 것이 좋습니다.',
	shippingCarrier: '택배사',
	shippingChronopostPickupError: '픽업 장소를 불러올 수 없습니다! 국가와 우편번호를 확인한 후 다시 시도해 주세요.',
	shippingChronopostPickupNoResult: '고객님 근처에서 픽업 장소를 찾지 못했습니다. 다른 주소로 검색해 주세요.',
	shippingChronopostPickupOpeningHours: '영업시간',
	shippingChronopostPickupOpeningHoursView: '영업시간 보기',
	shippingChronopostPickupViewList: '목록 보기',
	shippingChronopostPickupViewMap: '지도 보기',
	shippingPickupError: '픽업 장소 선택 창을 열 수 없습니다. 잠시 후 다시 시도해 주세요.',
	shippingPickupChange: '픽업 장소 변경',
	shippingPickupChoose: '픽업 장소 선택',
	shippingPickupSelectedHint: '픽업 장소를 선택했습니다. 결제를 이어가실 수 있습니다.',
	shippingPickupSelectedLabel: '픽업 장소',
	shippingPickupMapUnavailable: '이 픽업 장소는 지도를 표시할 수 없습니다. 목록 보기를 이용해 주세요.',
	shippingPickupNoResultHomeHint: '이 주소 근처에서 픽업 장소를 찾지 못했습니다. 다른 우편번호를 시도하거나, 위에서 집 배송을 선택해 주세요.',
	shippingPickupErrorHomeHint: '픽업 장소를 불러오지 못했습니다. 다시 시도하거나, 위에서 집 배송을 선택해 주세요.',
	shippingDeliveryApproxOn: '{date}경',
	shippingDeliveryApproxBetween: '{date1}부터 {date2} 사이',
	shippingCountrySelect: '배송 국가',
	shippingDeleteConfirmMessage: '이 배송 방법을 삭제하시겠습니까?',
	shippingDeliveryEstimationDate1: '예상 배송일: {date}',
	shippingDeliveryEstimationDate2: '예상 배송일: {date1} ~ {date2}',
	shippingDeliveryEstimationText: '예상 배송비입니다. 배송 장소는 다음 단계에서 선택하실 수 있습니다.',
	shippingSurchargeCorsica: '이 요금에는 코르시카 추가 요금 {price}이 포함되어 있습니다.',
	shippingSurchargeOverseas: '이 요금에는 해외 영토 추가 요금 {price}이 포함되어 있습니다.',
	shippingSurchargeRemote: '이 요금에는 배송 곤란 지역 추가 요금 {price}이 포함되어 있습니다.',
	shippingDeliveryTime: '배송 기간(일)',
	shippingDeliveryTimeInfo: '영업일 기준 {days}일 배송',
	shippingDescription: '설명',
	shippingExcludeDepartmentInfo: '제외할 우편번호를 쉼표(,)로 구분해 입력하세요. 와일드카드로는 "*"를 사용합니다',
	shippingExcludeDepartmentLabel: '우편번호 제외',
	shippingExtraFeeCalculation: '추가 배송비 계산',
	shippingExtraFeeLabel: '추가 배송비 라벨',
	shippingExtraFees: '추가 배송비',
	shippingFeeCalculatorTitle: '배송비 계산하기',
	shippingFeeFreeDelivery: '무료 배송',
	shippingFeeNotFoundError: '',
	shippingFeeWithBookResult: '지금 주문하시면 전자책은 몇 분 안에, 종이책은 {countryName} 지역으로 {deliveryDateFrom} ~ {deliveryDateTo} 사이에 받아보실 수 있습니다',
	shippingFeeWithoutBookResult: '지금 주문하시면 전자책을 몇 분 안에 받아보실 수 있습니다',
	shippingFreeStep: '무료 배송 단계',
	shippingFreeTreshold: '무료 배송 기준 금액',
	shippingFreeInfo: '{value} 이상 무료 배송',
	shippingIdentifier: '배송 식별자',
	shippingIsPriceTTC: '배송비 부가세 포함 여부',
	shippingLabelGenerateButton: '운송장 생성',
	shippingLabelGenerateButton2: '운송장 재생성',
	packingCheckTitle: '이 주문의 책',
	packingCheckHint: '책을 한 권씩, 뒷표지가 카메라를 향하게 보여 주세요. 숫자가 올라가면 책을 화면 밖에 두고 다음 책으로 넘어가세요.',
	packingCheckProgress: '{seen} / {expected}',
	packingCheckForeign: '이 책은 주문 {code}의 책입니다. 상자에서 빼 주세요.',
	packingCheckReady: '확인했습니다. 이 주문의 책이 맞습니다. 운송장을 인쇄할 수 있습니다.',
	packingCheckOverflow: '책이 너무 많이 읽혔습니다. 처음부터 다시 해 주세요.',
	packingCheckRestart: '다시 하기',
	packingCheckCameraStart: '카메라 열기',
	packingCheckCameraDenied: '카메라가 막혀 있습니다. 허용하거나 스캐너로 QR을 읽어 주세요.',
	packingCheckLocked: '운송장을 인쇄하기 전에 모든 책을 스캔해 주세요.',
	packingCheckWedgeLabel: '또는 스캐너로 QR 읽기',
	packingCheckLoading: '이 주문의 책을 불러오는 중입니다.',
	prepBooksCardTitle: '책',
	prepBooksCount: '{count}권',
	prepBooksPageEyebrow: '준비',
	prepBooksPageTitle: '주문 {code}',
	prepBooksPageHint: '이 상자에 들어가는 책입니다.',
	prepModeClient: '고객 화면',
	prepModePreparation: '준비 화면',
	shippingLabelGenerateError: '운송장을 만들지 못했습니다. 주소, 픽업 장소, Sendcloud 인증 정보를 확인한 뒤 다시 시도해 주세요.',
	shippingProviderSendcloudInfoDefault: '집 배송입니다. 제작은 약 2영업일(월~금, 프랑스 공휴일 제외) 후 운송사로 넘깁니다. 최종 운송사는 운송장 생성 시 정해집니다.',
	shippingProviderSendcloudPickupInfoDefault: '가까운 픽업 장소를 선택해 주세요. 제작은 약 2영업일(월~금, 프랑스 공휴일 제외) 후 발송됩니다. 최종 운송사는 운송장 생성 시 정해집니다.',
	shippingSendcloudMethodAuto: '자동(최적 방법)',
	shippingSendcloudMethodOverride: 'Sendcloud 운송사(운송장)',
	shippingSendcloudMethodOverrideHint: '자동으로 두거나, 운송장 생성 전에 다른 Sendcloud 방법을 지정할 수 있습니다.',
	shippingSendcloudPickLog: '사용한 Sendcloud 방법',
	shippingAdd: '배송 방법 추가',
	shippingAdminListHint: '배송에 사용할 택배사, 국가, 요금 규칙을 설정합니다.',
	shippingMethod: '배송 방법',
	shippingMethodCalculating: '배송비 계산 중...',
	shippingMethodConditions: '배송 조건',
	shippingMethodMissingAlert: '고객님의 장바구니에 적용할 수 있는 택배사가 없습니다. 배송 정보를 수정하여 택배사를 선택해 주세요',
	shippingMethodNotAvailable: '입력하신 주소로 이용 가능한 배송 방법이 없습니다...',
	shippingRatesError: '배송비 계산이 중간에 멈췄어요. 잠시 후 다시 시도해 주세요. 같은 일이 또 생기면 문의해 주세요. 함께 확인해 드릴게요.',
	shippingMethodPricing: '요금',
	shippingMethodPricingSystem: '요금 체계',
	shippingMethodSearch: '배송 방법 검색',
	shippingMethodSelectTitle: '배송 방법 선택',
	shippingGroupRelay: '픽업 장소',
	shippingGroupHome: '자택 배송',
	shippingTierClassic: '일반 배송',
	shippingTierExpress: '특급 배송',
	shippingTierClassicDesc: '표준 배송 기간',
	shippingTierExpressDesc: '가장 빠른 옵션',
	shippingTierPriceRelayFree: '픽업 장소 무료',
	shippingTierPriceRelayFrom: '픽업 장소 {price}부터',
	shippingTierPriceHomeFrom: '자택 배송 {price}',
	shippingChangeTier: '배송 속도 변경',
	shippingTierModeTitle: '배송 방식 선택',
	shippingStepOf: '{total}단계 중 {current}단계',
	shippingStepSpeedTitle: '언제 받으시겠어요?',
	shippingStepModeTitle: '어디로 받으시겠어요?',
	shippingMethodTrackingInfo: '배송 조회 정보',
	shippingMethods: '배송 방법',
	shippingOrder: '배송 순서',
	shippingProvider: '배송 제공업체',
	shippingStep: '단계',
	shippingStepInfo: '이 단계는 반드시 왼쪽 설정이어야 합니다! 위쪽 설정이 기본 우편번호입니다.',
	shippingStepLimitInfo: '왼쪽 조건이 최소값 또는 최대값입니까?',
	shippingTaxRate: '배송 부가세율',
	shippingTitle: '배송',
	shippingTrackingNumber: '운송장 번호',
	shippingTrackingParcelUrl: '배송 조회 URL',
	status: '상태',
	stepTitle: '{step}단계',
	submit: '제출',
	suborderitemAddProductTitle: '상품 추가',
	switchLanguage: '언어 변경',
	tableDownloadNoElementError: '다운로드할 항목이 없습니다!',
	tablePageSize: '페이지당',
	tableMassActions: '일괄 작업',
	tableRefreshSuccessAlert: '동기화되었습니다!',
	tableRefreshSuccessError: '동기화 오류!',
	tableSelection: '{count} {count, plural,\n			  =0 {선택됨}\n			  =1 {선택됨}\n			  other {선택됨}\n		  }',
	tag: '키워드',
	tagFillPlaceholder: '키워드를 입력하세요...',
	tags: '키워드',
	taskDescription: '설명',
	taskAddTitle: '작업 추가',
	taskEditTitle: '작업 수정',
	taskCountdownDate: '알림 날짜',
	taskAssignSelf: '나에게 할당',
	taskPriority: '우선순위',
	taxRate: '부가세',
	the: '',
	time: '시간',
	timezone: '시간대',
	title: '제목',
	toleranceLabel: '허용 오차',
	total: '합계',
	type: '유형',
	unit: '단위',
	user: '사용자',
	userAccountCreditsTitle: '내 크레딧 잔액',
	userAccountDataProtection: '개인정보 보호',
	userAccountDataProtectionText1: '저희는 고객님의 개인정보 보호를 매우 중요하게 생각합니다. 그래서 데이터를 안전하게 관리하며, 서비스 진행에 필요한 합리적인 기간 동안만 보관합니다.',
	userAccountDataProtectionText2: '서비스에 꼭 필요한 정보만 요청하며, 고객님의 동의 없이 제3자에게 제공하거나 상업적 목적으로 개인정보를 이용하지 않습니다.',
	userAccountDataProtectionText3: '개인정보 사본을 받거나 데이터 이동권을 행사하고 싶으시면 {email}로 문의해 주시기 바랍니다',
	userAccountDelete: '계정 삭제',
	userAccountDeleteActiveSuborder: '참여 중인 주문이 완료되기 전에는 계정을 삭제할 수 없습니다!',
	userAccountDeleteBlockText: '지금은 계정을 삭제할 수 없습니다!',
	userAccountDeleteButton: '계정 삭제',
	userAccountDeleteConfirmMessage: '계정을 영구적으로 삭제하시겠습니까?',
	userAccountDeleteConfirmTitle: '계정 삭제',
	userAccountDeleteError: '계정을 삭제할 수 없습니다!',
	userAccountDeleteSuccess: '계정이 삭제되었습니다! 다음에 또 뵙겠습니다!',
	userAccountDeleteText: '계정을 삭제하면 이 사이트에서 고객님의 정보에 접근할 수 없게 됩니다. 저희 데이터베이스에서 개인정보도 삭제됩니다. 이 작업은 되돌릴 수 없습니다!',
	userAccountEdit: '내 계정 수정',
	userAccountEditSuccess: '계정 정보가 업데이트되었습니다',
	userAccountExistError: '해당 이메일 주소로 등록된 계정이 없습니다!',
	userAccountExistTitle: '이미 계정이 있으신가요?',
	userAccountGeneral: '일반',
	userAccountHistory: '이용 내역',
	userAccountInfo: '고객님의 데이터는 안전하게 보호되며 철저히 비밀로 유지됩니다.',
	userAccountInfoMyTitle: '내 정보',
	userAccountMy: '내 계정',
	userAccountNote: '사용자 계정 메모',
	userAccountPersonnalInformation: '내 개인정보',
	userAccountPreferencesInformation: '내 환경설정',
	userAccountResetError: '계정 초기화 중 오류가 발생했습니다!',
	userAccountResetSuccess: '계정이 초기화되었습니다!',
	userActivityOnLine: '온라인',
	userAdd: '사용자 추가',
	userAddNew: '새 사용자 추가',
	userAdminListHint: '계정을 검색하고 활동을 확인하며 사용자 프로필이나 주문 내역으로 이동합니다.',
	userBridgeError: '앱에서의 로그인에 실패했습니다. 다시 시도해 주세요.',
	userBridgeInvalid: '이 로그인 링크는 더 이상 유효하지 않습니다. 앱에서 다시 시작해 주세요.',
	userBridgePending: '로그인 중…',
	userBridgeSuccess: '로그인되었습니다! 이제 앱으로 돌아가세요.',
	userChangePasswordSuccess: '비밀번호가 변경되었습니다!',
	userConfirmationCode: '이메일로 받은 인증 코드',
	userConfirmationCodeCheckButton: '비밀번호 재설정 코드를 받았습니다',
	userConfirmationCodeError: '인증 코드를 입력해 주세요! 이메일함을 확인해 보세요!',
	userConnectionInfo: '계정에 로그인해 주문을 확정하고 친구들을 초대해 함께 만들어 보세요!',
	userCredits: '크레딧',
	userCreditsBalancePositive: '사용 가능한 크레딧이 {amount} 있습니다. 다음 단계에서 자동으로 적용됩니다.',
	userCreditsPrepaymentInviteTitle: '책 선결제',
	userDeleteConfirmTitle: '사용자 삭제',
	userDeleteConfirmMessage: '이 사용자를 삭제하시겠습니까?',
	userDeleteConfirmation: '{user} 사용자가 삭제되었습니다!',
	userEdit: '{user} 수정',
	userEdit2: '사용자 수정',
	userEditPassword: '비밀번호 변경',
	userEmail: '이메일 주소',
	userEmailError: '이메일 주소가 올바르지 않습니다!',
	userEmailFillInfo: '이메일 주소를 입력하세요',
	userEmailFormInfo: '계속하려면 이메일 주소를 입력해 주세요',
	userEmailFormInfo2: '입력하신 이메일은 계정 생성과 주문 진행 상황 안내에 사용됩니다.',
	userLoginCodeTitle: '이미 계정이 있습니다',
	userLoginCodeIntro: '{email}(으)로 6자리 코드를 보내 드렸습니다. 계속하려면 여기에 코드를 입력해 주세요.',
	userLoginCodeLabel: '이메일로 받은 코드',
	userLoginCodeSubmit: '확인',
	userLoginCodeInvalid: '코드가 일치하지 않습니다. 가장 최근에 받은 이메일을 확인해 주세요.',
	userLoginCodeExpired: '이 코드는 더 이상 유효하지 않습니다. 아래에서 새 코드를 요청해 주세요.',
	userLoginCodeError: '죄송합니다. 문제가 발생했습니다. 잠시 후 다시 시도해 주세요.',
	userLoginCodeLinkHint: '같은 이메일에 로그인 링크도 들어 있습니다.',
	userLoginCodeResend: '새 코드 보내기',
	userLoginCodeResendIn: '{seconds}초 후 새 코드를 보낼 수 있습니다',
	userLoginCodeResent: '다시 보내 드렸습니다. 스팸함도 확인해 주세요.',
	userLoginCodeChangeEmail: '다른 이메일 사용하기',
	userLoginCodeCartSuccess: '로그인되었습니다. 이제 주문을 완료하실 수 있습니다.',
	userEnvironmentTestNoTest: '이 사용자는 환경 테스트를 진행한 적이 없습니다!',
	userFillPlaceholder: '사용자 이름을 입력하세요...',
	userFirstName: '이름',
	userForgotPassword: '비밀번호를 잊으셨나요?',
	userForgotPasswordRetryDateError: '비밀번호 재설정을 다시 요청하실 수 없습니다. 이메일함에서 인증 코드를 확인해 주시기 바랍니다.',
	userFormInfo: '프로필을 완성해 주세요',
	userGenderLabel: '성별',
	userIsActive: '활성 여부',
	userLastName: '성',
	userLogin: '로그인',
	userLoginAction: '로그인',
	userLoginEmailSelected: '{email} 이메일 주소로 로그인',
	userLoginError: '로그인 정보가 올바르지 않습니다. 다시 시도해 주십시오...',
	userLoginFirstButton: '첫 로그인이신가요?',
	userLoginFirstText: '이메일함에서 임시 비밀번호를 확인해 주세요. 첫 로그인에는 이 비밀번호를 사용하시고, 이후에 원하시는 비밀번호로 변경하실 수 있어요.',
	userLoginBenefit1: '클릭 몇 번으로 완성하는 SMS 포토북',
	userLoginBenefit2: '집 앞까지 빠른 배송',
	userLoginBenefit3: '100% 안전한 결제',
	userLoginIntro: '마이페이지를 이용하시려면 로그인해 주세요',
	userLoginWelcomeSubtitle: '고객님의 SMS를 아름다운 실물 포토북으로 만들어 보세요.',
	userLoginWelcomeTitle: '환영합니다!',
	userLoginNoConnexion: '로그인 이력 없음',
	userLoginTitle: '로그인',
	userLogout: '로그아웃',
	userName: '이름',
	userNewPassword: '새 비밀번호',
	userNewsletterSubscribeButton: '뉴스레터 구독',
	userNewsletterText1: '새로운 소식과 특가, 프로모션을 이메일로 바로 받아 보세요',
	userOldPassword: '현재 비밀번호',
	userOptions: '사용자 옵션',
	userPassword: '비밀번호',
	userPasswordConfirmation: '비밀번호 확인',
	userPasswordConfirmationError: '비밀번호와 비밀번호 확인이 일치하지 않습니다.',
	userPasswordConfirmationRestriction: '비밀번호 확인은 입력한 비밀번호와 동일해야 합니다',
	userPasswordEdit: '비밀번호 변경',
	userPasswordSet: '비밀번호 설정',
	userPasswordSetSuccess: '비밀번호가 저장되었습니다.',
	userSocialConnectionsTitle: '로그인 방법',
	userSocialContinueApple: 'Apple로 계속',
	userSocialContinueGoogle: 'Google로 계속',
	userSocialDivider: '또는',
	userSocialError: '로그인에 실패했습니다. 다시 시도해 주세요.',
	userSocialErrorNoEmail: 'Apple 계정에서 이메일을 제공하지 않았습니다. 다른 방법을 사용해 주세요.',
	userSocialErrorUnavailable: '이 로그인 방법은 아직 사용할 수 없습니다.',
	userSocialLinkApple: 'Apple 연결',
	userSocialLinkGoogle: 'Google 연결',
	userSocialLinkSuccess: '계정이 연결되었습니다.',
	userSocialLinked: '연결됨',
	userSocialUnlinkApple: 'Apple 연결 해제',
	userSocialUnlinkConfirm: '이 로그인 방법을 계정에서 해제할까요?',
	userSocialUnlinkGoogle: 'Google 연결 해제',
	userSocialUnlinkLastError: '마지막 로그인 방법을 해제하기 전에 비밀번호를 추가하세요.',
	userSocialUnlinkSuccess: '연결이 해제되었습니다.',
	userPasswordError: '올바른 비밀번호를 입력해 주십시오.',
	userPasswordResetText: '사용하실 비밀번호를 입력해 주세요. 확인란에 한 번 더 입력한 뒤 아래 버튼을 눌러 주세요.',
	userPasswordRestriction: '비밀번호는 6자 이상이어야 하며 숫자 1개와 특수문자 1개(@&!()$*€%)를 포함해야 합니다.',
	userPasswordRestrictionAlt: '비밀번호는 6자 이상이어야 합니다.',
	userPasswordTemporaryCheckButton: '임시 비밀번호를 받았습니다',
	userPhone: '전화번호',
	userPhoneError: '전화번호가 올바르지 않습니다.',
	userProfileMy: '내 프로필',
	userReInitPassword: '비밀번호 재설정',
	userRecoverFromOldAppCheckButton: '비밀번호 재설정 이메일을 받았습니다',
	userRecoverFromOldAppText: '고객님의 계정이 새 서비스로 이전되었습니다. 이메일함에서 비밀번호를 확인하고 새 계정을 활성화해 주세요.',
	userRegister: '계정 만들기',
	userRegisterError: '계정을 만들 수 없습니다. 이메일 주소를 확인한 뒤 다시 시도해 주십시오...',
	userRegisterSuccess: '축하합니다! 계정이 생성되었습니다. 임시 비밀번호가 담긴 이메일을 곧 보내 드립니다!',
	userRegisterSuccessEmailNotice: '확인 이메일을 {email} 주소로 보내 드렸습니다.',
	userRegisterSuccessEyebrow: '환영합니다',
	userRegisterSuccessPageTitle: '환영합니다!',
	userRegisterSuccessSourcesHint: '메시지가 저장된 앱을 선택해 주세요.',
	userRegisterSuccessSourcesTitle: '어디에서 시작할까요?',
	userRegisterSuccessStep1Desc: '가입 내역을 확인하실 수 있어요.',
	userRegisterSuccessStep1Title: '이메일함 확인하기',
	userRegisterSuccessStep2Desc: 'WhatsApp, Messenger, Instagram, iOS, Android 중에서 가져올 곳을 선택해 보세요.',
	userRegisterSuccessStep2Title: '메시지 가져오기',
	userRegisterSuccessStep3Desc: '표지, 색상, 사진까지 하나하나 원하는 대로 꾸며 보세요.',
	userRegisterSuccessStep3Title: '책 만들기',
	userRegisterSuccessStepsEyebrow: '이용 순서',
	userRegisterSuccessText: '계정이 준비되었어요. 몇 단계만 거치면 소중한 메시지가 오래 간직할 책으로 완성돼요.',
	userRegisterSuccessTitle: '고객님의 이야기가 여기에서 시작됩니다',
	userRegisterSuccessTitleNamed: '{firstName}님, 환영합니다!',
	userResetPasswordAccountButton: '계정 비밀번호 재설정',
	userResetPasswordAskSuccess: '이메일함에서 비밀번호 재설정 링크를 클릭해 주십시오.',
	userResetPasswordButton: '비밀번호 재설정',
	userResetPasswordError: '비밀번호를 재설정할 수 없습니다. 잠시 후 다시 시도해 주십시오...',
	userResetPasswordInfo: '비밀번호를 재설정할 수 있는 확인 링크를 이메일로 보내 드립니다.',
	userResetPasswordInfo2: '아래 항목을 입력해 비밀번호를 재설정해 주세요:',
	userResetPasswordSuccess: '비밀번호가 재설정되었습니다!',
	userRole: '역할',
	userRoleAdmin: '관리자',
	userRoleCustomer: '고객',
	userSearchLabel: '이메일 또는 사용자 이름을 입력하세요',
	userSendNewAccountEmail: '사용자에게 새 계정 이메일 발송',
	userSendNewAccountEmailSuccess: '사용자에게 안내 이메일을 보냈습니다!',
	userSwitch: '사용자 변경',
	userValidForgotPasswordError: '비밀번호 재설정 코드를 보낼 수 없습니다.',
	userValidForgotPasswordSuccess: '이메일함에서 인증 코드를 확인하여 비밀번호를 재설정해 주십시오.',
	users: '사용자',
	usersList: '사용자 목록',
	valid: '확인',
	vatExempt: '부가세 면세',
	vatRates: '국가별 부가가치세율',
	vatRatesAddCountry: '국가 추가',
	vatRatesAdminHint: '배송 국가마다 부가가치세율을 설정합니다. 고객이 내는 금액은 바뀌지 않습니다.',
	vatRatesEmpty: '설정된 국가가 없습니다. 모든 주문이 부가가치세 0%로 청구됩니다.',
	vatReport: '부가가치세 신고',
	vatReportAdminHint: '기간 동안 국가별로 청구한 부가가치세입니다. 신고 준비에 사용할 수 있습니다.',
	vatReportUnknownCountry: '국가 미상',
	vatRatesIntro: '적용 세율은 배송 국가입니다(디지털 상품만 있는 경우 청구지 국가). 결제 금액은 같고, 공급가액과 부가세의 구분만 바뀝니다.',
	vatRatesIntroFallback: '이 표에 없는 국가는 부가가치세 0%로 청구됩니다. 종이책, 전자책, 배송비에 같은 세율이 적용됩니다.',
	vatRatesInvalid: '{country}의 세율을 확인해 주세요. 0에서 100 사이의 퍼센트를 입력하세요.',
	vatRatesSaveSuccess: '부가가치세율을 저장했습니다.',
	vatRatesSimulation: '부가세 포함 가격 시뮬레이션',
	view: '보기',
	voucher: '할인 쿠폰',
	voucherAdd: '할인 쿠폰 추가',
	voucherAdminListHint: '할인 코드와 적용 조건, 사용 제한을 만들고 관리합니다.',
	voucherApplyButton: '적용',
	voucherApplyComplete: '할인 쿠폰은 더 이상 추가하실 수 없습니다.',
	voucherApplyFormLabel: '할인 코드',
	voucherApplyValidError: '이 할인 쿠폰은 주문에 적용할 수 없습니다.',
	voucherCode: '코드',
	voucherCodePlaceholder: '할인 코드를 입력하세요',
	voucherDeleteConfirmMessage: '이 할인 쿠폰을 삭제하시겠습니까?',
	voucherEdit: '할인 쿠폰 수정',
	voucherIsAuto: '자동 적용 여부',
	voucherIsCumulative: '중복 사용 여부',
	voucherIsPublic: '공개 여부',
	voucherNotExistsError: '존재하지 않는 할인 쿠폰입니다.',
	voucherPriority: '우선순위',
	voucherProductOffer: '제공 상품',
	voucherRemoveAllButton: '할인 코드 모두 삭제',
	vouchers: '할인 쿠폰',
	weight: '무게',
	yes: '예',
	you: '나',
	yourself: '나',
	userNewsletterTitle: '뉴스레터',
	userNewsletterSubscribeText: '새로운 상품과 프로모션, 추천 아이템을 보내 드려요',
	userNewsletterUnSubscribeButton: '뉴스레터 구독 해지',
	userOrdersView: '사용자 주문 보기',
	userCanCustomizeMessages: '메시지 편집 가능 여부',
	userLogAsUser: '사용자로 로그인',
	shippingMethodProviderData: '배송 제공업체 정보',
	productUseForCustomization: '맞춤 제작에 사용 여부',
	conversationBookFormat: '책 판형',
	conversationMessageSelect: '이 메시지 선택',
	conversationMessagesLuxEyebrow: '내 책',
	conversationMessagesLuxHint: '메시지를 검색하거나 숨기거나 수정해 보세요. 변경 사항은 선택하신 메시지에 적용됩니다.',
	conversationMessagesLuxSavePreview: '저장 · 미리보기로 돌아가기',
	conversationMessagesLuxBackPreview: '미리보기',
	conversationMessagesLuxCount: '선택한 메시지 {messages, number}건, 사진 {photos, number}장, 미디어 {medias, number}개',
	conversationMessagesFilterResults: '결과 {count, number}{count, plural, one {건} other {건}}',
	conversationMessagesOnlyHidden: '숨긴 메시지만',
	conversationMessagesResetFilters: '필터 초기화',
	conversationMessagesShowHidden: '숨긴 메시지 표시',
	conversationMessagesResetChanges: '모든 변경 사항 취소',
	conversationMessagesResetChangesButton: '전체 취소',
	conversationMessagesResetChangesConfirm: '대화가 처음 가져왔을 때의 상태로 복원됩니다. 숨기거나 수정하거나 추가한 메시지 등 모든 변경 사항이 완전히 사라집니다. 계속하시겠습니까?',
	conversationMediaTypePhotos: '사진',
	conversationMediaTypeVideos: '동영상',
	conversationMediaTypeAudios: '음성',
	conversationMediaTypeLinks: '링크',
	conversationMediaTypeOther: '기타',
	conversationMessagesToolSearch: '검색',
	conversationMessagesToolMedias: '미디어',
	conversationMessagesToolDates: '날짜',
	conversationMessagesToolHidePeriod: '기간 숨기기',
	conversationMessagesToolHidden: '표시',
	conversationMessagesToolReset: '변경 사항',
	conversationMessagesToolResetNone: '없음',
	conversationMessagesToolResetCount: '변경 {count, number}{count, plural, one {건} other {건}}',
	conversationMessagesHiddenViewHint: '아래 목록에 표시할 메시지를 선택하세요.',
	conversationMessagesHiddenViewAll: '전체',
	conversationMessagesHiddenViewVisible: '표시됨',
	conversationMessagesHiddenViewHidden: '숨김',
	conversationMessagesResetChangesHint: '대화를 처음 가져왔을 때의 상태로 되돌립니다. 숨기거나 수정하거나 추가한 메시지 등 모든 변경 사항이 사라집니다.',
	conversationMessagesToolSearchNone: '없음',
	conversationMessagesToolMediasAll: '모든 메시지',
	conversationMessagesToolDatesAll: '전체 기간',
	conversationMessagesToolHidePeriodNone: '기간 없음',
	conversationMessagesToolHiddenShown: '표시됨',
	conversationMessagesToolHiddenMasked: '숨김',
	conversationMessagesBestofCuratedHint: '베스트 오브가 이미 구성되어 최대 페이지 수까지 채워져 있어요. 메시지를 숨길 수 있고, 책이 길어지지 않는 범위에서 다른 메시지를 다시 표시할 수 있어요.',
	conversationMessagesBestofFullError: '베스트 오브가 이미 가득 찼어요. 이 메시지를 표시하려면 먼저 다른 곳에서 약 {pages, number}페이지를 숨겨 주세요.',
	conversationMessagesHidePeriodHint: '두 날짜 사이의 모든 메시지를 한 번에 숨기거나 다시 표시할 수 있어요.',
	conversationMessagesHidePeriodFrom: '시작일',
	conversationMessagesHidePeriodTo: '종료일',
	conversationMessagesHidePeriodCount: '이 기간의 메시지 {count, number}{count, plural, one {건} other {건}}(표시 {visible}건, 숨김 {hidden}건)',
	conversationMessagesHidePeriodConfirmHide: '이 기간의 메시지 {count, number}{count, plural, one {건} other {건}}을 숨기시겠습니까?',
	conversationMessagesHidePeriodConfirmShow: '이 기간의 메시지 {count, number}{count, plural, one {건} other {건}}을 다시 표시하시겠습니까?',
	conversationMessagesHidePeriodHide: '이 기간 숨기기',
	conversationMessagesHidePeriodShow: '이 기간 다시 표시하기',
	conversationMessagesHidePeriodItem: '기간 {index}',
	conversationMessagesHidePeriodAdd: '기간 추가',
	conversationMessagesHidePeriodInvalid: '종료일은 시작일 이후여야 합니다.',
	conversationMessagesToolHidePeriodCount: '기간 {count, number}{count, plural, one {개} other {개}}',
	conversationMessagesSearchPlaceholder: '단어나 이름을 검색하세요…',
	conversationMessagesEditTitle: '메시지 편집',
	conversationMessageSelectorDateFrom: '이 날짜 이후 메시지 선택',
	conversationMessageSelectorDateTo: '이 날짜 이전 메시지 선택',
	conversationTextSearch: '메시지 내용 검색',
	conversationOnlyMedias: '미디어만 표시',
	conversationMessagesSelectVisible: '이 페이지 선택',
	conversationMessagesSelectAllFiltered: '모두 선택 ({count, number}개)',
	unselect: '선택 해제',
	conversationMessagesEditHideSelected: '선택한 메시지 숨기기',
	conversationMessagesEditShowSelected: '선택한 메시지 표시',
	conversationMessagesEditTooManySelected: '선택한 메시지가 너무 많습니다',
	conversationNoMessages: '메시지 없음',
	conversationMessageEdit: '메시지 수정',
	conversationMessageAdd: '메시지 추가',
	conversationMessageInsert: '여기에 메시지 삽입',
	conversationMessageEditSelect: '이 메시지 선택',
	conversationMessageEditUnselect: '이 메시지 선택 해제',
	conversationMessageHiddenAlert: '이 메시지는 숨김 처리되어 인쇄되는 책에는 나오지 않습니다.',
	conversationMessageSetUnVisibleButton: '인쇄되는 책에서 이 메시지 숨기기',
	conversationMessageSetVisibleButton: '메시지 다시 표시',
	conversationMessagesEditEnableButton: '맞춤 편집 활성화',
	conversationMessagesEditEnableButton2: '{price}에 맞춤 편집 활성화',
	conversationMessagesEditDisableAlert: '메시지를 맞춤 편집하시려면 결제 후 기능을 활성화하셔야 합니다.',
	conversationMessageDateHint: '날짜와 시간을 바꿔 이 메시지를 대화에서 원하는 위치에 둘 수 있습니다.',
	conversationMessageSender: '보낸 사람',
	conversationMessageSenderPlaceholder: '보낸 사람 선택',
	conversationMessageSenderRequiredHint: '저장하려면 이 메시지를 보내는 사람을 선택하세요.',
	conversationMessageAnnotation: '주석',
	conversationMessageAnnotationNoMedia: '주석에는 사진, 동영상, 오디오를 첨부할 수 없습니다.',
	conversationMessageText: '내용',
	conversationMessageTextPlaceholder: '내용을 입력하세요',
	conversationMessageAttachments: '첨부 파일',
	conversationMessageMediaLabel: '사진, 동영상 또는 오디오',
	conversationMessageMediaDragDrop: '사진, 동영상 또는 오디오 파일을 여기에 끌어다 놓으세요',
	conversationMessageMediaTapSelect: '탭하여 사진, 동영상 또는 오디오를 선택하세요',
	conversationMessageMediaOpenFinder: '파일 선택',
	conversationMessageMediaPickSenderFirst: '사진, 동영상 또는 오디오를 추가하려면 먼저 보낸 사람을 선택하세요.',
	conversationMessageHiddenLabel: '메시지 숨김 여부',
	conversationGenerate: '책 생성',
	conversationVerify: '검증 강제 실행',
	conversationLaunchButton: '프로덕션에서 실행',
	conversationViewButton: '대화 보기',
	reset: '초기화',
	cmsLinkColor: '버튼 색상',
	cmsLinkNeedObfuscate: '난독화 필요 여부',
	cmsImageUseForMobile: '모바일 표시용 여부',
	contentEditPage: '페이지 수정',
	cmsRedirectionAdd: '리디렉션 추가',
	cmsContentEdit: '콘텐츠 수정',
	cmsPageIsActive: '활성 여부',
	cmsContentTypeLabel: '콘텐츠 유형',
	cmsContentModelLabel: '콘텐츠 템플릿',
	cmsContentTitle: '제목',
	cmsContentSlug: '슬러그',
	cmsPanelIsTemplate: '템플릿 포함 여부',
	cmsPageSeoTitle: 'SEO 제목',
	cmsPageSeoDescription: 'SEO 설명',
	cmsPageSeoKeywords: 'SEO 키워드',
	cmsPageSeoHideOnSitemap: '사이트맵에서 숨기기',
	cmsPageSeoUseCustomTitleSuffix: '사용자 지정 제목 접미사 사용',
	cmsPageSeoTitleSuffix: '제목 접미사',
	affiliation: '제휴',
	affiliationInvoiceTotalAdminTitle: '지급할 총액(부가세 포함)',
	conversationImportLuxEyebrow: '고객님의 이야기',
	conversationImportLuxTagline: '고객님이 직접 만드는 세상에 하나뿐인 선물. 다른 누구도 대신할 수 없어요.',
	conversationImportLuxPrivacy: '고객님의 메시지는 안전하게 보호돼요. 선택하신 대화만 사용해요.',
	conversationImportProgressExport: '내보내기',
	conversationImportProgressUpload: '업로드',
	conversationImportProgressCustomize: '맞춤 설정',
	conversationImportUploadSuccess: '압축 파일을 받았어요. 다음 단계에서 대화를 선택해 주세요',
	conversationImportUploadSuccessSingle: '파일을 받았어요. 이어서 책을 꾸며 보세요',
	conversationImportContinueSingle: '계속하기',
	conversationImportSelectionTitleSingle: '고객님의 대화',
	conversationImportSelectionHintSingle: '파일에서 대화 1개를 찾았어요.',
	conversationImportSelectionHintMultiple: '책으로 만들 대화를 선택해 주세요. 검색으로 목록을 좁힐 수 있어요.',
	conversationImportSelectionListCount: '대화 {total}개 중 {shown}개',
	conversationImportSelectionNoMatch: '검색과 일치하는 대화가 없어요.',
	conversationImportStepPickThread: '대화 선택',
	conversationImportStepMedia: '사진 옵션',
	conversationImportStepTerms: '이용약관 동의',
	conversationImportExtrasLockedHint: '위에서 대화를 선택하시면 이 옵션을 사용할 수 있어요.',
	conversationImportPickThreadBeforeTerms: '계속하시기 전에 위에서 대화를 선택해 주세요.',
	conversationImportChangeThread: '다른 대화 선택',
	conversationImportSelectionConfirmedHint: '좋아요. 이제 아래에서 책을 꾸며 보세요.',
	conversationImportOptionsTitle: '사진과 추억',
	conversationImportOptionsHint: '모든 항목이 기본으로 포함돼요. 넣고 싶지 않은 항목만 체크를 해제해 주세요.',
	conversationImportOptionsImagesLabel: '사진과 이미지',
	conversationImportOptionsImagesDesc: '대화 속 사진이 책에 인쇄돼요.',
	conversationImportOptionsMediasLabel: '동영상, 음성, GIF',
	conversationImportOptionsMediasDesc: '책에 인쇄되는 QR 코드로 보실 수 있어요 (10년 보관 무료).',
	conversationImportOptionsTransferNote: '사진 개수에 따라 전송에 몇 분이 걸릴 수 있어요. 이 페이지를 벗어나지 말아 주세요.',
	conversationImportOptionsNoMedia: '파일에 사진이나 미디어가 없어요. 책에는 메시지만 담겨요.',
	conversationImportAgreementRead: '이용약관 확인하기',
	conversationImportCreateBook: '내 책 만들기',
	conversationImportSelectToContinue: '계속하시려면 대화를 선택해 주세요.',
	conversationImportAcceptTermsToContinue: '계속하시려면 이용약관 동의란에 체크해 주세요.',
	conversationImportDropHint: '.zip 파일을 여기에 끌어다 놓으세요. 또는',
	conversationImportDropFormats: '전체 .zip 파일 권장: 압축을 풀지 마세요 (사진과 미디어 포함)',
	conversationImportJsonOnlyHint: '.json 파일만 올리시면 사진과 미디어는 포함되지 않아요. 사진이 담긴 책을 원하시면 전체 .zip은 풀지 말고 그대로 올려 주세요. 브라우저가 이미 압축을 풀었다면 \'messages\' 폴더를 .zip으로 압축해 주세요.',
	conversationInstagramImportIntro: 'Instagram 메시지를 가져오는 3단계:',
	conversationInstagramImportDemoTitle: 'Instagram 메시지 내보내기',
	conversationInstagramImportDemoExportMeta: '기기로 내보내기 · JSON',
	conversationInstagramImportDemoDownloadsAvailable: '사용 가능한 다운로드',
	conversationInstagramImportDemoStartExport: '내보내기 시작',
	conversationInstagramImportDemoCustomizeMessages: '메시지만',
	conversationInstagramImportDemoCustomize: '정보 맞춤 설정',
	conversationInstagramImportDemoConfirmTitle: '내보내기 확인',
	conversationInstagramImportDemoSave: '저장',
	conversationInstagramImportDemoMessagesTip: '선택 사항이지만 더 빠름: 모두 지운 뒤 메시지만.',
	conversationInstagramImportDemoDataPayments: '결제',
	conversationInstagramImportDemoDataComments: '댓글',
	conversationInstagramImportDemoClearAll: '모두 지우기',
	conversationInstagramImportDemoActivitySection: 'Instagram 활동',
	conversationInstagramImportDemoPickSpecific: '내보낼 특정 정보 선택',
	conversationInstagramImportDemoExportExternal: '외부 서비스로 내보내기',
	conversationInstagramImportDemoExportDevice: '내 기기로 내보내기',
	conversationInstagramImportDemoChooseDestination: '내보낼 위치 선택',
	conversationInstagramImportDemoProfileAccount: '내 계정 · Instagram',
	conversationInstagramImportDemoProfileName: '내 계정 이름',
	conversationInstagramImportDemoAccountShort: '내 계정',
	conversationInstagramImportDemoProfiles: '프로필',
	conversationInstagramImportDemoChooseProfile: '프로필 선택',
	conversationInstagramImportDemoPastActivity: '지난 활동',
	conversationInstagramImportDemoCurrentActivity: '진행 중 활동',
	conversationInstagramImportDemoCreateExport: '내보내기 만들기',
	conversationInstagramImportDemoExportIntro: '기기에 다운로드할 정보 사본을 만듭니다.',
	conversationInstagramImportDemoExportTitle: '정보 내보내기',
	conversationInstagramImportDemoCaptionStart: '내보내기 시작을 누르세요',
	conversationInstagramImportDemoCaptionDevice: '내 기기로 내보내기를 누르세요',
	conversationInstagramImportDemoCaptionProfile: 'Instagram 프로필을 선택하세요',
	conversationInstagramImportDemoCaptionCreate: '내보내기 만들기를 누르세요',
	conversationInstagramImportDemoCaptionMessages: '팁: 모두 지우기 후 메시지만(더 빠름)',
	conversationInstagramImportDemoCaptionJson: 'JSON 형식을 고르고 저장',
	conversationInstagramImportDemoCaptionDrop: '준비되면 .zip을 받아 아래에 올리세요',
	conversationInstagramImportDemoPlatform: 'Instagram',
	conversationInstagramImportDemoDataMessages: '메시지',
	conversationInstagramImportDemoFormat: '형식',
	conversationInstagramImportDemoMediaQuality: '미디어 품질',
	conversationInstagramImportDemoQualityLow: '낮음',
	conversationInstagramImportDemoJsonNotice: '책에는 JSON이 필요합니다. HTML은 안 됩니다.',
	conversationInstagramImportDemoReadyHint: '압축을 풀지 말고 전체 .zip을 아래에 올리세요. 대화는 나중에 고릅니다.',
	conversationInstagramImportCta: 'Instagram 설정 열기',
	conversationInstagramImportStep1: '<b>내보내기 만들기</b>를 누르고 <b>Instagram</b> 프로필을 고른 뒤 <b>내 기기로 내보내기</b>를 선택하세요.',
	conversationInstagramImportStep2: '더 빠른 팁: <b>모두 지우기</b> 후 <b>메시지</b>만 체크. <b>JSON</b> 형식과 <b>낮음</b> 미디어 품질을 선택하세요.',
	conversationInstagramImportStep3: '<b>내보내기 시작</b>을 누르고 이메일을 기다린 뒤(10분~24시간) <b>.zip</b>을 <b>압축을 풀지 말고</b> 아래에 올리세요. 대화는 <b>나중에</b> 고릅니다.',
	conversationInstagramImportAlert: '<b>JSON</b> 형식 필수(HTML 불가). 팁: <b>메시지</b>만 내보내면 더 빠르지만 필수는 아닙니다.',
	conversationInstagramImportDetailTitle: 'Instagram 내보내기: 상세 가이드',
	conversationInstagramImportDetailIntro: '아래 스크린샷을 따라 하세요. 위 버튼으로 내보내기 페이지를 바로 열 수 있습니다.',
	conversationInstagramImportDetailSkipApp: '버튼으로 페이지를 열었어요. 5단계부터 시작하기',
	conversationInstagramImportDetailStep1: '<b>Instagram</b> 앱을 열고 오른쪽 위 점 세 개를 눌러 <b>설정</b>으로 이동하세요.',
	conversationInstagramImportDetailStep2: '<b>계정 센터</b>를 선택하세요.',
	conversationInstagramImportDetailStep3: '<b>내 정보 및 권한</b>을 누르세요.',
	conversationInstagramImportDetailStep4: '<b>내 정보 다운로드</b>를 선택하세요.',
	conversationInstagramImportDetailStep5: '<b>정보 다운로드 또는 전송</b>으로 이동하세요. 위 버튼을 사용하셨다면 이미 이 페이지에 있어요.',
	conversationInstagramImportDetailStep6: '<b>Instagram</b>을 선택하세요. 계정에 따라 이 단계가 나오지 않을 수도 있어요.',
	conversationInstagramImportDetailStep7: '<b>일부 정보</b>를 선택하세요.',
	conversationInstagramImportDetailStep8: '아래로 내려 <b>메시지</b>를 체크한 뒤 <b>다음</b>을 누르세요.',
	conversationInstagramImportDetailStep9: '<b>기기에 다운로드</b>를 누르세요.',
	conversationInstagramImportDetailStep10: '원하는 기간을 고르고 형식은 <b>JSON</b>, 미디어 화질은 <b>낮음</b>으로 선택하시면 더 빠르게 다운로드돼요.',
	conversationInstagramImportDetailStep11: '압축 파일은 <b>10분에서 24시간</b> 안에 준비돼요. 준비되면 이메일로 알려 드리고, 계정 센터 페이지에서도 확인하실 수 있어요.',
	conversationInstagramImportDetailStep12: '전체 <b>.zip</b> 파일을 기기에 다운로드한 뒤 <b>압축을 풀지 말고</b> 아래에 올려 주세요. 이후 선택하신 대화만 책에 사용돼요.',
	conversationKakaotalkImportIntro: '먼저 휴대폰에서 시작하세요. iPhone인가요, Android인가요?',
	conversationKakaotalkImportPlatformIphone: 'iPhone',
	conversationKakaotalkImportPlatformAndroid: 'Android',
	conversationKakaotalkImportIphoneStep1: 'iPhone에서 <b>KakaoTalk</b>을 열고 책으로 만들 채팅방에 들어가세요.',
	conversationKakaotalkImportIphoneStep2: '오른쪽 위 <b>메뉴</b>(☰)를 눌러 채팅방 서랍을 열고, 아래쪽 <b>채팅방 설정</b>(톱니바퀴) 아이콘을 누르세요.',
	conversationKakaotalkImportIphoneStep3: '<b>대화 내용 내보내기</b>를 누른 뒤 <b>텍스트 메시지만 보내기</b>를 선택하세요.',
	conversationKakaotalkImportIphoneStep4: '<b>.txt</b> 파일을 저장하고(파일에 저장, 이메일, AirDrop), <b>수정하지 말고</b> 아래에 올려 주세요.',
	conversationKakaotalkImportAndroidStep1: '휴대폰에서 <b>KakaoTalk</b>을 열고 책으로 만들 채팅방에 들어가세요.',
	conversationKakaotalkImportAndroidStep2: '오른쪽 위 <b>메뉴</b>(☰)를 눌러 채팅방 서랍을 열고, 아래쪽 <b>채팅방 설정</b>(톱니바퀴) 아이콘을 누르세요.',
	conversationKakaotalkImportAndroidStep3: '<b>대화 내용 내보내기</b>를 누른 뒤 <b>텍스트 메시지만 보내기</b>를 선택하세요.',
	conversationKakaotalkImportAndroidStep4: '<b>.txt</b> 파일을 저장하고(파일 앱, Google Drive, 이메일), <b>수정하지 말고</b> 아래에 올려 주세요.',
	conversationKakaotalkImportAlert: '한 번에 대화 하나씩 내보낼 수 있어요. 다른 옵션인 \'모든 메시지 내보내기\'는 사진까지 저장하지만, KakaoTalk이 사진을 메시지와 연결해 주지 않아요. 텍스트만 선택하시면 사진은 \'사진\'이라는 글자로만 표시돼요.',
	conversationKakaotalkImportDesktopNote: 'PC(Windows 또는 Mac)에서는 채팅방 메뉴를 열고 <b>대화 내용 저장</b>을 누르세요. 이렇게 받은 <b>.txt</b> 파일도 여기서 사용하실 수 있어요.',
	conversationLineImportIntro: '먼저 휴대폰에서 시작하세요. iPhone인가요, Android인가요?',
	conversationLineImportPlatformIphone: 'iPhone',
	conversationLineImportPlatformAndroid: 'Android',
	conversationLineImportIphoneStep1: 'iPhone에서 <b>LINE</b>을 열고 책으로 만들 채팅방에 들어가세요.',
	conversationLineImportIphoneStep2: '채팅방 위쪽의 <b>메뉴</b>(☰) → <b>설정</b>을 차례로 누르세요.',
	conversationLineImportIphoneStep3: '<b>대화 내용 전송</b>을 누른 뒤 파일을 보낼 방법을 선택하세요 (파일에 저장, 이메일, AirDrop).',
	conversationLineImportIphoneStep4: '<b>.txt</b> 파일을 저장한 뒤 <b>수정하지 말고</b> 아래에 올려 주세요.',
	conversationLineImportAndroidStep1: '휴대폰에서 <b>LINE</b>을 열고 책으로 만들 채팅방에 들어가세요.',
	conversationLineImportAndroidStep2: '채팅방 위쪽의 <b>메뉴</b>(☰) → <b>설정</b>을 차례로 누르세요.',
	conversationLineImportAndroidStep3: '<b>대화 내용 전송</b>을 누른 뒤 파일을 보낼 방법을 선택하세요 (파일 앱, Google Drive, 이메일).',
	conversationLineImportAndroidStep4: '<b>.txt</b> 파일을 저장한 뒤 <b>수정하지 말고</b> 아래에 올려 주세요.',
	conversationLineImportAlert: '한 번에 대화 하나씩 내보낼 수 있어요. 채팅방에 현재 보이는 메시지만 저장되며, LINE은 사진과 스티커를 이미지로 내보내지 않아요.',
	conversationLineImportDesktopNote: 'PC(Windows 또는 Mac)에서는 <b>채팅</b>을 열고 대화방을 더블클릭한 뒤, 위쪽 <b>메뉴</b> → <b>대화 내용 저장</b>을 이용하세요. Chrome용 LINE에는 이 기능이 없어요.',
	conversationLinkedinImportIntro: 'LinkedIn 대화를 가져오는 3단계:',
	conversationLinkedinImportCta: 'LinkedIn 데이터 내보내기 페이지 열기',
	conversationLinkedinImportStep1: '<b>웹 브라우저</b>(PC 또는 휴대폰)에서 위 페이지를 여세요. 또는 <b>나</b> → <b>설정 및 개인정보</b> → <b>데이터 개인정보</b> → <b>데이터 복사본 가져오기</b> 순서로 이동하세요.',
	conversationLinkedinImportStep2: '<b>메시지</b>가 포함된 아카이브를 요청하세요. <b>메시지</b> 파일을 체크하거나 전체 아카이브를 선택한 뒤 <b>아카이브 요청</b>을 클릭하세요.',
	conversationLinkedinImportStep3: 'LinkedIn 이메일에서 <b>.zip</b>을 다운로드하고(10분에서 24시간 소요), <b>압축을 풀지 말고</b> 아래에 올려 주세요. 대화는 업로드 <b>후</b>에 선택하시면 돼요.',
	conversationLinkedinImportAlert: '이 기능은 LinkedIn 모바일 앱에는 없어요. 웹 브라우저를 이용해 주세요. 아카이브에는 <b>messages.csv</b> 파일이 들어 있어야 해요 (LinkedIn은 사진과 첨부 파일을 내보내지 않아요).',
	conversationSnapchatImportIntro: 'Snapchat 대화를 가져오는 3단계:',
	conversationSnapchatImportCta: 'Snapchat 내 데이터 열기',
	conversationSnapchatImportStep1: '앱에서 프로필 아바타를 누르고 설정(톱니바퀴) → <b>개인정보 보호</b> → <b>내 데이터</b> 순서로 이동하세요. 위 링크를 이용하셔도 돼요.',
	conversationSnapchatImportStep2: '필요하면 로그인한 뒤 페이지 아래쪽의 <b>내 데이터 제출</b>을 누르세요. 압축 파일이 준비되면 Snapchat이 이메일로 알려 줘요 (몇 시간에서 하루 정도).',
	conversationSnapchatImportStep3: '이메일에서 <b>.zip</b>을 다운로드하고 <b>압축을 풀지 말고</b> 아래에 올려 주세요. 대화는 업로드 <b>후</b>에 선택하시면 돼요.',
	conversationSnapchatImportAlert: '전체 <b>.zip</b> 파일이 반드시 필요해요. 압축을 풀지 마세요. 메시지는 책에 인쇄되지만, Snapchat 내보내기에는 인쇄할 수 있는 사진이 들어 있지 않아요.',
	conversationSnapchatPlaceholderMedia: '[미디어]',
	conversationSnapchatPlaceholderNote: '[음성 노트]',
	conversationSnapchatPlaceholderSticker: '[스티커]',
	conversationSnapchatPlaceholderSnap: '[Snap]',
	conversationSnapchatPlaceholderAudio: '[오디오]',
	conversationSnapchatStatusParticipantAdded: '그룹에 멤버가 추가되었습니다',
	conversationSnapchatStatusNameChanged: '그룹 이름이 변경되었습니다',
	conversationSnapchatStatusConversationCreated: '대화가 생성되었습니다',
	conversationSnapchatStatusGeneric: 'Snapchat 알림',
	conversationSnapchatImportPartialContent: '{total}개 중 텍스트가 있는 메시지는 {withText}개입니다. Snapchat은 저장되지 않은 메시지의 본문을 내보내지 않습니다.',
	conversationSnapchatImportDetailTitle: 'Snapchat 내보내기: 상세 가이드',
	conversationSnapchatImportDetailIntro: '아래 화면 캡처를 보며 단계를 그대로 따라 해 보세요. 위 버튼으로 내 데이터를 바로 열고 4단계부터 시작하실 수도 있어요.',
	conversationSnapchatImportDetailSkipApp: '버튼으로 페이지를 열었어요. 4단계부터 시작하기',
	conversationSnapchatImportDetailStep1: '<b>Snapchat</b>을 열고 프로필 사진을 누르세요.',
	conversationSnapchatImportDetailStep2: '<b>톱니바퀴</b> 아이콘을 눌러 설정을 여세요.',
	conversationSnapchatImportDetailStep3: '아래로 내려 <b>계정 작업</b>까지 이동한 뒤 <b>내 데이터</b>를 누르세요. 위 버튼을 이용하셔도 돼요.',
	conversationSnapchatImportDetailStep4: '<b>채팅 기록</b>을 체크하고 <b>JSON</b>과 <b>HTML</b> 형식을 선택한 뒤 <b>다음</b>을 누르세요.',
	conversationSnapchatImportDetailStep5: '원하는 기간을 고르고 이메일 주소를 확인한 뒤 <b>내 데이터 제출</b>을 누르세요.',
	conversationSnapchatImportDetailStep6: '내보내기가 끝나면 Snapchat이 이메일로 알려 줘요. 몇 시간에서 며칠까지 걸릴 수 있어요.',
	conversationSnapchatImportDetailStep7: '이메일을 받으시면 링크를 눌러 데이터 페이지로 이동하세요.',
	conversationSnapchatImportDetailStep8: 'Snapchat에서 <b>내보내기 보기</b>를 누른 뒤 <b>다운로드</b>를 누르세요.',
	conversationSnapchatImportDetailStep9: '전체 <b>.zip</b> 파일을 기기에 다운로드한 뒤 <b>압축을 풀지 말고</b> 아래에 올려 주세요. 이후 선택하신 대화만 책에 사용돼요.',
	conversationTelegramImportIntro: 'Telegram 대화를 내보내는 4단계:',
	conversationTelegramImportCta: 'Telegram Desktop 다운로드',
	conversationTelegramImportStep1: 'PC에서는 <b>Telegram Desktop</b>을 설치하세요. Mac에서는 App Store의 « Telegram » 앱을 쓰지 말고, 위 링크에서 <b>Telegram Desktop</b>을 받으세요(App Store에서는 Telegram Lite라는 이름입니다). 그다음 책으로 만들 대화방을 여세요.',
	conversationTelegramImportStep2: '오른쪽 위 <b>점 세 개</b> → <b>채팅 기록 내보내기</b>를 클릭하세요.',
	conversationTelegramImportStep3: '<b>사진, 동영상, 파일</b>을 체크하고 형식은 <b>JSON</b>을 선택하세요(HTML도 받을 수 있습니다). <b>내보내기</b>를 클릭하고 다운로드가 끝날 때까지 기다리세요.',
	conversationTelegramImportStep4: '내보낸 폴더를 <b>.zip</b>으로 압축한 뒤(마우스 오른쪽 클릭 → 압축), <b>압축을 풀지 말고</b> 아래에 올려 주세요. 옵션은 업로드 <b>후</b>에 확인하시면 돼요.',
	conversationTelegramImportAlert: '한 번에 대화 하나만 가져올 수 있어요. 사진이 들어간 책을 원하신다면 내보내기에 <b>미디어</b>를 포함해 주세요. 받으신 <b>.zip</b> 파일 전체를 그대로 올려 주세요.',
	conversationTelegramImportDetailTitle: 'Telegram 내보내기: 자세한 가이드',
	conversationTelegramImportDetailIntro: '아래 스크린샷을 보면서 각 단계를 따라 해 보세요. 위 버튼으로 Telegram Desktop을 다운로드하시거나, 이미 설치되어 있다면 2단계로 바로 넘어가세요.',
	conversationTelegramImportDetailSkipApp: 'Telegram Desktop이 이미 설치되어 있어요: 2단계부터 시작',
	conversationTelegramImportDetailStep1: 'PC에서는 <b>Telegram Desktop</b>이 맞는 앱입니다. Mac에서는 위 링크에서 <b>Telegram Desktop</b>을 받으세요. App Store의 « Telegram » 앱으로는 대화를 내보낼 수 없습니다. App Store에서 맞는 프로그램 이름은 <b>Telegram Lite</b>입니다.',
	conversationTelegramImportDetailStep2: '책으로 만들고 싶은 <b>대화</b>를 여세요.',
	conversationTelegramImportDetailStep3: '오른쪽 위 <b>점 세 개</b>를 클릭한 다음 <b>채팅 기록 내보내기</b>를 선택하세요.',
	conversationTelegramImportDetailStep4: '<b>모든 파일 형식</b>(사진, 동영상, 음성 메시지 등)을 체크하고, 최대 파일 크기를 <b>1500MB</b>로 올린 다음 <b>JSON</b> 형식을 선택하세요. 형식 선택이 없으면 HTML 내보내기도 받을 수 있습니다.',
	conversationTelegramImportDetailStep5: '오른쪽 아래의 <b>내보내기</b>를 클릭하면 내보내기가 시작됩니다.',
	conversationTelegramImportDetailStep6: '휴대폰에서 요청이 뜨면 <b>허용</b>을 누르세요. 내보낸 폴더를 <b>.zip</b>으로 압축한 다음, <b>압축을 풀지 말고</b> 그대로 아래에 올려 주세요. 옵션은 업로드한 뒤에 선택하시면 됩니다.',
	conversationImportDetectedPlatform: '{platform}용 단계입니다. 다른 선택도 그대로 고를 수 있습니다.',
	conversationWhatsappImportIntro: '먼저 휴대폰에서 시작하세요. iPhone인가요, Android인가요?',
	conversationWhatsappImportPlatformIphone: 'iPhone',
	conversationWhatsappImportPlatformAndroid: 'Android',
	conversationWhatsappImportIphoneStep1: '대화를 열고 상단 <b>이름</b>을 탭한 뒤 <b>채팅 내보내기</b>를 누르세요.',
	conversationWhatsappImportIphoneStep2: '책에 사진을 넣을 경우 <b>미디어 포함</b>을 선택하세요(텍스트만이면 미디어 없음).',
	conversationWhatsappImportIphoneStep3: '<b>파일</b>에 저장한 뒤 <b>.zip</b>을 <b>압축을 풀지 말고</b> 아래에 올려주세요.',
	conversationWhatsappImportIphoneStep4: '사진이 들어간 책을 원하신다면 <b>미디어 첨부</b>, 메시지만 담으시려면 <b>미디어 없이</b>를 선택하세요. 파일을 컴퓨터나 휴대폰에 저장한 다음, <b>압축을 풀지 말고</b> 아래에 올려 주세요.',
	conversationWhatsappImportAndroidStep1: '채팅을 연 뒤 <b>⋮</b> → <b>기타</b> → <b>채팅 내보내기</b>를 누르세요.',
	conversationWhatsappImportAndroidStep2: '책에 사진을 넣으려면 <b>미디어 첨부</b>(텍스트만이면 <b>미디어 없이</b>).',
	conversationWhatsappImportAndroidStep3: '파일을 저장하거나 공유한 뒤 <b>압축을 풀지 말고</b> 아래에 <b>.zip</b>을 올리세요.',
	conversationWhatsappImportAndroidStep4: '파일을 저장하고(파일, Google Drive 또는 이메일), 컴퓨터나 휴대폰으로 옮긴 다음 <b>압축을 풀지 말고</b> 아래에 올려 주세요.',
	conversationWhatsappImportAlert: '내보내기당 대화 하나. 일러스트 책에는 <b>미디어 포함</b>을 권장합니다. 전송이 끝날 때까지 이 페이지에 머무르세요.',
	conversationWhatsappImportAlertAndroid: '내보내기당 대화 하나. <b>미디어 첨부</b>를 권장합니다. 일부 폰은 이메일만 됩니다: 그때는 <b>미디어 없이</b>. 전송이 끝날 때까지 이 페이지에 머무르세요.',
	conversationWhatsappImportIphoneDetailTitle: 'iPhone에서 WhatsApp 내보내기: 자세한 가이드',
	conversationWhatsappImportIphoneDetailIntro: '아래 스크린샷을 보면서 iPhone에서 각 단계를 따라 하신 다음, 파일을 컴퓨터나 휴대폰으로 옮기고 나서 여기에 올려 주세요.',
	conversationWhatsappImportIphoneDetailStep1: '<b>WhatsApp</b>을 실행한 다음 책으로 만들고 싶은 대화를 여세요.',
	conversationWhatsappImportIphoneDetailStep2: '화면 위쪽의 <b>연락처 또는 그룹 이름</b>을 누르세요.',
	conversationWhatsappImportIphoneDetailStep3: '<b>채팅 내보내기</b>가 보일 때까지 화면 맨 아래로 내려 주세요.',
	conversationWhatsappImportIphoneDetailStep4: '<b>채팅 내보내기</b>를 누르세요.',
	conversationWhatsappImportIphoneDetailStep5: '사진이 들어간 책을 원하신다면 <b>미디어 첨부</b>, 메시지만 담으시려면 <b>미디어 없이</b>를 선택하세요.',
	conversationWhatsappImportIphoneDetailStep6: '파일을 컴퓨터나 휴대폰에 저장한 다음(예: 파일 앱), <b>압축을 풀지 말고</b> 아래에 올려 주세요.',
	conversationWhatsappImportAndroidDetailTitle: 'Android에서 WhatsApp 내보내기: 자세한 가이드',
	conversationWhatsappImportAndroidDetailIntro: '아래 스크린샷을 보면서 Android에서 각 단계를 따라 하신 다음, 파일을 컴퓨터나 휴대폰으로 옮기고 나서 여기에 올려 주세요.',
	conversationWhatsappImportAndroidDetailStep1: '<b>WhatsApp</b>을 실행한 다음 책으로 만들 대화를 여세요.',
	conversationWhatsappImportAndroidDetailStep2: '<b>⋮</b>(오른쪽 위) → <b>기타</b> → <b>채팅 내보내기</b>를 누르세요.',
	conversationWhatsappImportAndroidDetailStep3: '사진을 함께 담으려면 <b>미디어 첨부</b>, 메시지만 담으려면 <b>미디어 없이</b>를 선택하세요.',
	conversationWhatsappImportAndroidDetailStep4: '파일을 저장하고(파일, Google Drive 또는 이메일), 컴퓨터나 휴대폰으로 옮긴 다음 <b>압축을 풀지 말고</b> 아래에 올려 주세요.',
	conversationWhatsappImportDemoTitle: 'WhatsApp 대화 내보내기',
	conversationWhatsappImportDemoIndividual: '개인 채팅',
	conversationWhatsappImportDemoGroup: '그룹 채팅',
	conversationWhatsappImportDemoCaptionOpen: 'WhatsApp에서 대화를 여세요',
	conversationWhatsappImportDemoCaptionTapName: '상단 이름을 탭하세요',
	conversationWhatsappImportDemoCaptionExport: '아래로 스크롤한 뒤 채팅 내보내기',
	conversationWhatsappImportDemoCaptionMedia: '책 사진용으로 미디어 포함을 선택하세요',
	conversationWhatsappImportDemoCaptionSave: '파일에 저장한 뒤 아래에 올리세요',
	conversationWhatsappImportDemoExportLabel: '채팅 내보내기',
	conversationWhatsappImportDemoMediaNotice: 'Attach Media creates a larger archive, ideal for an illustrated book.',
	conversationWhatsappImportDemoAttachMedia: '미디어 포함',
	conversationWhatsappImportDemoWithoutMedia: '미디어 없음',
	conversationWhatsappImportDemoSaveFiles: '파일에 저장',
	conversationWhatsappImportDemoA11y: '애니메이션 안내: 대화 열기, 이름 탭, 내보내기, 미디어 포함, 파일에 저장.',
	conversationWhatsappImportDemoCaptionExportGroup: '⋯ 메뉴를 연 뒤 채팅 내보내기',
	conversationWhatsappImportDemoContactName: 'Léa',
	conversationWhatsappImportDemoContactMom: '엄마',
	conversationWhatsappImportDemoGroupName: '주말 모임',
	conversationWhatsappImportDemoGroupWork: 'Work : design',
	conversationWhatsappImportDemoChats: '채팅',
	conversationWhatsappImportDemoHeaderSubContact: 'tap here for contact info',
	conversationWhatsappImportDemoHeaderSubGroup: 'tap here for group info',
	conversationWhatsappImportDemoGroupsInCommon: 'Groups in common',
	conversationWhatsappImportDemoSeeAll: 'See all ›',
	conversationWhatsappImportDemoAddFavorite: 'Add to Favorites',
	conversationWhatsappImportDemoAddList: 'Add to a list',
	conversationWhatsappImportDemoClearChat: '채팅 비우기',
	conversationWhatsappImportDemoBlock: 'Block',
	conversationWhatsappImportDemoParticipants: '{count} participants',
	conversationWhatsappImportDemoAudio: 'Audio',
	conversationWhatsappImportDemoVideo: 'Video',
	conversationWhatsappImportDemoAdd: 'Add',
	conversationWhatsappImportDemoSearch: 'Search',
	conversationWhatsappImportDemoMemberYou: 'You',
	conversationWhatsappImportDemoMemberAlex: 'Alex',
	conversationWhatsappImportDemoMemberCamille: 'Camille',
	conversationWhatsappImportDemoEditGroup: 'Edit group info',
	conversationWhatsappImportDemoEditDescription: 'Edit description',
	conversationWhatsappImportAndroidDemoIncludeMedia: '미디어 첨부',
	conversationWhatsappImportAndroidDemoWithoutMedia: '미디어 없이',
	conversationWhatsappImportAndroidDemoMediaNotice: '일러스트 책에는 미디어 첨부. 미디어 없이가 더 가볍습니다.',
	conversationWhatsappImportAndroidDemoClear: '채팅 지우기',
	conversationWhatsappImportAndroidDemoExport: '채팅 내보내기',
	conversationWhatsappImportAndroidDemoReport: '신고',
	conversationWhatsappImportAndroidDemoMore: '기타',
	conversationWhatsappImportAndroidDemoWallpaper: '배경화면',
	conversationWhatsappImportAndroidDemoMute: '알림 끄기',
	conversationWhatsappImportAndroidDemoOnline: '온라인',
	conversationWhatsappImportAndroidDemoCaptionSave: '저장하거나 공유한 뒤 아래에 올리세요',
	conversationWhatsappImportAndroidDemoCaptionMedia: '책 사진용으로 미디어 첨부를 선택하세요',
	conversationWhatsappImportAndroidDemoCaptionExport: '기타, 이어서 채팅 내보내기',
	conversationWhatsappImportAndroidDemoCaptionMenu: '오른쪽 위 메뉴를 누르세요',
	conversationWhatsappImportAndroidDemoCaptionOpen: 'WhatsApp에서 대화를 여세요',
	conversationWhatsappImportAndroidDemoTitle: 'Android에서 WhatsApp 대화 내보내기',
	conversationWhatsappImportAndroidDemoShareHint: '그다음 .zip은 풀지 말고 아래에 올리세요.',
	conversationWhatsappImportAndroidDemoFiles: '파일',
	conversationWhatsappImportAndroidDemoShareVia: '보내기…',
	conversationMessengerImportIntro: '먼저 <b>2023년 이후</b>부터 시작하세요. 암호화된 채팅은 Messenger.com에 있습니다. 없으면 <b>2023년 이전</b>으로 전환하세요.',
	conversationMessengerImportContext: '2023년 이전에 시작된 대화는 암호화를 켠 뒤에도 이어질 수 있습니다. 그러면 Messenger가 기록을 두 개의 아카이브로 나눕니다. 둘 다 가져온 다음 대화 목록에서 하나로 합치세요.',
	conversationMessengerImportPlatformClassic: '2023년 이전',
	conversationMessengerImportPlatformEncrypted: '2023년 이후',
	conversationMessengerImportClassicCta: 'Meta를 열어 내보내기',
	conversationMessengerClassicImportDemoReadyHint: '압축을 풀지 말고 전체 .zip을 아래에 올리세요. 대화는 나중에 고릅니다.',
	conversationMessengerClassicImportDemoExportMeta: '기기로 내보내기 · JSON',
	conversationMessengerClassicImportDemoDownloadsAvailable: '사용 가능한 다운로드',
	conversationMessengerClassicImportDemoStartExport: '내보내기 시작',
	conversationMessengerClassicImportDemoQualityLow: '낮음',
	conversationMessengerClassicImportDemoMediaQuality: '미디어 품질',
	conversationMessengerClassicImportDemoCustomizeMessages: '메시지만',
	conversationMessengerClassicImportDemoCustomize: '정보 맞춤 설정',
	conversationMessengerClassicImportDemoConfirmTitle: '내보내기 확인',
	conversationMessengerClassicImportDemoJsonNotice: '책에는 JSON이 필요합니다. HTML은 안 됩니다.',
	conversationMessengerClassicImportDemoFormat: '형식',
	conversationMessengerClassicImportDemoSave: '저장',
	conversationMessengerClassicImportDemoMessagesTip: '선택 사항이지만 더 빠름: 모두 지운 뒤 메시지만.',
	conversationMessengerClassicImportDemoDataMessages: '메시지',
	conversationMessengerClassicImportDemoDataPayments: '결제',
	conversationMessengerClassicImportDemoDataComments: '댓글',
	conversationMessengerClassicImportDemoClearAll: '모두 지우기',
	conversationMessengerClassicImportDemoPickSpecific: '내보낼 특정 정보 선택',
	conversationMessengerClassicImportDemoExportExternal: '외부 서비스로 내보내기',
	conversationMessengerClassicImportDemoExportDevice: '내 기기로 내보내기',
	conversationMessengerClassicImportDemoChooseDestination: '내보낼 위치 선택',
	conversationMessengerClassicImportDemoAccountShort: '내 계정',
	conversationMessengerClassicImportDemoProfileName: '내 계정 이름',
	conversationMessengerClassicImportDemoProfiles: '프로필',
	conversationMessengerClassicImportDemoChooseProfile: '프로필 선택',
	conversationMessengerClassicImportDemoPastActivity: '지난 활동',
	conversationMessengerClassicImportDemoCurrentActivity: '진행 중 활동',
	conversationMessengerClassicImportDemoCreateExport: '내보내기 만들기',
	conversationMessengerClassicImportDemoExportIntro: '기기에 다운로드할 정보 사본을 만듭니다.',
	conversationMessengerClassicImportDemoExportTitle: '정보 내보내기',
	conversationMessengerClassicImportDemoCaptionDrop: '준비되면 .zip을 받아 아래에 올리세요',
	conversationMessengerClassicImportDemoCaptionStart: '내보내기 시작을 누르세요',
	conversationMessengerClassicImportDemoCaptionJson: 'JSON 형식을 고르고 저장',
	conversationMessengerClassicImportDemoCaptionMessages: '팁: 모두 지우기 후 메시지만(더 빠름)',
	conversationMessengerClassicImportDemoCaptionDevice: '내 기기로 내보내기를 누르세요',
	conversationMessengerClassicImportDemoCaptionCreate: '내보내기 만들기를 누르세요',
	conversationMessengerClassicImportDemoActivitySection: 'Facebook 활동',
	conversationMessengerClassicImportDemoProfileAccount: '내 계정 · Facebook',
	conversationMessengerClassicImportDemoPlatform: 'Facebook',
	conversationMessengerClassicImportDemoCaptionProfile: 'Facebook 프로필을 선택하세요',
	conversationMessengerClassicImportDemoTitle: '2023년 이전 Messenger 대화 내보내기',
	conversationMessengerEncryptedImportDemoTitle: '2023년 이후 Messenger 대화 내보내기',
	conversationImportDemoBadgeMeta: '예시: 위 버튼으로 Meta에서 같은 작업을 하세요',
	conversationMessengerEncryptedImportDemoBadge: '예시: 위 버튼으로 Messenger.com에서 같은 작업을 하세요',
	conversationMessengerEncryptedImportDemoCaptionLogin: '컴퓨터에서 Messenger.com을 열고 로그인하세요',
	conversationMessengerEncryptedImportDemoCaptionSettings: '왼쪽 아래의 톱니바퀴를 클릭하세요',
	conversationMessengerEncryptedImportDemoCaptionPrivacy: '개인정보 보호 및 보안을 여세요',
	conversationMessengerEncryptedImportDemoCaptionEncrypted: '종단간 암호화 대화를 선택하세요',
	conversationMessengerEncryptedImportDemoCaptionStorage: '메시지 저장소를 여세요',
	conversationMessengerEncryptedImportDemoCaptionDownloadData: '메시지 저장소 데이터 다운로드를 클릭하세요',
	conversationMessengerEncryptedImportDemoCaptionRange: 'Media 선택을 유지하고 기간은 All time을 고르세요',
	conversationMessengerEncryptedImportDemoCaptionDrop: '파일 다운로드를 클릭한 뒤 .zip을 아래에 놓으세요',
	conversationMessengerEncryptedImportDemoLandingTitle: '흥미로운 대화를 위한 공간',
	conversationMessengerEncryptedImportDemoLandingText: 'Messenger로 소중한 사람들과 계속 연락할 수 있습니다.',
	conversationMessengerEncryptedImportDemoContinueAs: '내 이름으로 계속하기',
	conversationMessengerEncryptedImportDemoSwitchAccount: '계정 전환',
	conversationMessengerEncryptedImportDemoChats: '채팅',
	conversationMessengerEncryptedImportDemoSearch: 'Messenger에서 검색',
	conversationMessengerEncryptedImportDemoContactName: '내 연락처',
	conversationMessengerEncryptedImportDemoContactStatus: '활동 중',
	conversationMessengerEncryptedImportDemoLockBadge: '종단간 암호화',
	conversationMessengerEncryptedImportDemoMenuPreferences: '환경설정',
	conversationMessengerEncryptedImportDemoMenuProfileName: '프로필 이름 수정',
	conversationMessengerEncryptedImportDemoMenuRestricted: '제한된 계정',
	conversationMessengerEncryptedImportDemoMenuAccessibility: '접근성',
	conversationMessengerEncryptedImportDemoMenuHelp: '고객 센터',
	conversationMessengerEncryptedImportDemoPrivacyTitle: '개인정보 보호 및 보안',
	conversationMessengerEncryptedImportDemoPrivacyReceipts: '읽음 확인',
	conversationMessengerEncryptedImportDemoPrivacyReported: '신고한 대화',
	conversationMessengerEncryptedImportDemoPrivacyKeys: '대화의 키 확인',
	conversationMessengerEncryptedImportDemoEncryptedTitle: '종단간 암호화 대화',
	conversationMessengerEncryptedImportDemoEncryptedHint: '종단간 암호화 대화 설정을 관리합니다',
	conversationMessengerEncryptedImportDemoEncryptedAlerts: '보안 알림',
	conversationMessengerEncryptedImportDemoEncryptedPreviews: '미리보기',
	conversationMessengerEncryptedImportDemoStorageTitle: '메시지 저장소',
	conversationMessengerEncryptedImportDemoStorageHint: '대화 기록을 저장하고 여는 방식을 관리합니다',
	conversationMessengerEncryptedImportDemoStorageIntro: '종단간 암호화된 메시지는 백업에 안전하게 저장됩니다.',
	conversationMessengerEncryptedImportDemoStoragePin: 'PIN 코드 재설정',
	conversationMessengerEncryptedImportDemoStorageMethods: '보안 방법 관리',
	conversationMessengerEncryptedImportDemoStorageRemember: '이 브라우저 기억하기',
	conversationMessengerEncryptedImportDemoStorageDownload: '메시지 저장소 데이터 다운로드',
	conversationMessengerEncryptedImportDemoStorageDownloadHint: '종단간 암호화된 모든 메시지와 첨부 파일을 다운로드합니다.',
	conversationMessengerEncryptedImportDemoStorageAutoImport: '자동 가져오기 끄기',
	conversationMessengerEncryptedImportDemoDownloadTitle: '내 데이터 다운로드',
	conversationMessengerEncryptedImportDemoDownloadIntro: '종단간 암호화된 모든 메시지와 첨부 파일의 사본을 언제든지 다운로드할 수 있습니다.',
	conversationMessengerEncryptedImportDemoMediaTip: 'Media 선택을 유지하세요. 해제하면 책에 사진이 들어가지 않습니다.',
	conversationMessengerEncryptedImportDemoFileNotice: '파일 준비에는 몇 분이 걸릴 수 있습니다.',
	conversationMessengerEncryptedImportDemoDownloadFile: '파일 다운로드',
	conversationMessengerEncryptedImportDemoReadyHint: '.zip 파일을 열지 않고 그대로 아래에 놓으세요. 대화는 그다음에 선택합니다.',
	conversationMessengerImportEncryptedCta: 'Messenger.com을 열어 내보내기',
	conversationMessengerImportClassicStep1: '<b>내보내기 만들기</b>를 누르고 <b>Facebook</b> 프로필을 고른 뒤 <b>내 기기로 내보내기</b>를 선택하세요.',
	conversationMessengerImportClassicStep2: '더 빠른 팁: <b>모두 지우기</b> 후 <b>메시지</b>만 체크. <b>JSON</b> 형식과 <b>낮음</b> 미디어 품질을 선택하세요.',
	conversationMessengerImportClassicStep3: '<b>내보내기 시작</b>을 누르고 이메일을 기다린 뒤(10분~24시간) <b>.zip</b>을 <b>압축을 풀지 말고</b> 아래에 올리세요. 대화는 <b>나중에</b> 고릅니다.',
	conversationMessengerImportClassicAlert: '대화가 없나요? <b>2023년 이후</b>로 전환하세요. <b>JSON</b> 형식 필수(HTML 불가). 팁: <b>메시지</b>만 내보내면 더 빠르지만 필수는 아닙니다.',
	conversationMessengerImportEncryptedStep1: '컴퓨터에서 <b>Messenger.com</b>을 열고 로그인한 뒤, 왼쪽 아래의 <b>톱니바퀴</b>를 클릭하세요.',
	conversationMessengerImportEncryptedStep2: '<b>개인정보 보호 및 보안</b>, <b>종단간 암호화 대화</b>, <b>메시지 저장소</b> 순서로 이동하세요.',
	conversationMessengerImportEncryptedStep3: '<b>메시지 저장소 데이터 다운로드</b>를 클릭하세요. <b>Media</b> 선택을 유지하고 기간은 <b>All time</b>을 고르세요.',
	conversationMessengerImportEncryptedStep4: '<b>파일 다운로드</b>를 클릭한 뒤 <b>.zip</b>을 <b>열지 않고</b> 아래에 놓으세요. 대화는 <b>업로드 후</b>에 선택합니다.',
	conversationMessengerImportEncryptedAlert: '<b>Media</b> 선택을 유지하세요. 해제하면 책에 사진이 들어가지 않습니다. 대화가 없으면 <b>2023년 이전</b>으로 전환하세요.',
	conversationMessengerImportClassicDetailTitle: '2023년 이전 내보내기: 자세한 안내',
	conversationMessengerImportClassicDetailIntro: '아래 스크린샷을 따라 하세요. 위 버튼으로 내보내기 페이지를 바로 열 수 있습니다.',
	conversationMessengerImportClassicDetailSkipApp: '위 버튼으로 페이지를 열었어요: 5단계부터 시작',
	conversationMessengerImportClassicDetailStep1: '<b>Messenger</b> 앱을 열고 점 세 개를 눌러 <b>설정</b>으로 들어가세요.',
	conversationMessengerImportClassicDetailStep2: '<b>톱니바퀴</b> 아이콘을 누르세요.',
	conversationMessengerImportClassicDetailStep3: '<b>계정 센터</b>를 선택하세요.',
	conversationMessengerImportClassicDetailStep4: '<b>내 정보 및 권한</b>을 누르세요.',
	conversationMessengerImportClassicDetailStep5: '<b>내 정보 다운로드</b>를 선택하세요.',
	conversationMessengerImportClassicDetailStep6: '<b>정보 다운로드 또는 전송</b>으로 들어가세요. 위 버튼을 사용하셨다면 이미 이 페이지에 계십니다.',
	conversationMessengerImportClassicDetailStep7: '<b>Facebook</b>을 선택하세요. 계정에 따라 이 단계가 나타나지 않을 수 있습니다.',
	conversationMessengerImportClassicDetailStep8: '<b>일부 정보</b>를 선택하세요.',
	conversationMessengerImportClassicDetailStep9: '<b>메시지</b>만 체크한 다음 <b>다음</b>을 누르세요.',
	conversationMessengerImportClassicDetailStep10: '<b>기기에 다운로드</b>를 누르세요.',
	conversationMessengerImportClassicDetailStep11: '원하시는 기간과 <b>JSON</b> 형식, <b>낮음</b> 품질을 선택하세요. 아카이브는 <b>10분에서 24시간</b> 안에 준비되며, 이메일로 알려 드립니다.',
	conversationMessengerImportClassicDetailStep12: '<b>.zip</b> 파일 전체를 기기에 다운로드한 다음 <b>압축을 풀지 말고</b> 아래에 올려 주세요. 이후에 선택하신 대화만 책에 사용됩니다.',
	conversationMessengerImportEncryptedDetailTitle: '2023년 이후 내보내기: 자세한 안내',
	conversationMessengerImportEncryptedDetailIntro: '아래 스크린샷을 보면서 각 단계를 따라 해 보세요. 위 버튼으로 Messenger.com을 열고 2단계로 넘어가셔도 됩니다.',
	conversationMessengerImportEncryptedDetailSkipApp: '이미 Messenger.com에 있어요: 2단계부터 시작',
	conversationMessengerImportEncryptedDetailStep1: '컴퓨터에서 <b>Messenger.com</b>에 접속한 다음 왼쪽 아래의 프로필 사진을 클릭하세요.',
	conversationMessengerImportEncryptedDetailStep2: '<b>개인정보 및 안전</b>을 클릭하세요.',
	conversationMessengerImportEncryptedDetailStep3: '<b>엔드 투 엔드 암호화 채팅</b>을 클릭하세요.',
	conversationMessengerImportEncryptedDetailStep4: '<b>보안 저장소</b>를 클릭하세요.',
	conversationMessengerImportEncryptedDetailStep5: '<b>보안 저장소에서 데이터 다운로드</b>를 클릭하세요.',
	conversationMessengerImportEncryptedDetailStep6: '<b>파일 다운로드</b>를 클릭하세요.',
	conversationMessengerImportEncryptedDetailStep7: 'Facebook 비밀번호를 입력한 다음 <b>확인</b>을 클릭하세요.',
	conversationMessengerImportEncryptedDetailStep8: '<b>다운로드</b>를 클릭하세요. 파일 준비에 몇 분 걸릴 수 있습니다.',
	conversationMessengerImportEncryptedDetailStep9: '<b>.zip</b> 파일 전체를 컴퓨터에 다운로드한 다음 <b>압축을 풀지 말고</b> 아래에 올려 주세요. 이후에 선택하신 대화만 책에 사용됩니다.',
	conversationMessengerImportMissingTip: '목록에 대화가 없나요? 돌아가서 <b>2023년 이후</b> 내보내기를 시도하세요.',
	conversationMessengerImportEmptyTitle: '이 아카이브에서 대화를 찾을 수 없습니다',
	conversationSmsImportTagline: '여기에 올리실 파일은 없어요. 모든 과정은 저희 프로그램이나 앱에서 진행돼요.',
	conversationSmsImportIntro: '이 페이지에서는 파일을 올리지 않아요. 모든 과정은 저희 프로그램(iPhone)이나 앱(Android)에서 진행돼요. 사용 환경을 선택하세요:',
	conversationSmsImportContext: '저희 Android 앱은 <b>Google Play에 없습니다</b>. Play 스토어에서는 SMS 접근이 제한됩니다. 앱을 열려면 Android와 Play Protect에서 한 번 확인해 주세요.',
	conversationSmsImportPlatformIphoneMac: 'iPhone + Mac',
	conversationSmsImportPlatformIphonePc: 'iPhone + PC',
	conversationSmsImportPlatformAndroid: 'Android',
	conversationSmsImportMacCta: 'Mac용 프로그램 다운로드',
	conversationSmsImportPcCta: 'PC용 프로그램 다운로드',
	conversationSmsImportAndroidCta: 'Android 앱 다운로드',
	conversationSmsImportMacStep1: 'Mac용 프로그램을 다운로드하세요.',
	conversationSmsImportMacStep2: '설치한 뒤 <b>안내를 따라 주세요</b>. 프로그램이 다음 단계를 알려 줍니다.',
	conversationSmsImportMacStep3: '계정으로 보낼 <b>대화</b>를 선택한 다음, 전송이 끝날 때까지 화면을 유지해 주세요.',
	conversationSmsImportMacStep4: '아래 프로그램을 설치하고 시스템 설정 → 개인정보 보호 및 보안에서 <b>전체 디스크 접근 권한</b>을 허용한 다음, 계정으로 보낼 대화를 선택하세요.',
	conversationSmsImportMacHelp: '프로그램이 백업을 찾지 못한다면: 시스템 설정 → 개인정보 보호 및 보안 → <b>전체 디스크 접근 권한</b>에서 MonLivreSMS를 추가하세요(왼쪽 아래 자물쇠를 먼저 풀어 주세요).',
	conversationSmsImportMacAlert: '여기에 파일을 올리지 않습니다. 전송은 프로그램에서 시작되며, 화면 안내에 따라 진행됩니다.',
	conversationSmsImportPcStep1: 'PC용 프로그램을 다운로드하세요.',
	conversationSmsImportPcHelp: 'iTunes에서 <b>로컬 백업 암호화</b>가 해제되어 있는지 확인한 다음 <b>지금 백업</b>을 클릭하세요. 위 이미지를 참고하세요.',
	conversationSmsImportHelpToggle: '더 자세한 도움이 필요하신가요?',
	conversationSmsImportPcStep2: '설치한 뒤 <b>안내를 따라 주세요</b>. 프로그램이 다음 단계를 알려 줍니다.',
	conversationSmsImportPcStep3: '계정으로 보낼 <b>대화</b>를 선택한 다음, 전송이 끝날 때까지 화면을 유지해 주세요.',
	conversationSmsImportPcStep4: '아래 프로그램을 설치하고 실행하세요(Windows에서 경고가 뜨면 실행을 허용해 주세요). 그런 다음 계정으로 보낼 대화를 선택하세요.',
	conversationSmsImportPcAlert: '여기에 파일을 올리지 않습니다. 전송은 프로그램에서 시작되며, 화면 안내에 따라 진행됩니다.',
	conversationSmsImportAndroidStep1: 'Android 휴대폰에서 아래의 <b>스토어 외부 앱</b>을 다운로드하세요. Google Play에서는 SMS 접근이 허용되지 않습니다.',
	conversationSmsImportAndroidStep2: '다운로드한 파일을 여세요. 설치가 허용되지 않으면 <b>설정</b>을 누르고 <b>이 출처의 앱 허용</b>을 켠 뒤 돌아오세요.',
	conversationSmsImportAndroidStep3: 'Play Protect가 나타나면 <b>자세한 내용</b>을 누른 다음 <b>무시하고 설치</b>를 누르세요. 이어서 <b>설치</b>를 누르고 <b>열기</b>를 누르세요.',
	conversationSmsImportAndroidStep4: '앱에서 <b>SMS</b>와 <b>연락처</b> 접근을 허용해 주세요.',
	conversationSmsImportAndroidStep5: '<b>대화</b>를 고르고 확인해 주세요. 전송이 끝날 때까지 화면을 그대로 두세요. 메시지는 계정으로 바로 전송됩니다.',
	conversationSmsImportAndroidAlert: '여기에 올리실 파일은 없어요. 모든 사진이 잘 전송되도록 앱의 전송 화면을 그대로 두세요.',
	conversationSmsImportFooter: '전송이 끝나면 이 사이트에서 책을 꾸며 보세요. 앱에서 자동으로 이동해 드립니다.',
	conversationSmsImportAndroidDetailIntro: 'Android 휴대폰에서 각 단계를 따라 주세요. 앱은 <b>Google Play에 없습니다</b>. 열기 전에 Android와 Play Protect가 확인을 요청합니다. 정상적인 과정입니다.',
	conversationSmsImportAndroidDetailSkipApp: '앱을 이미 다운로드했어요: 2단계부터 시작',
	conversationSmsImportAndroidDetailStep1: 'Google Play 외부에서 저희 SMS 추출 앱을 다운로드하세요(아래 버튼). Play 스토어에서는 SMS 접근이 허용되지 않습니다.',
	conversationSmsImportAndroidDetailStep2: '다운로드가 끝나면 <b>열기</b>를 누르세요.',
	conversationSmsImportAndroidDetailStep3: '설치를 허용하려면 <b>설정</b>을 누르세요.',
	conversationSmsImportAndroidDetailStep4: '<b>이 출처의 앱 허용</b>을 켠 뒤, 설치 화면으로 돌아가세요.',
	conversationSmsImportAndroidDetailStep5: 'Play Protect가 나타나면 <b>자세한 내용</b>을 누른 다음 <b>무시하고 설치</b>를 누르세요. 설치하고 앱을 연 다음, SMS와 연락처 접근을 허용해 주세요.',
	conversationSmsImportAndroidDetailStep6: '원하시는 <b>대화</b>를 선택하세요.',
	conversationSmsImportAndroidDetailStep7: '확인하고 진행하세요. 모든 사진이 잘 전송되도록 전송이 끝날 때까지 전송 화면을 유지해 주세요. 완료되면 책을 꾸미는 화면으로 자동 이동합니다.',
	conversationSmsImportAndroidDetailTitle: 'Android SMS 내보내기: 자세한 가이드',
	conversationSmsImportMacDetailIntro: '프로그램을 다운로드하고 화면 안내를 따라 주세요. 아래 스크린샷은 주로 설치에 도움이 됩니다.',
	conversationSmsImportMacDetailSkipSoftware: '프로그램을 이미 다운로드했어요: 8단계부터 시작',
	conversationSmsImportMacDetailStep1: 'USB 케이블로 iPhone을 Mac에 연결하세요.',
	conversationSmsImportMacDetailStep10: '<b>시스템 설정</b> → <b>개인정보 보호 및 보안</b>을 여세요.',
	conversationSmsImportMacDetailStep11: '페이지 맨 아래로 내려가 <b>그래도 열기</b>를 클릭하세요.',
	conversationSmsImportMacDetailStep12: '보안 경고창에서 <b>허용</b>을 클릭하세요.',
	conversationSmsImportMacDetailStep13: '<b>열기</b>를 클릭하세요.',
	conversationSmsImportMacDetailStep14: '<b>계속</b>을 클릭하세요.',
	conversationSmsImportMacDetailStep15: '<b>계속</b>을 한 번 더 클릭하세요.',
	conversationSmsImportMacDetailStep16: '<b>설치</b>를 클릭하세요.',
	conversationSmsImportMacDetailStep17: '보안 경고창에서 <b>허용</b>을 다시 클릭하세요.',
	conversationSmsImportMacDetailStep18: '<b>닫기</b>를 클릭해 설치 프로그램을 종료하세요.',
	conversationSmsImportMacDetailStep19: '<b>Finder</b> → <b>응용 프로그램</b>을 열고 <b>MonLivreSMS</b>를 실행하세요.',
	conversationSmsImportMacDetailStep2: '사진이 들어간 책을 원하신다면 <b>메시지</b> 앱을 열고 대화를 선택한 다음 <b>연락처 이름</b>을 누르세요.',
	conversationSmsImportMacDetailStep20: '왼쪽 위의 <b>Apple 메뉴</b>를 클릭한 다음 <b>시스템 설정</b>으로 들어가세요.',
	conversationSmsImportMacDetailStep21: '<b>개인정보 보호 및 보안</b> → <b>전체 디스크 접근 권한</b>을 여세요.',
	conversationSmsImportMacDetailStep22: 'MonLivreSMS 아이콘을 길게 눌러 목록으로 끌어다 놓은 다음 <b>전체 디스크 접근 권한</b>을 켜 주세요.',
	conversationSmsImportMacDetailStep23: '<b>열기</b>를 클릭해 확인하세요.',
	conversationSmsImportMacDetailStep24: '두 번째 확인창이 뜨면 <b>열기</b>를 다시 클릭하세요.',
	conversationSmsImportMacDetailStep25: '내보낼 <b>대화</b>를 선택하세요. 문자와 사진이 고객님의 계정으로 전송됩니다. 인터넷 연결이 안정된 상태에서 전송이 끝날 때까지 전송 화면을 유지해 주세요.',
	conversationSmsImportMacDetailStep3: '연락처 정보 화면 맨 아래까지 내려가세요.',
	conversationSmsImportMacDetailStep4: '<b>다운로드</b>를 눌러 iCloud 사진을 모두 iPhone으로 가져오세요.',
	conversationSmsImportMacDetailStep5: '<b>Finder</b>를 열고 사이드바에서 iPhone을 선택한 다음, <b>로컬 백업 암호화</b> 체크를 해제하고 <b>iPhone의 모든 데이터를 이 Mac에 백업</b>을 선택하세요.',
	conversationSmsImportMacDetailStep6: '<b>지금 백업</b>을 클릭하고 백업이 끝날 때까지 기다리세요.',
	conversationSmsImportMacDetailStep7: 'Mac용 MonLivreSMS 프로그램을 다운로드하세요(이 페이지 아래 버튼).',
	conversationSmsImportMacDetailStep8: '다운로드한 <b>MonLivreSMS</b> 폴더를 두 번 클릭하세요.',
	conversationSmsImportMacDetailStep9: '<b>확인</b>을 클릭해 설치를 시작하세요.',
	conversationSmsImportMacDetailTitle: 'iPhone + Mac SMS 내보내기: 자세한 가이드',
	conversationSmsImportPcDetailIntro: '프로그램을 다운로드하고 화면 안내를 따라 주세요. 아래 스크린샷은 주로 설치에 도움이 됩니다.',
	conversationSmsImportPcDetailSkipSoftware: '프로그램을 이미 다운로드했어요: 3단계부터 시작',
	conversationSmsImportPcDetailStep1: 'USB 케이블로 iPhone을 PC에 연결하세요.',
	conversationSmsImportPcDetailStep2: 'PC용 MonLivreSMS 프로그램을 다운로드하세요(이 페이지 아래 버튼).',
	conversationSmsImportPcDetailStep3: '아직 설치하지 않으셨다면 <link>iTunes</link>를 설치하세요.',
	conversationSmsImportPcDetailStep4: 'iTunes를 실행하세요.',
	conversationSmsImportPcDetailStep5: '<b>Apple 계정</b>으로 로그인하고, 요청이 뜨면 iPhone에서 확인해 주세요.',
	conversationSmsImportPcDetailStep6: 'iPhone이 인식되면 <b>계속</b>을 클릭하세요.',
	conversationSmsImportPcDetailStep7: '<b>요약</b>에서 <b>로컬 백업 암호화</b> 체크를 해제한 다음 <b>지금 백업</b>을 클릭하세요(iCloud가 아니라 이 컴퓨터에 저장).',
	conversationSmsImportPcDetailStep8: '백업이 끝나면 MonLivreSMS 폴더를 여세요. Windows에서 경고가 표시되면 <b>추가 정보</b>를 클릭한 다음 <b>실행</b>을 클릭하세요. 그런 다음 계정으로 보낼 대화를 선택하세요.',
	conversationSmsImportPcDetailTitle: 'iPhone + PC SMS 내보내기: 자세한 가이드',
	offerErrorRequired: '필수 항목을 입력해 주세요.',
	offerErrorEmail: '이메일 주소를 확인해 주세요.',
	offerErrorGiftEmail: '선물 받는 분의 이메일 주소를 확인해 주세요.',
	offerErrorGiftSameEmail: '선물 받는 분의 이메일은 본인 이메일과 달라야 합니다.',
	offerErrorGeneric: '죄송합니다. 문제가 발생했습니다. 잠시 후 다시 시도해 주세요.',
	offerStepWhoEyebrow: '시작해 볼까요',
	offerStepWhoTitle: '책은 누가 만들까요?',
	offerStepWhoHint: '직접 만듭니다. 나를 위해서도, 선물로도. 기프트 카드는 상대가 책을 만드는 경우입니다.',
	offerWhoSelf: '제가 만들게요',
	offerWhoSelfHint: '나를 위해, 또는 인쇄한 뒤 선물로',
	offerWhoGift: '기프트 카드를 드려요',
	offerWhoGiftHint: '상대가 링크를 받고 직접 책을 만들어요',
	offerStepOccasionEyebrow: '어떤 날',
	offerStepOccasionHint: '마음에 두고 있는 순간.',
	offerStepGiftEyebrow: '선물',
	offerStepGiftTitle: '누구에게 선물하시나요?',
	offerStepGiftHint: '책을 만들 수 있는 링크와 함께 선물을 이메일로 보내 드립니다. 인쇄도, 포장도 필요 없습니다.',
	offerGiftName: '받는 분 이름',
	offerGiftEmail: '받는 분 이메일',
	offerGiftEmailHelp: '결제 직후 이 이메일로 선물이 도착합니다.',
	offerGiftFromName: '보내는 분 이름',
	offerGiftFromNameHelp: '누가 보낸 선물인지 알 수 있도록 표시됩니다.',
	offerGiftMessage: '짧은 메시지 (선택)',
	offerGiftMessagePlaceholder: '이 메시지들이 언제나 네 곁에 있기를.',
	offerContinue: '계속하기',
	offerStepMessengerEyebrow: '메시지',
	offerStepMessengerTitleGift: '{name}님의 책이 될 메시지는 어디에 있나요?',
	offerStepMessengerTitle: '가장 소중한 메시지는 어디에 있나요?',
	offerStepMessengerHint: '하나를 선택해 주세요. 나중에 변경할 수 있습니다.',
	offerStepMessengerHintGift: '{name}님과 나눈 대화도, {name}님이 소중한 분과 나눈 대화도 좋습니다. 앱이 확실하지 않다면 {name}님이 나중에 다른 앱을 선택할 수 있습니다.',
	offerStepEmailEyebrow: '거의 다 됐어요',
	offerStepEmailTitle: '계정',
	offerStepEmailHintGift: 'Google, Apple 또는 이메일. 확인 메일을 보낸 뒤 기프트 카드를 결제합니다.',
	offerStepEmailHint: 'Google, Apple 또는 이메일. 확인 메일을 보낸 뒤 대화를 가져옵니다.',
	offerStepEmailHintPay: 'Google, Apple 또는 이메일. 확인 메일을 보낸 뒤 책을 결제합니다.',
	offerEmailLabel: '이메일 주소',
	offerEmailPlaceholder: 'name@example.com',
	offerEmailSubmit: '결제로 이동',
	offerEmailSubmitAccount: '계정 만들기',
	offerEmailPrivacy: '책 소식만 보내 드립니다. 스팸함도 확인해 주세요.',
	offerStepSentEyebrow: '다시 오신 것을 환영합니다',
	offerStepSentTitle: '이미 계정이 있습니다',
	offerStepSentCodeHint: '{email}(으)로 6자리 코드를 보내 드렸습니다. 여기에 입력해 주세요. 주문은 결제할 수 있는 상태로 기다리고 있습니다. 스팸함도 확인해 주세요.',
	offerStepSentCodeHintAccount: '{email}(으)로 6자리 코드를 보내 드렸습니다. 여기에 입력하면 계정이 열리고 책 만들기를 시작할 수 있습니다. 스팸함도 확인해 주세요.',
	offerStepPayEyebrow: '마지막 단계',
	offerStepPayTitleGift: '{name}님을 위한 책',
	offerStepPayTitle: '나만의 종이책',
	offerLoggedAs: '{email}(으)로 로그인됨',
	offerSwitchAccount: '본인이 아니신가요?',
	offerTrustReviews: 'Trustpilot 리뷰 {count}개 이상',
	offerTrustGuarantee: '환불 보장',
	offerTrustShipping: '무료 배송',
	offerPageTitle: '메시지로 만드는 나만의 책',
	offerBack: '뒤로',
	offerItemName: '직접 꾸미는 종이책',
	offerPayBenefitBook: '메시지와 사진으로 구성한 나만의 종이책',
	offerPayBenefitBookGift: '원하는 메시지와 사진으로 만드는 진짜 종이책',
	offerPayBenefitMedia: '영상과 음성 메시지도 책에 인쇄된 QR 코드로 다시 감상할 수 있습니다',
	offerPayBenefitCustom: '표지, 사진, 제목, 색상, 머리말까지 모두 맞춤 설정할 수 있습니다',
	offerPayBenefitPdf: '책과 함께 PDF를 무료로 드립니다',
	offerPayBenefitShipping: '무료 배송',
	offerPayTotal: '합계',
	offerPayNextGift: '결제가 완료되면 선물 이메일이 {name}님께 바로 발송됩니다.',
	offerPayNextSelf: '결제 직후 대화를 가져옵니다. 몇 분이면 됩니다.',
	offerPayDreamSelf: '휴대폰으로 몇 번이고 다시 읽던 그 메시지들, 이제 곧 손안에. 영원히.',
	offerPayDreamGift: '{name}님이 이 책을 펼치는 날, 그 모든 메시지가 손끝에서 다시 살아납니다.',
	offerPayButton: '{price} 결제하기',
	offerPaySecure: '안전한 결제. 정기 결제가 아닙니다.',
	offerConfirmStepsTitle: '이용 방법',
	offerConfirmGiftStep1: '{name}님이 이메일을 열고 링크를 클릭합니다',
	offerConfirmGiftStep2: '{name}님이 몇 분 만에 대화를 가져옵니다',
	offerConfirmGiftStep3: '저희가 책을 인쇄해 배송해 드립니다',
	offerConfirmGiftTitle: '{name}님께 선물을 보냈습니다!',
	offerConfirmGiftLead: '{name}님({email})께 책을 만들 수 있는 링크와 함께 선물이 도착했습니다. 배송비를 포함해 이미 결제가 완료되었습니다.',
	offerConfirmViewOrder: '주문 내역 보기',
	offerConfirmGiftNote: '이메일이 도착하지 않았다면 스팸함을 확인해 달라고 전해 주시거나 저희에게 문의해 주세요.',
	offerConfirmStep1: '{messenger}에서 대화를 내보내세요',
	offerConfirmStep1Generic: '메신저 앱에서 대화를 내보내세요',
	offerConfirmStep2: '여기로 가져오기만 하면 편집은 저희가 모두 맡습니다',
	offerConfirmStep3: '책을 확정하시면 인쇄해서 보내 드립니다',
	offerConfirmTitle: '결제가 완료되었습니다!',
	offerConfirmLead: '이제 {messenger} 대화를 가져오기만 하면 됩니다. 단계별로 안내해 드리며, 몇 분이면 끝납니다.',
	offerConfirmLeadGeneric: '이제 대화를 가져오기만 하면 됩니다. 단계별로 안내해 드리며, 몇 분이면 끝납니다.',
	offerConfirmCta: '{messenger} 대화 가져오기',
	offerConfirmCtaGeneric: '대화 가져오기',
	offerConfirmChangeMessenger: '메시지가 다른 앱에 있습니다',
	offerConfirmEmailNote: '영수증과 로그인 링크를 {email}(으)로 보내 드렸습니다.',
	userMagicTitle: '로그인',
	userMagicWorking: '로그인 중입니다…',
	userMagicExpired: '링크가 만료되었습니다. 클릭 한 번으로 새 링크를 받아 보세요.',
	userMagicInvalid: '더 이상 유효하지 않은 링크입니다. 클릭 한 번으로 새 링크를 받아 보세요.',
	userMagicSent: '이 주소로 가입된 계정이 있다면 새 링크가 발송됩니다. 스팸함도 확인해 주세요.',
	userMagicEmailLabel: '이메일 주소',
	userMagicSend: '새 링크 받기',
	conversationPreviewBookCreditRemaining: '+{price}',
	conversationPreviewIncluded: '결제 완료',
	conversationPreviewCollectionPrepaidNote: '{count}권 · {paid}권 결제 완료',
	conversationPreviewBookCreditBannerBestof: '책값은 이미 결제되었습니다. Best Of는 추가 비용 없이 만들 수 있습니다. 전권 컬렉션을 원하시면 차액만 결제하시면 됩니다.',
	conversationPreviewBookCreditBanner: '책값은 일반 배송비를 포함해 이미 결제되었습니다. 원하는 대로 꾸민 뒤 주문을 완료해 주세요.',
	conversationOrderButtonBookCreditRemaining: '책 완성하기 · 남은 금액 {price}',
	conversationOrderButtonBookCreditIncluded: '책 완성하기 · 결제 완료',
	conversationPreviewBookCreditOrderHint: '{credit} 결제 완료 · 정가 {fullPrice}',
	conversationOrderButtonBookCredit: '책 완성하기',
	conversationPreviewStickyBookCredit: '책값 결제 완료',
	paymentMethodBookCreditHint: '책값이 이미 결제되었습니다',
	cartTotalsBookCredit: '책값 (결제 완료)',
	paymentMethodBookcredit: '선결제한 책',
  },
};
